{
    "account": {
        "addSalesAccount": "+ Verkoopaccount",
        "create": {
            "additional": {
                "cocNumber": "KvK nummer",
                "subtitle": "Deze gegevens vullen we ook vast in op je factuurtemplate",
                "title": "Aanvullende bedrijfsgegevens",
                "vatNumber": "BTW nummer"
            },
            "cancel": "Annuleren",
            "company": {
                "address": "Adres *",
                "city": "Stad *",
                "companyName": "Bedrijfsnaam *",
                "email": "E-mailadres * (ontvangst van klanten mails)",
                "phone": "Telefoonnummer *",
                "subtitle": "Deze gegevens vullen we ook alvast in op je factuurtemplate",
                "title": "Bedrijfsgegevens",
                "zipCode": "Postcode *"
            },
            "contentSub": "We zullen deze informatie gebruiken om je beter van dienst te kunnen zijn",
            "contentTitle": "Laten we je account klaarmaken voor gebruik",
            "errors": {
                "address": "Vul je adres in",
                "city": "Vul je stad in",
                "companyAddress": "Vul het adres in",
                "companyCity": "Vul de stad in",
                "companyEmail": "Vul het e-mailadres in",
                "companyName": "Vul de bedrijfsnaam in",
                "companyPhone": "Vul het telefoonnummer in",
                "companyZipCode": "Vul de postcode in",
                "email": "Vul je e-mailadres in",
                "emailInvalid": "Vul een geldig e-mailadres in",
                "firstname": "Vul je voornaam in",
                "invalidImage": "Alleen PNG, JPG en JPEG afbeeldingen zijn toegestaan.",
                "invoicePrefix": "Vul de voortekens in",
                "invoiceStart": "Vul het startgetal in",
                "lastname": "Vul je achternaam in",
                "phone": "Vul je telefoonnummer in",
                "referralRequired": "Dit veld is verplicht",
                "setupFailed": "Het instellen van je account is niet gelukt.",
                "setupFailedTitle": "Instellen mislukt",
                "subscriptionCheck": "Het is niet gelukt om te controleren of je een actief abonnement hebt.",
                "zipCode": "Vul je postcode in"
            },
            "finished": {
                "subtitle": "Je account is ingesteld en is klaar voor gebruik.",
                "title": "Account ingesteld"
            },
            "invoice": {
                "dropMessage": "Sleep hier je logo of klik hier om te zoeken",
                "prefix": "Voortekens *",
                "preview": "Voorbeeld:",
                "start": "Beginnen bij *",
                "subtitle": "Deze zetten we op de facturen",
                "supported": "Ondersteunde bestanden: PNG, JPG en JPEG",
                "title": "Bedrijfslogo en factuurnummer"
            },
            "personal": {
                "address": "Adres *",
                "city": "Stad *",
                "email": "E-mailadres * (om mee in te loggen)",
                "firstname": "Voornaam *",
                "firstnamePlaceholder": "Je voornaam",
                "lastname": "Achternaam *",
                "phone": "Telefoonnummer *",
                "subtitle": "Zo houden we contact met elkaar",
                "title": "Persoonlijke gegevens",
                "zipCode": "Postcode *"
            },
            "referral": {
                "bol": "Via Bol",
                "chooseOption": "Kies een optie",
                "existingCustomer": "Via Via",
                "google": "Via Google",
                "googlePlaceholder": "Gezocht op zoekwoord...",
                "other": "Anders, namelijk...",
                "otherPlaceholder": "Gevonden via...",
                "social": "Via Socials (Facebook groepen, X, Instagram, etc.)",
                "subtitle": "We zijn erg benieuwd naar hoe je ons gevonden hebt.",
                "title": "Hoe heb je ons gevonden?"
            },
            "step": {
                "back": "Terug",
                "next": "Volgende",
                "skip": "Overslaan"
            },
            "welcome": {
                "start": "Nu beginnen",
                "text1": "Je account is succesvol aangemaakt.",
                "text2": "Laten we het aanpassen naar jouw wens.",
                "title": "Hi {{name}}, welkom bij Bluemate!"
            }
        },
        "otherAccounts": "Andere accounts",
        "ownAccounts": "Eigen accounts",
        "salesAccount": "Verkoopaccount:"
    },
    "accountSelect": {
        "back": "Terug",
        "fetchFrom": "Ophalen uit:",
        "import": "Importeren"
    },
    "admin": {
        "account": {
            "back": "Terug",
            "cancel": "Annuleren",
            "close": "Sluiten",
            "confirmTitle": "Bevestig",
            "delete": "Verwijderen",
            "deleteConfirmMsg": "Weet je zeker dat je dit account wilt verwijderen?",
            "deleteFailedMsg": "Het verwijderen van het account is niet gelukt.",
            "deleteFailedTitle": "Verwijderen mislukt",
            "deletedSnack": "Het account is verwijderd",
            "edit": "Wijzigen",
            "field": {
                "address": "Adres",
                "autoSend": "Automatisch mailen",
                "city": "Stad",
                "cocNumber": "KvK-nummer",
                "companyName": "Bedrijfsnaam",
                "country": "Land",
                "email": "E-mailadres",
                "iban": "IBAN",
                "invoicePrefix": "Factuurnummer",
                "invoiceStart": "Factuurnummer start",
                "participateKor": "Deelnemer KOR",
                "telNumber": "Telefoonnummer",
                "useBolText": "Gebruik Bol tekst",
                "usePlatformText": "Gebruik Bluemate tekst",
                "vatNumber": "BTW-nummer",
                "zipCode": "Postcode"
            },
            "no": "Nee",
            "off": "Uit",
            "on": "Aan",
            "save": "Opslaan",
            "section": {
                "account": "Account",
                "settings": "Instellingen"
            },
            "title": "Account details",
            "updateFailedMsg": "Het bijwerken van het account is niet gelukt.",
            "updateFailedTitle": "Bijwerken mislukt",
            "updatedSnack": "Het account is bijgewerkt",
            "validation": {
                "address": "Het adres mag niet leeg zijn",
                "city": "De stad mag niet leeg zijn",
                "coc": "Het KvK-nummer mag niet leeg zijn",
                "companyName": "De bedrijfsnaam mag niet leeg zijn",
                "country": "Het land mag niet leeg zijn",
                "emailEmpty": "Het e-mailadres mag niet leeg zijn",
                "emailInvalid": "Het e-mailadres is niet geldig",
                "telNumber": "Het telefoonnummer mag niet leeg zijn",
                "zipCode": "De postcode mag niet leeg zijn"
            },
            "yes": "Ja"
        },
        "adminProcess": {
            "col": {
                "account": "ACCOUNT",
                "companyName": "BEDRIJFSNAAM",
                "email": "E-MAILADRES",
                "id": "ID",
                "name": "NAAM",
                "startedAt": "GESTART OP",
                "status": "STATUS",
                "subscription": "ABONNEMENT"
            },
            "deleteFailedMsg": "Het verwijderen van het proces is niet gelukt.",
            "deletedSnack": "Het proces is verwijderd",
            "filter": "Filter",
            "imports": "Imports",
            "linkedAccounts": "Gekoppelde accounts",
            "loadAccountsFailedMsg": "Het laden van de accounts is niet gelukt.",
            "loadAccountsFailedTitle": "Account niet gevonden",
            "loadUsersFailedMsg": "Het laden van de gebruikers is niet gelukt.",
            "loadUsersFailedTitle": "Laden mislukt",
            "noProcesses": "Er zijn geen processen gevonden",
            "search": "Zoeken",
            "selectUser": "Selecteer een gebruiker",
            "users": "Gebruikers"
        },
        "bar": {
            "id": "ID",
            "name": "Naam",
            "selectedAccount": "Geselecteerd account",
            "selectedUser": "Geselecteerde gebruiker"
        },
        "churn": {
            "calculate": "Berekenen",
            "close": "Sluiten",
            "col": {
                "active": "ACTIEF",
                "canceled": "OPGEZEGD",
                "expired": "VERLOPEN",
                "free": "GRATIS",
                "inactive": "INACTIEF",
                "period": "PERIODE",
                "registered": "GEREGISTREERD",
                "trialing": "PROEFPERIODE"
            },
            "datePlaceholder": "dd-mm-jjjj",
            "display": "Weergave",
            "fromDate": "Vanaf datum",
            "loadFailedMsg": "Het bepalen van de churn is niet gelukt.",
            "loadFailedTitle": "Churn bepalen mislukt",
            "split": {
                "day": "Per dag",
                "hour": "Per uur",
                "month": "Per maand",
                "quarter": "Per kwartaal",
                "week": "Per week",
                "year": "Per jaar"
            },
            "title": "Abonnementen verloop",
            "toDate": "T/m datum"
        },
        "connections": {
            "confirmTitle": "Bevestig",
            "disable": "uitschakelen",
            "disabled": "uitgeschakeld",
            "enable": "inschakelen",
            "enabled": "ingeschakeld",
            "lastChanged": "Laatst gewijzigd",
            "maintenance": "Onderhoud",
            "maintenanceModeIs": "Onderhoud modus is",
            "na": "n.v.t.",
            "no": "Nee",
            "pageReloading": "de pagina wordt opnieuw geladen",
            "status": {
                "down": "Down",
                "unstable": "Instabiel",
                "up": "Up"
            },
            "title": "Verbindingen",
            "toggleConfirmPrefix": "Weet je zeker dat je de onderhoudsmodus wilt",
            "toggleFailedMsg": "Het wijzigen van de onderhoudsmodus is niet gelukt.",
            "yes": "Ja"
        },
        "copiedToClipboardSuffix": "gekopieerd",
        "defaultEmails": {
            "disabled": "Uitgeschakeld",
            "editor": {
                "changesSavedSnack": "De wijzigingen zijn opgeslagen",
                "deleteConfirmMsg": "Weet je zeker dat je deze e-mail template volledig wilt verwijderen?",
                "deleteConfirmTitle": "Template verwijderen",
                "deleteFailedMsg": "Het verwijderen van de template is niet gelukt.",
                "deleteFailedTitle": "Verwijderen mislukt",
                "deleteTemplate": "Template verwijderen",
                "deletedSnack": "De template is verwijderd",
                "disabled": "Uitgeschakeld",
                "enabled": "Ingeschakeld",
                "errorTitle": "Fout",
                "flow": {
                    "creditInvoice": "Creditfactuur",
                    "invoice": "Factuur",
                    "reviewInvoice": "Review + Factuur"
                },
                "flows": "Flows",
                "hide": "Verbergen",
                "loadFailedTitle": "Laden mislukt",
                "nameLabel": "Template naam",
                "namePlaceholder": "Naam van de template",
                "no": "Nee",
                "notFoundMsg": "De template kan niet gevonden worden.",
                "previewOptions": "Preview opties",
                "save": "Opslaan",
                "saveChangesFailedMsg": "Het opslaan van de wijzigingen is niet gelukt.",
                "saveFailedMsg": "Het opslaan van de template is niet gelukt.",
                "saveFailedTitle": "Opslaan mislukt",
                "savedSnack": "De template is opgeslagen",
                "sendTest": "Test verzenden",
                "statusLabel": "Status",
                "subjectLabel": "Onderwerp van mail",
                "subjectPlaceholder": "Standaard onderwerp van de e-mail",
                "testFailedMsg": "Het verzenden van de testmail is niet gelukt.",
                "testFailedTitle": "Verzending mislukt",
                "testSentTo": "De test mail is verzonden naar",
                "validation": {
                    "content": "De template heeft geen inhoud.",
                    "flow": "Selecteer minimaal één flow.",
                    "name": "Geef de template een naam.",
                    "preview": "Je kunt de template niet activeren zonder preview.",
                    "subject": "Vul het onderwerp in."
                },
                "yes": "Ja"
            },
            "empty": "Geen e-mailtemplates gevonden",
            "enabled": "Ingeschakeld",
            "flow": {
                "creditInvoice": "Creditfactuur",
                "invoice": "Factuur",
                "reviewInvoice": "Review + Factuur"
            },
            "flowLabel": "Flow",
            "loadFailedMsg": "Het laden is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "newTemplate": "+ Nieuwe template maken",
            "pagingOf": "van",
            "pagingTo": "t/m",
            "previewAlt": "Template preview",
            "searchLabel": "Zoek een e-mail",
            "searchPlaceholder": "Naam van e-mail",
            "status": "Status"
        },
        "emailSequence": {
            "after": "Na",
            "datePlaceholder": "dd-mm-jjjj",
            "determiningCount": "Aantal facturen bepalen...",
            "for": "voor",
            "genericError": "Er is iets fout gegaan.",
            "in": "in",
            "invoice": "factuur",
            "invoices": "facturen",
            "mailWithAttachment": "mail met bijlage",
            "noTemplate": "Geen template",
            "ordersFrom": "Orders vanaf",
            "ordersTo": "Orders tot",
            "selectEmails": "Selecteer welke e-mails verzonden moeten worden",
            "selected": "geselecteerd",
            "send": "stuur",
            "settings": "Instellingen",
            "start": "Start",
            "startedSnack": "De verwerking is gestart",
            "to": "naar",
            "via": "via"
        },
        "failedPayments": {
            "col": {
                "amountExcl": "BEDRAG EXCL.",
                "dateFailed": "DATUM MISLUKT",
                "status": "STATUS",
                "stripeCustomerId": "STRIPE KLANT ID",
                "user": "GEBRUIKER",
                "userId": "GEBRUIKER ID"
            },
            "copiedToClipboard": "gekopieerd",
            "copyPaymentLink": "Betaallink kopiëren",
            "delete": "Verwijderen",
            "deleteFailedMsg": "Het verwijderen van de betaling is niet gelukt.",
            "deleteFailedTitle": "Verwijderen mislukt",
            "deletedSnack": "De betaling is verwijderd",
            "emptyLabel": "- Geen betalingen gevonden -",
            "generateFailedMsg": "Het genereren van de factuur is niet gelukt.",
            "generateFailedTitle": "Factuur genereren mislukt",
            "generateNoSend": "Nieuwe factuur aanmaken (niet verzenden)",
            "generatedSentSnack": "De factuur is gegeneerd en verzonden",
            "hasOpenInvoices": "Heeft al openstaande facturen",
            "invoicePaid": "Factuur betaald",
            "loadFailedMsg": "Het laden van de mislukte betalingen is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "pagingOf": "van",
            "pagingTo": "t/m",
            "search": "Zoeken",
            "searchPlaceholder": "Zoek een betaling",
            "sendFailedMsg": "Het verzenden van de factuur is niet gelukt.",
            "sendFailedTitle": "Factuur verzenden mislukt",
            "sendInvoice": "Factuur verzenden",
            "sendNew": "Nieuwe factuur verzenden",
            "sentSnack": "De factuur is verzonden",
            "status": {
                "closed": "Factuur betaald",
                "generated": "Factuur aangemaakt",
                "new": "Nieuw",
                "sent": "Factuur verzonden"
            },
            "title": "Mislukte betalingen"
        },
        "historyImport": {
            "datePlaceholder": "dd-mm-jjjj",
            "firstPage": "Eerste API page",
            "genericError": "Er is iets fout gegaan.",
            "orderFrom": "(Optioneel) Order importeren vanaf",
            "prefix": "Voorvoegsel factuurnummer",
            "sendEmails": "E-mails verzenden",
            "settings": "Instellingen",
            "start": "Start",
            "startNumber": "Start factuurnummer",
            "startedSnack": "De import is gestart"
        },
        "platformUsage": {
            "accountsAdditional": "Met extra gebruikers",
            "actions": "Acties",
            "active": "Betalende eigenaren",
            "additionalUsers": "Extra gebruikers",
            "adminImpersonation": "Admin-impersonatie",
            "admins": "Admins",
            "afterTrialPaying": "Na trial (betalend)",
            "aggregate": "Aggregeer",
            "aggregatedWith": "Data wordt geaggregeerd met",
            "aggregationDelay": "Aggregation delay (min 1 minuut)",
            "aggregationDonePrefix": "Aggregatie voltooid",
            "aggregationFailed": "Aggregatie is mislukt.",
            "all": "Alle",
            "allOf": "Alle",
            "analyticsSettings": "Analytics Instellingen",
            "autoMailOff": "Automatisch mailen uit",
            "autoMailOn": "Automatisch mailen aan",
            "back": "Terug",
            "breakdown": {
                "featureGroup": "Feature groep",
                "featureKey": "Feature"
            },
            "bucket": {
                "auto": "Auto",
                "day": "Dag",
                "month": "Maand",
                "week": "Week"
            },
            "cancel": "Annuleren",
            "chart": {
                "platformActivity": "Platform activiteit over tijd",
                "totalUsers": "Totaal gebruikers op platform"
            },
            "clearAllData": "Alle data wissen",
            "clearData": "Data wissen",
            "clearDataFailed": "Het verwijderen van analytics data is mislukt.",
            "clearFilter": "Wis filter",
            "clearModalTitle": "Analytics data wissen",
            "clearWarn1": "Deze actie verwijdert",
            "clearWarn2": "analytics records permanent. Dit omvat:",
            "clickToAggregate": "Klik op de knop hieronder om verzamelde events te aggregeren.",
            "confirmLabel": "Ik bevestig dat alle analytics data permanent verwijderd moet worden en begrijp dat dit niet teruggedraaid kan worden",
            "crumb": {
                "admin": "Admin",
                "platformUsage": "Platformgebruik"
            },
            "dailyAggregates": "dagelijkse aggregaten",
            "dailyAggregatesRetention": "Dagelijkse aggregaten retentie (0 = onbeperkt)",
            "dataCleared": "Alle analytics data is verwijderd.",
            "dataCollection": "Dataverzameling",
            "days": "dagen",
            "detail": "Detail",
            "drillDown": "Drill-down",
            "emailSettingsTitle": "E-mail instellingen",
            "event": {
                "actionFailed": "Acties (gefaald)",
                "actionSuccess": "Acties (succes)",
                "pageView": "Page views"
            },
            "eventType": "Event type",
            "events": "Events",
            "eventsAutoCollected": "Analytics events worden automatisch verzameld zodra gebruikers de platform gebruiken.",
            "eventsNotStored": "Analytics events worden NIET opgeslagen",
            "eventsProcessed": "events verwerkt.",
            "eventsStored": "Analytics events worden opgeslagen",
            "eventsWord": "events",
            "featureActivity": "Feature activiteit",
            "features": "features",
            "fetchError": "Er is een fout opgetreden bij het ophalen van de statistieken.",
            "fetchFailed": "Het ophalen van de statistieken is niet gelukt.",
            "filters": "Filters",
            "from": "Van",
            "groupBy": "Groeperen op",
            "groups": "groepen",
            "inTrial": "In trial",
            "invalidRangeMsg1a": "De \"Van\" datum",
            "invalidRangeMsg1b": "is later dan de \"Tot\" datum",
            "invalidRangeMsg2": "Pas de datums aan zodat \"Van\" eerder is dan of gelijk aan \"Tot\".",
            "invalidRangeTitle": "Ongeldige datumbereik",
            "invoiceOnly": "Alleen factuur e-mail",
            "invoiceReview": "Factuur + review verzoek",
            "max31Days": "(max 31 dagen)",
            "metric": {
                "totalEvents": "Totaal events",
                "uniqueUsers": "Unieke gebruikers"
            },
            "metricLabel": "Metriek",
            "minutes": "minuten",
            "minutesDelay": "minuten vertraging",
            "noAnalyticsData": "Geen analytics data beschikbaar.",
            "noDataPeriod": "Geen data beschikbaar voor de geselecteerde periode.",
            "noDataToClear": "Er is geen data om te wissen",
            "noDrillDownData": "Geen drill-down data beschikbaar.",
            "noFilterResults": "De huidige filterinstellingen geven geen resultaten voor Feature activiteit.",
            "noFilterResultsExplanation": "Mogelijk is de verzamelde data voor andere gebruikertypes dan geselecteerd in de sectie \"Gebruikertype\", of er zijn geen events in de geselecteerde periode.",
            "noGrowthData": "Geen gebruikersgroei data beschikbaar voor de geselecteerde periode.",
            "noReplyOff": "No-reply tracking uit",
            "noReplyOn": "No-reply tracking aan",
            "notificationsByType": "Notificaties (per type)",
            "notificationsModule": "Notificaties module (abonnement)",
            "orderFree": "Order (gratis)",
            "pageTitle": "Platformgebruik",
            "pageViews": "Page views",
            "pending": "wachtend",
            "pendingReadyIn": "wachtend (gereed over",
            "period": "Periode",
            "rawEvents": "ruwe events",
            "rawRetention": "Ruwe events retentie (max",
            "readyForAggregation": "klaar voor aggregatie",
            "records": "records",
            "refresh": "Vernieuwen",
            "regularUsers": "Reguliere gebruikers",
            "resetFilters": "Filters resetten",
            "retention": "Data Retentie & Aggregation",
            "runAggregation": "Aggregatie uitvoeren",
            "saveSettings": "Instellingen opslaan",
            "searchPlaceholder": "E-mail, naam, telefoon...",
            "searchUser": "Gebruiker zoeken",
            "settingsConflict": "De instellingen zijn ondertussen door een andere beheerder gewijzigd.",
            "settingsSaveFailed": "Het opslaan van de instellingen is mislukt.",
            "settingsSaved": "Instellingen opgeslagen.",
            "tbl": {
                "actionsTotal": "Acties (totaal)",
                "actionsUnique": "Acties (uniek)",
                "conversion": "Conversie %",
                "group": "Groep",
                "name": "Naam",
                "viewsTotal": "Views (totaal)",
                "viewsUnique": "Views (uniek)"
            },
            "timeout": "Het verzoek duurde te lang. Probeer het opnieuw.",
            "to": "Tot",
            "topN": {
                "all": "Alles"
            },
            "topNLabel": "Top N",
            "topWord": "Top",
            "totalActive": "Totaal actief",
            "totalAdditional": "Totaal extra gebruikers",
            "totalUsersSeriesName": "Totaal gebruikers",
            "tryOtherPeriod": "Probeer een andere periode, andere gebruikertypes te selecteren of reset de filters.",
            "usageAnalytics": "Usage Analytics",
            "userDayRecords": "gebruiker-dag records",
            "userDayRetention": "Gebruiker-dag retentie (max",
            "userGrowth": "Gebruikersgroei",
            "userType": "Gebruikertype",
            "wait": "Wacht",
            "warning": "Let op",
            "additionalTooltipAccountsDesc": "Links: accounts met meer dan één gebruiker. Rechts: unieke betalende eigenaren met minstens één extra gebruiker in hun eigen winkels.",
            "additionalTooltipIntro": "Extra gebruikers bij alle accounts en bij betalende eigenaren.",
            "additionalTooltipTotalDesc": "Links: som van extra gebruikers per account. Rechts: unieke extra personen in winkels van betalende eigenaren, exclusief eigenaren in die winkel. Dezelfde persoon telt eenmaal, ook bij meerdere winkels. Dit aantal kan hoger zijn dan het aantal betalende eigenaren.",
            "aggregationDelayLabel": "Aggregation delay",
            "aggregationTooltipCooldownDesc": "Na het uitvoeren moet u {{minutes}} minuten wachten voordat u opnieuw kunt aggregeren. Dit geldt voor alle beheerders.",
            "aggregationTooltipDelayDesc": "Events moeten minimaal {{delay}} minuten oud zijn voordat ze kunnen worden geaggregeerd (om race conditions te voorkomen).",
            "aggregationTooltipDelayLabel": "Vertraging",
            "aggregationTooltipDesc": "Deze knop voert direct de data-aggregatie uit, zonder te wachten op de automatische verwerking (elke {{delay}} minuten).",
            "aggregationTooltipTitle": "Handmatige aggregatie",
            "chartTooltipActivityLabel": "Platform activiteit",
            "chartTooltipActivityTotal": "Toont totaal aantal events in de geselecteerde periode.",
            "chartTooltipActivityUnique": "Toont unieke gebruikers die features hebben gebruikt in de geselecteerde periode.",
            "chartTooltipIntro": "Deze grafieken tonen het gebruik van features op basis van de geselecteerde filters.",
            "chartTooltipTopFeatures": "Toont de meest populaire features.",
            "chartTooltipTopGroups": "Toont de meest populaire feature groepen.",
            "chartTooltipTopLabel": "Top groepen/features",
            "clearWarnIrreversible": "Deze actie kan niet ongedaan worden gemaakt. Alle historische analytics data gaat verloren.",
            "columnActiveDesc": "Unieke eigenaren met abonnementsstatus active, past_due of unpaid, net als Actief bij Gebruikers; exclusief het demo-account. Zonder eigen winkel telt een gebruiker bij uit. Een eigenaar telt eenmaal per categorie als minstens één eigen winkel voldoet. Uit betekent: in geen enkele eigen winkel ingeschakeld. Factuurcategorieën worden per winkel bepaald; een eigenaar kan in beide categorieën voorkomen.",
            "columnAllDesc": "Alle accounts.",
            "deliveryRate1h": "Bevestigingspercentage (afgelopen uur)",
            "deliveryRate24h": "Bevestigingspercentage (vandaag)",
            "deliveryRate7d": "Bevestigingspercentage (deze week)",
            "emailTooltipAutoDesc": "Of automatische e-mailverzending is ingeschakeld (minstens één actieve e-mail flow).",
            "emailTooltipAutoLabel": "Automatisch mailen aan/uit",
            "emailTooltipIntro": "Overzicht van e-mailinstellingen per account.",
            "emailTooltipInvoiceDesc": "Accounts die alleen factuur e-mails versturen.",
            "emailTooltipReviewDesc": "Accounts die zowel factuur als review e-mails versturen.",
            "emailTooltipTrackingDesc": "Of no-reply tracking (met leesbevestigingen) is ingeschakeld.",
            "emailTooltipTrackingLabel": "No-reply tracking",
            "eventTooltipFailed": "Mislukte acties (bijv. validatiefouten).",
            "eventTooltipPageView": "Paginabezoeken — wanneer een gebruiker een pagina opent.",
            "eventTooltipSuccess": "Succesvolle acties zoals opslaan, exporteren, versturen.",
            "groupByTooltipFeature": "Toont individuele functies (bijv. settings.api, invoices.list).",
            "groupByTooltipGroup": "Groepeert per categorie (bijv. Settings, Invoices, Emails).",
            "growthTooltip1": "Dit is het cumulatieve totaal van geregistreerde gebruikers op het platform.",
            "growthTooltip2": "Deze grafiek toont het totale aantal accounts, niet hoeveel gebruikers een specifieke feature hebben gebruikt (zoals in \"Feature activiteit\" hierboven).",
            "growthTooltip3": "Alleen de filters Van-Tot en Periode zijn van toepassing op deze grafiek.",
            "metricTooltipTotal": "Telt elk paginabezoek afzonderlijk.",
            "metricTooltipUnique": "Telt hoeveel verschillende personen de pagina hebben bezocht.",
            "other": "Overig",
            "notifModuleAfterTrialDesc": "Abonnementen die betalen voor notificaties (na trial periode).",
            "notifModuleInTrialDesc": "Abonnementen die de notificatiemodule in trial hebben.",
            "notifModuleTooltipIntro": "Status van de betaalde notificatiemodule per abonnement.",
            "notifModuleTotalDesc": "Totaal aantal actieve notificatiemodules (betalend + trial + gratis, exclusief geannuleerd).",
            "notifTypeBuyBox": "Notificaties over Buy Box wijzigingen.",
            "notifTypeOrder": "Gratis ordernotificaties.",
            "notifTypeReviews": "Notificaties over nieuwe reviews.",
            "notifTypeStock": "Notificaties over voorraadwijzigingen.",
            "notifTypeTooltipIntro": "Aantal accounts met actieve notificaties per type.",
            "periodTooltipAuto": "Kiest automatisch de beste periode op basis van het datumbereik.",
            "periodTooltipDay": "Toont data per dag (alleen beschikbaar bij een bereik van maximaal 31 dagen).",
            "periodTooltipMonth": "Groepeert data per maand.",
            "periodTooltipWeek": "Groepeert data per week.",
            "pushActiveDevices": "Actieve apparaten",
            "pushActiveDevicesInfo": "Aantal unieke apparaten met een actief web push abonnement dat recent is gezien (binnen de ingestelde bewaarperiode). Dubbele abonnementen van hetzelfde apparaat tellen als één.",
            "pushCounterRetention": "Delivery statistieken retentie (max 365 dagen)",
            "pushCounters": "push delivery statistieken",
            "pushDeliveryInfo1": "Overzicht van web push bezorgstatistieken.",
            "pushDeliveryNote": "De werkelijke bezorging ligt hoger dan het bevestigingspercentage: bevestigingen vereisen een actieve sessie (cookie) en dubbele bevestigingen van dezelfde push tellen niet mee.",
            "pushDeliveryOfflineNote": "Offline apparaten: wanneer een apparaat offline is, wordt het pushbericht tot 24 uur bewaard door de push-service. De bevestiging wordt pas geteld wanneer het apparaat weer online komt. Hierdoor kan het percentage bij \"afgelopen uur\" tijdelijk lager lijken. De periodes \"vandaag\" en \"deze week\" geven een nauwkeuriger beeld doordat ze een breder tijdvenster beslaan.",
            "pushDeliveryRate": "Bevestigingspercentage",
            "pushDeliveryRateInfo": "Percentage van verzonden pushes dat door de service worker als ontvangen is bevestigd. Naast het percentage staat het aantal (bevestigd/verzonden).",
            "pushDeliverySettings": "Web Push Opschonen",
            "pushDeliveryTitle": "Web Push Bezorging",
            "pushDeliveryTooltipTitle": "Web Push Bezorging",
            "pushInactiveDevices": "Inactieve apparaten",
            "pwaInstallInfo": "Overzicht van unieke push-apparaten per platform (dubbele abonnementen van hetzelfde apparaat tellen als één; alleen recent geziene abonnementen tellen als actief). Dit geeft een indicatie van het PWA-gebruik, aangezien push-abonnementen een geïnstalleerde app vereisen op mobiele apparaten.",
            "pwaInstallTitle": "Push-apparaten",
            "pushInactiveDevicesInfo": "Apparaten zonder recent actief abonnement: gedeactiveerd door een mislukte bezorging (410/404), niet gezien binnen de ingestelde bewaarperiode, of vervangen door een nieuwere registratie van hetzelfde apparaat.",
            "pushStaleTokenDays": "Inactieve apparaten verwijderen na (max 365 dagen)",
            "pushUnconfirmedThreshold": "Apparaat verwijderen na onbevestigde pushes",
            "webPushCleanupEnabled": "Inactieve apparaten automatisch verwijderen",
            "webPushCleanupEnabledDesc": "Apparaten waarvan 'laatst gezien' ouder is dan het ingestelde aantal dagen worden automatisch verwijderd",
            "webPushCleanupDisabledDesc": "Apparaten worden NOOIT automatisch verwijderd op basis van inactiviteit",
            "webPushUnconfirmedCleanupEnabled": "Apparaat verwijderen na onbevestigde pushes",
            "webPushUnconfirmedCleanupEnabledDesc": "Een apparaat wordt verwijderd zodra het ingestelde aantal pushes onbevestigd blijft",
            "webPushUnconfirmedCleanupDisabledDesc": "Apparaten worden nooit verwijderd om onbevestigde pushes",
            "pushTrayLimit": "Maximaal zichtbare meldingen per apparaat (1-20)",
            "notifications": "meldingen",
            "pushes": "pushes",
            "deactivatedUnconfirmed7d": "Gedeactiveerd (onbevestigd, deze week)",
            "searchTooltip": "Zoekt in: e-mailadres, voornaam, achternaam, telefoonnummer en bedrijfsnaam van het account.",
            "settingsTooltipCollection": "Als uitgeschakeld, worden er geen nieuwe analytics events opgeslagen.",
            "settingsTooltipDelay": "Tijd voordat events worden geaggregeerd (voorkomt race conditions).",
            "settingsTooltipIntro": "Beheer hier de analytics dataverzameling en -opslag.",
            "settingsTooltipRetention": "Na de opgegeven periode worden oude records automatisch verwijderd.",
            "topNTooltipAll": "Toont alle beschikbare items.",
            "topNTooltipIntro": "Bepaalt hoeveel items worden weergegeven in de grafiek en tabel.",
            "topTableTooltip": "Deze tabel toont de meest gebruikte features of groepen op basis van de geselecteerde filters. Klik op \"Detail\" om dieper in te zoomen op een specifieke feature. Na het klikken op Detail kunt u nogmaals een subgroep selecteren om de weergave verder te verfijnen en een gedetailleerde grafiek te bekijken.",
            "total": "Totaal",
            "userTypeTooltipAdminDesc": "Admin/support accounts.",
            "userTypeTooltipImpersonateDesc": "Admin ingelogd als een andere gebruiker.",
            "userTypeTooltipNone": "Geen selectie",
            "userTypeTooltipNoneDesc": "Toont alle gebruikers.",
            "userTypeTooltipRegularDesc": "Normale gebruikers (niet-admins).",
            "allAccounts": "Alle accounts"
        },
        "systemService": {
            "allServices": "Alle services",
            "allServicesAre": "Alle services zijn",
            "back": "Terug",
            "changeFailedMsg": "Het wijzigen van de services is niet gelukt.",
            "confirmTitle": "Bevestig",
            "crumb": {
                "admin": "Admin",
                "services": "Services"
            },
            "disableAll": "Alles uitschakelen",
            "disableVerb": "uitschakelen",
            "disabled": "uitgeschakeld",
            "enableAll": "Alles inschakelen",
            "enableVerb": "inschakelen",
            "enabled": "ingeschakeld",
            "failedSuffix": "mislukt",
            "no": "Nee",
            "ofServiceFailed": "van de service is niet gelukt.",
            "off": "uit",
            "on": "op",
            "onLabel": "in",
            "serviceIs": "De service is",
            "switchSuffix": "schakelen",
            "switchedSuffix": "geschakeld",
            "theWord": "Het",
            "toggleAllConfirm1": "Weet je zeker dat je alle services",
            "toggleAllConfirm2": "wilt schakelen?",
            "toggleServiceConfirm": "Weet je zeker dat je deze service wilt",
            "yes": "Ja"
        },
        "threads": {
            "activeThreads": "Actieve threads",
            "back": "Terug",
            "col": {
                "account": "ACCOUNT",
                "processId": "PROCESS ID",
                "status": "STATUS",
                "statusChanged": "STATUS GEWIJZIGD",
                "type": "TYPE"
            },
            "crumb": {
                "admin": "Admin",
                "threads": "Threads"
            },
            "empty": "Er zijn geen threads gevonden",
            "finish": "Beëindigen",
            "finishFailedMsg": "Het beëindigen van de thread is niet gelukt.",
            "finishFailedTitle": "Beëindigen mislukt",
            "finishedSnack": "De thread is beëindigd",
            "idCopied": "ID gekopieerd",
            "lastUpdated": "Laatst bijgewerkt",
            "na": "n.v.t.",
            "no": "Nee",
            "pagingOf": "van",
            "pagingTo": "t/m",
            "stop": "Stoppen",
            "stopConfirm": "Weet je zeker dat je deze thread wilt stoppen?",
            "stopFailedMsg": "Het stoppen van de thread is niet gelukt.",
            "stopFailedTitle": "Stoppen mislukt",
            "stopTitle": "Thread stoppen",
            "stoppingSnack": "De thread wordt gestopt",
            "yes": "Ja"
        },
        "userSelection": {
            "active": "Actief",
            "all": "Alle",
            "col": {
                "email": "E-mailadres",
                "id": "ID",
                "name": "Naam",
                "paymentMethod": "Heeft betaalwijze",
                "subStarted": "Abonnement gestart",
                "subStatus": "Abonnement status"
            },
            "copiedToClipboard": "gekopieerd",
            "createdAfter": "Account aangemaakt na",
            "createdBefore": "Account aangemaakt voor",
            "datePlaceholder": "dd-mm-jjjj",
            "empty": "- Geen gebruikers geselecteerd -",
            "exportFailedMsg": "Het exporteren van de gebruikers is niet gelukt.",
            "exportFailedTitle": "Exporteren mislukt",
            "exportUsers": "Gebruikers exporteren",
            "filters": "Filters",
            "inactive": "Inactief",
            "includeFree": "Inclusief gratis",
            "includeTrial": "Inclusief proef",
            "includeUnpaid": "Inclusief onbetaald",
            "no": "Nee",
            "noUsersSelected": "Er zijn geen gebruikers geselecteerd",
            "registrationDate": "Registratiedatum",
            "selectFailedMsg": "Het selecteren van de gebruikers is niet gelukt.",
            "selectFailedTitle": "Selectie mislukt",
            "selectUsers": "Gebruikers selecteren",
            "status": "Status",
            "subscription": "Abonnement",
            "yes": "Ja"
        },
        "users": {
            "back": "Terug",
            "blocked": "Geblokkeerd",
            "churn": "Abonnementen verloop",
            "clearFilters": "Filters wissen",
            "col": {
                "createdAt": "AANGEMAAKT OP",
                "email": "E-MAILADRES",
                "lastLogin": "LAATSTE LOGIN",
                "name": "NAAM",
                "subscription": "ABONNEMENT"
            },
            "copyFailed": "Het kopiëren van het ID is niet gelukt.",
            "copyId": "ID kopiëren",
            "crumb": {
                "admin": "Admin",
                "users": "Gebruikers"
            },
            "details": {
                "accounts": "Accounts",
                "address": "Adres",
                "back": "Terug",
                "block": "Blokkeren",
                "blockVerb": "blokkeren",
                "canLoginWithCode": "De gebruiker kan inloggen met de code",
                "cancel": "Annuleren",
                "city": "Stad",
                "close": "Sluiten",
                "codeGenerated": "Code gegenereerd",
                "col": {
                    "companyName": "BEDRIJFSNAAM",
                    "createdAt": "AANGEMAAKT OP",
                    "status": "STATUS"
                },
                "confirmTitle": "Bevestig",
                "country": "Land",
                "day": "dag",
                "days": "dagen",
                "delete": "Verwijderen",
                "deleteConfirm": "Weet je zeker dat je deze gebruiker wilt verwijderen?",
                "deleteFailedMsg": "Het verwijderen van de gebruiker is niet gelukt.",
                "deleteFailedTitle": "Verwijderen mislukt",
                "deletedSnack": "De gebruiker is verwijderd",
                "edit": "Wijzigen",
                "email": "E-mailadres",
                "firstname": "Voornaam",
                "generateAccessCode": "Toegangscode genereren",
                "lastname": "Achternaam",
                "loadAccountsFailedMsg": "Het laden van de accounts is niet gelukt.",
                "loadAccountsFailedTitle": "Account niet gevonden",
                "lockConfirm": "Weet je zeker dat je deze gebruiker wilt",
                "mailSent": "De mail is verzonden",
                "no": "Nee",
                "noSubscription": "Geen abonnement",
                "off": "Uit",
                "on": "Aan",
                "overrideEmail": "Negeer e-mail beleidspunten",
                "overrideLimit": "Negeer beperkingen",
                "resetTwoFactor": "Resetten",
                "resetTwoFactorConfirm": "Weet je zeker dat de tweestapsverificatie voor deze gebruiker gereset moet worden?",
                "save": "Opslaan",
                "status": "Status",
                "stripeId": "Stripe ID",
                "sub": {
                    "active": "Actief",
                    "canceled": "Geannuleerd",
                    "free": "Gratis",
                    "inactive": "Inactief",
                    "trial": "Proefperiode",
                    "unpaid": "Onbetaald"
                },
                "subStatus": "Status abonnement",
                "subscription": "Abonnement",
                "telNumber": "Telefoonnummer",
                "title": "Gebruiker details",
                "tokenFailedMsg": "Het genereren van de token is niet gelukt.",
                "tokenFailedTitle": "Genereren mislukt",
                "trialUntil": "Proefperiode t\\m",
                "twoFactor": "Tweestapsverificatie",
                "type": {
                    "admin": "Admin",
                    "premium": "Premium gebruiker",
                    "superAdmin": "Super admin",
                    "support": "Support",
                    "user": "Gebruiker"
                },
                "typeLabel": "Type",
                "unblock": "Deblokkeren",
                "unblockVerb": "deblokkeren",
                "updateFailedMsg": "Het bijwerken van de gebruiker is niet gelukt.",
                "updateFailedTitle": "Bijwerken mislukt",
                "updatedSnack": "De gebruiker is bijgewerkt",
                "validation": {
                    "address": "Het adres mag niet leeg zijn",
                    "city": "De stad mag niet leeg zijn",
                    "country": "Het land mag niet leeg zijn",
                    "emailEmpty": "Het e-mailadres mag niet leeg zijn",
                    "emailInvalid": "Het e-mailadres is niet geldig",
                    "firstname": "De voornaam mag niet leeg zijn",
                    "lastname": "De achternaam mag niet leeg zijn",
                    "telNumber": "Het telefoonnummer mag niet leeg zijn",
                    "zipCode": "De postcode mag niet leeg zijn"
                },
                "yes": "Ja",
                "zipCode": "Postcode"
            },
            "detailsAction": "Details",
            "detailsLabel": "Details",
            "extraUser": "Extra gebruiker",
            "filter": {
                "accountId": "Account ID",
                "apply": "Toepassen",
                "cancel": "Annuleren",
                "companyName": "Bedrijfsnaam",
                "customerId": "Customer ID",
                "email": "E-mailadres",
                "firstname": "Voornaam",
                "lastname": "Achternaam",
                "title": "Filter klanten",
                "userId": "User ID"
            },
            "filterAction": "Filter",
            "idCopied": "ID gekopieerd",
            "loadFailedMsg": "Het laden van de gebruikers is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "login": "Inloggen",
            "loginFailedMsg": "Het inloggen is niet gelukt.",
            "loginFailedTitle": "Inloggen mislukt",
            "na": "n.v.t.",
            "pagingOf": "van",
            "pagingTo": "t/m",
            "placeholder": {
                "companyName": "Bedrijfsnaam",
                "createdAt": "Aangemaakt op",
                "email": "E-mailadres",
                "lastLogin": "Laatste login",
                "name": "Naam",
                "status": "Status"
            },
            "search": "Zoeken",
            "stats": {
                "active": "Actief",
                "free": "Gratis",
                "inactive": "Inactief",
                "trial": "Proefperiode"
            },
            "title": "Gebruikers"
        }
    },
    "adminNav": {
        "admin": "Admin",
        "cron": "Cron",
        "defaultTemplates": "Standaard templates",
        "failedPayments": "Mislukte betalingen",
        "platformUsage": "Platformgebruik",
        "sendEmails": "E-mails verzenden",
        "thirtyDayImport": "30 dagen import",
        "threads": "Threads log",
        "users": "Gebruikers"
    },
    "app": {
        "admin": {
            "account": "Account",
            "apiKey": "API key",
            "idCopied": "{{id}} gekopieerd",
            "user": "Gebruiker"
        },
        "env": {
            "accept": "Acceptatie omgeving",
            "dev": "Develop omgeving",
            "test": "Test omgeving"
        },
        "mobileReadyHint": "Pagina's die wél goed werken op je telefoon herken je in het menu aan dit label:",
        "mobileWarning": "Deze pagina is nog niet geoptimaliseerd voor mobiele apparaten. Gebruik hiervoor een laptop of desktop."
    },
    "auth": {
        "forgotPassword": {
            "back": "Terug",
            "emailInvalid": "Vul een geldig e-mailadres in",
            "emailLabel": "E-mailadres",
            "emailPlaceholder": "Je e-mailadres",
            "emailRequired": "Vul je e-mailadres in",
            "submit": "Verzenden",
            "subtitle": "Vul je e-mailadres in om je wachtwoord opnieuw in te stellen",
            "successMessage": "Als het e-mailadres overeenkomt met een gebruiker in onze database, dan is er een e-mail verzonden met instructies om je wachtwoord opnieuw in te stellen. Het kan een aantal minuten duren voordat deze mail aankomt. We raden je aan om ook je spam te controleren.",
            "successTitle": "Wachtwoord opnieuw instellen",
            "title": "Wachtwoord opnieuw instellen",
            "connectionError": "Verbinding mislukt — controleer je internet en probeer opnieuw.",
            "failedTitle": "Verzenden mislukt"
        },
        "login": {
            "accountBlockedTitle": "Account geblokkeerd",
            "checkEmailNote": "90% van de tijd vergissen gebruikers zich in het e-mailadres.",
            "checkEmailQuestion": "Weet je zeker dat dit wel het juiste e-mailadres is?",
            "emailInvalid": "Vul een geldig e-mailadres in",
            "emailLabel": "E-mailadres *",
            "emailPlaceholder": "E-mailadres",
            "emailRequired": "Vul je e-mailadres in",
            "forgotPassword": "Wachtwoord vergeten?",
            "genericError": "Er is iets misgegaan",
            "googleAccountMessage": "Dit e-mailadres is geregistreerd met Google. Je kunt inloggen via de Google inloggen knop.",
            "googleAccountTitle": "Google account",
            "googleErrorMessage": "Er is iets missgegaan bij het verbinden met Google.",
            "invalidCredentials": "Ongeldige combinatie van e-mailadres en wachtwoord.",
            "loginFailedTitle": "Inloggen mislukt",
            "noAccount": "Heb je nog geen account?",
            "passwordLabel": "Wachtwoord *",
            "passwordPlaceholder": "Wachtwoord",
            "passwordRequired": "Vul je wachtwoord in",
            "register": "Registreren",
            "submit": "Log in",
            "subtitle": "Welkom bij Bluemate",
            "title": "Inloggen in je account",
            "connectionError": "Verbinding mislukt — controleer je internet en probeer opnieuw."
        },
        "register": {
            "acceptTerms": "Accepteer de voorwaarden om een account te registreren",
            "and": "en",
            "companiesUsingBluemate": "Meer dan {{total}}+ bedrijven gebruiken Bluemate!",
            "companyNameLabel": "Bedrijfsnaam *",
            "companyNamePlaceholder": "Bedrijfsnaam",
            "companyNameRequired": "De bedrijfsnaam mag niet leeg zijn",
            "createAccount": "Maak een account aan",
            "createAccountFailed": "Het aanmaken van het account is niet gelukt.",
            "emailInUse": "Het opgegeven e-mailadres is al in gebruik.",
            "emailInvalid": "Het e-mailadres is niet geldig",
            "emailLabel": "E-mailadres *",
            "emailPlaceholder": "E-mailadres",
            "emailRequired": "Het e-mailadres mag niet leeg zijn",
            "firstnameLabel": "Voornaam *",
            "firstnamePlaceholder": "Voornaam",
            "firstnameRequired": "De voornaam mag niet leeg zijn",
            "freeTrialSubtitle": "Stopt automatisch. Verlenging mogelijk. Geen betaalmethode nodig.",
            "freeTrialTitle": "Probeer 30 dagen gratis!",
            "googleErrorMessage": "Er is iets misgegaan bij het registreren met Google.",
            "googleErrorTitle": "Registreren mislukt",
            "haveAccount": "Heb je al een Bluemate account?",
            "invitationFailedTitle": "Uitnodiging mislukt",
            "invitationNotFound": "De uitnodiging kan niet gevonden worden.",
            "lastnameLabel": "Achternaam *",
            "lastnamePlaceholder": "Achternaam",
            "lastnameRequired": "De achternaam mag niet leeg zijn",
            "login": "Inloggen",
            "okButton": "Oké",
            "or": "- of -",
            "passwordLabel": "Wachtwoord *",
            "passwordPlaceholder": "Wachtwoord",
            "passwordRequired": "Het wachtwoord mag niet leeg zijn",
            "privacyStatement": "Privacy statement",
            "processingAgreement": "Verwerkersovereenkomst",
            "registrationFailedTitle": "Registratie mislukt",
            "signupWithEmail": "Aanmelden met e-mailadres",
            "termsAgreePrefix": "Ik ga akkoord met de",
            "termsConditions": "Algemene voorwaarden",
            "connectionError": "Verbinding mislukt — controleer je internet en probeer opnieuw."
        },
        "resetPassword": {
            "confirmPasswordLabel": "Herhaal wachtwoord",
            "confirmPasswordPlaceholder": "Herhaal wachtwoord",
            "confirmRequired": "Herhaal het wachtwoord",
            "failedMessage": "Het wijzigen van je wachtwoord is niet gelukt.",
            "failedTitle": "Wijzigen mislukt",
            "newPasswordLabel": "Nieuw wachtwoord",
            "newPasswordPlaceholder": "Nieuw wachtwoord",
            "passwordRequired": "Kies een nieuw wachtwoord",
            "passwordsMismatch": "De wachtwoorden komen niet overeen",
            "save": "Opslaan",
            "subtitle": "Kies een nieuw wachtwoord",
            "successMessage": "Het wachtwoord van je account is aangepast, je kunt nu met je nieuwe wachtwoord inloggen.",
            "successTitle": "Wachtwoord gewijzigd",
            "title": "Wachtwoord opnieuw instellen",
            "connectionError": "Verbinding mislukt — controleer je internet en probeer opnieuw."
        }
    },
    "beta": {
        "popup": {
            "maybe": "Misschien",
            "no": "Nee",
            "q1": "Wil jij meewerken aan het optimaliseren van ons platform?",
            "q2": "Wij zijn momenteel op zoek naar bèta testers voor onze nieuwe \"Hulp bij BTW aangifte\" functionaliteit.",
            "q3": "Jij krijgt als eerste toegang tot deze nieuwe functie van ons platform. Door feedback te geven kun je ons helpen deze te verbeteren.",
            "q4": "Ben je geïnteresseerd in deelname aan dit bètaprogramma?",
            "registeredMessage": "Je bent aangemeld voor het bèta programma en ontvangt binnenkort meer informatie over hoe je toegang krijgt tot de \"Hulp bij BTW aangifte\".",
            "registeredTitle": "Bedankt voor je aanmelding!",
            "saveFailed": "Opslaan mislukt",
            "saveFailedMessage": "Het opslaan van je keuze is niet gelukt.",
            "title": "Bèta testers gevraagd",
            "yes": "Ja"
        }
    },
    "bol": {
        "returnReason": {
            "defective": "Artikel is defect",
            "other": "Anders",
            "wrongOrder": "Verkeerd besteld",
            "wrongProduct": "Ander artikel ontvangen dan besteld",
            "doesNotWork": "Artikel werkt niet",
            "cheaper": "Elders goedkoper",
            "noReason": "Geen reden",
            "productComplaint": "Klacht over artikel",
            "deliveryComplaint": "Klacht over de bezorging",
            "wrongSize": "Verkeerde maat of afmeting"
        }
    },
    "chromeExtension": {
        "bottomButton": "Download de gratis Chrome Extensie",
        "crumb": "Chrome Extensie",
        "eyebrow": "Chrome Extensie",
        "introDiscover": "Ontdek potentiele kansen met deze productonderzoek tool op bol.com.",
        "shareButton": "Share de link",
        "shareCopied": "De link is gekopieerd",
        "shareFailed": "Kopiëren is niet gelukt",
        "shareText": "Deze Chrome Extensie is gratis en publiek toegankelijk. Ken je iemand die dit ook wel een omzet schatting wilt zien bij elk product op bol? Deel de link met je vrienden of collega's.",
        "shareTitle": "Deel 'm met anderen",
        "title": "De omzet van elk product op bol.com",
        "intro": "Een inschatting van de omzet en orders van elk product op bol.",
        "storeButton": "Download de Chrome Extensie",
        "ctaNote": "Gratis en publiek — geen Bluemate of Bol account nodig",
        "featuresTitle": "Wat doet de extensie?",
        "featureSalesTitle": "Inschatting",
        "featureSalesText": "Ons model berekent het aantal verkopen en de omzet per maand voor producten op bol. Hiervoor gebruikt het publieke metadata van de producten, gegeven door bol.",
        "featureEverywhereTitle": "In de zoekresultaten",
        "featureEverywhereText": "De schatting verschijnt in de zoekresultaten en op de productpagina van bol.com zelf.",
        "featureFreeTitle": "Publiek en gratis",
        "featureFreeText": "Onze Chrome Extensie is gratis voor iedereen - je hebt geen Bluemate noch bol account nodig. Deel hem met je vrienden!",
        "shotsTitle": "Zo ziet het eruit",
        "shotListAlt": "Geschatte verkopen onder producten in de zoekresultaten van bol.com",
        "shotListCaption": "Inschatting van verkopen en omzet per maand, direct onder elk product in de zoekresultaten.",
        "shotBadgeAlt": "De Bluemate verkoopbadge onder een product op bol.com",
        "shotBadgeCaption": "De badge van dichtbij: geschatte verkopen en omzet per maand.",
        "bottomTitle": "Probeer de gratis Chrome-extensie",
        "bottomText": "Installeer de extensie op jouw Chrome browser. Bekijk de omzet van elk product op bol.com. Gratis en openbaar voor iedereen."
    },
    "common": {
        "apply": "Toepassen",
        "cancel": "Annuleren",
        "close": "Sluiten",
        "copy": "Kopieren",
        "dialog": {
            "defaultTitle": "Bericht van het systeem",
            "ok": "Oke"
        },
        "no": "Nee",
        "yes": "Ja"
    },
    "connectionComplete": {
        "autoUpload": {
            "decideLater": "Later beslissen",
            "info1": "Sinds juni 2023 kunnen facturen direct naar het platform van Bol geüpload worden. Als een klant een aanvraag indient voor een factuur, dan ben je verplicht deze binnen 24 uur te uploaden naar Bol. Je kunt met Bluemate factuuraanvragen voor zijn door facturen proactief te laten uploaden. Daarnaast kan Bluemate automatisch jouw factuuraanvragen beantwoorden door de factuur te uploaden.",
            "info2": "Je kunt deze keuze altijd nog aanpassen en jouw specifieke upload wensen instellen onder het kopje Aanvragen in het menu.",
            "subtitle": "Zo ben je factuuraanvragen voor.",
            "title": "Facturen automatisch laten uploaden naar Bol?"
        },
        "autoUploadOld": {
            "heading": "Factuuraanvragen voor oude orders",
            "info1": "Jouw klanten kunnen voor orders tot 2 jaar terug een factuur aanvragen. Het is mogelijk dat wij deze order niet in het systeem hebben, omdat jouw Bluemate account toen nog niet bestond.",
            "info2": "We kunnen deze factuuraanvraag wel automatisch beantwoorden met een factuur upload, maar doordat de Belastingdienst vereist dat jouw factuurnummering chronologisch oploopt, kunnen we hiervoor niet het standaard factuurnummer gebruiken.",
            "info3": "Je kunt daarom een andere factuurnummerreeks kiezen voor de facturen voor oude orders, op deze manier blijven de nummers chronologisch oplopend.",
            "subtitle": "Deze worden verwerkt met een andere factuurnummer reeks.",
            "title": "Factuuraanvragen voor oudere orders automatisch verwerken?"
        },
        "back": "Terug",
        "configured": "Ingesteld:",
        "custom": "Anders",
        "customInfo": {
            "etc": "etc.",
            "example": "Voorbeeld:",
            "line1": "Je hebt 50 orders gehad in de afgelopen 30 dagen.",
            "line2": "Je stelt hiervoor een andere factuurnummering in namelijk",
            "line3": "Dan krijgt de import de nummering",
            "line4": "op volgorde chronologisch in de tijd.",
            "line5": "De orders die je daarna nieuw binnenkrijgt, volgen de standaard factuurnummering.",
            "line6": "Deze krijgen dus de nummering",
            "until": "tot"
        },
        "customNamely": "Namelijk...",
        "errors": {
            "importFailedTitle": "Importeren mislukt",
            "invalid": "Niet geldig",
            "startImportFailed": "Het starten van de import is niet gelukt."
        },
        "importHistory": {
            "info1": "De facturen zijn pas beschikbaar als het importeren klaar is.",
            "info2": "In de tussentijd kun je wel de rest van het platform gebruiken.",
            "info3": "Indicatie van de tijd die het duurt:",
            "subtitle": "Dit kan even duren, afhankelijk van de hoeveelheid orders.",
            "time1": "100 orders = 1 minuut",
            "time2": "1000 orders = 1,5 minuten",
            "time3": "5000 orders = 2 minuten",
            "title": "Wil je ook de orders van de afgelopen 30 dagen importeren?"
        },
        "intro": {
            "subtitle": "Vanaf nu halen we alle nieuwe orders op bij Bol",
            "title": "De koppeling met Bol is gemaakt!"
        },
        "invoiceNumber": {
            "subtitle1": "Wil je dezelfde of een andere factuurnummering gebruiken",
            "subtitle2": "voor de import van de orders van de afgelopen 30 dagen?",
            "title": "Welke factuur nummering wil je hiervoor gebruiken?"
        },
        "next": "Volgende",
        "no": "Nee",
        "notifications": {
            "betaLabel": "Beta",
            "buyBox": {
                "description": "Een e-mail wanneer het koopblok verandert",
                "title": "Koopblok verandering"
            },
            "info1": "De notificaties worden met standaard instellingen aangemaakt.",
            "info2": "Je kunt deze altijd nog aanpassen op de Notificaties pagina.",
            "order": {
                "description": "Ontvang een e-mail bij nieuwe orders",
                "title": "Nieuwe bestellingen"
            },
            "productHijack": {
                "description": "Ontvang een e-mail wanneer een nieuwe verkoper op jouw product verschijnt",
                "title": "Productkaping notificatie"
            },
            "reviews": {
                "description": "Ontvang een e-mail bij nieuwe reviews",
                "title": "Nieuwe reviews"
            },
            "stock": {
                "description": "Krijg een e-mail als jouw voorraad onder de 20 is",
                "title": "Lage voorraad"
            },
            "subtitle1": "Selecteer bij welke gebeurtenissen je direct een notificatie per e-mail wilt.",
            "subtitle2": "Ik wil een notificatie ontvangen bij:",
            "title": "Welke meldingen wil je ontvangen?"
        },
        "prefix": "Voortekens *",
        "preview": "Voorbeeld:",
        "standard": "Standaard",
        "standardInfo": {
            "etc": "etc.",
            "example": "Voorbeeld:",
            "line1": "Je hebt 50 orders gehad in de afgelopen 30 dagen.",
            "line2": "Deze krijgen de nummering",
            "line3": "op volgorde chronologisch in de tijd.",
            "line4": "De orders die je nieuw binnenkrijgt, tellen door vanaf dit punt.",
            "line5": "Die krijgen dus de nummering",
            "until": "tot"
        },
        "start": "Beginnen bij *",
        "summary": {
            "history1": "We gaan nu jouw orders importeren.",
            "history2": "Dit kan even duren, afhankelijk van het aantal orders.",
            "history3": "In de tussentijd kun je de rest van het platform gewoon gebruiken.",
            "history4": "De facturen worden vanaf nu automatisch aangemaakt.",
            "history5": "Je kunt Bluemate nu verder naar wens instellen en gaan gebruiken.",
            "start": "Start",
            "title": "Klaar voor de start!"
        },
        "yes": "Ja"
    },
    "controls": {
        "countryField": {
            "all": "Alle",
            "country": "Land",
            "countries": "Landen"
        },
        "countrySelect": {
            "all": "Alle",
            "available": "Beschikbare",
            "countries": "landen",
            "done": "Klaar",
            "selectCountries": "Landen selecteren",
            "selected": "Geselecteerde"
        },
        "datePicker": {
            "close": "Sluiten",
            "dayShort": {
                "mon": "Ma",
                "tue": "Di",
                "wed": "Wo",
                "thu": "Do",
                "fri": "Vr",
                "sat": "Za",
                "sun": "Zo"
            },
            "today": "Vandaag"
        },
        "dialog": {
            "cancel": "Annuleren",
            "confirm": "Goedkeuren"
        },
        "input": {
            "clear": "Wissen"
        },
        "periodSelector": {
            "all": "Alles",
            "applyRange": "Bereik toepassen",
            "back": "Terug",
            "custom": "Aangepast",
            "customEllipsis": "Aangepast...",
            "customRange": "Aangepast bereik",
            "datePlaceholder": "dd-mm-jjjj",
            "endDate": "Einddatum",
            "labels": {
                "today": "Vandaag",
                "yesterday": "Gisteren",
                "last7Days": "Afgelopen 7 dagen",
                "last30Days": "Afgelopen 30 dagen",
                "last90Days": "Afgelopen 90 dagen",
                "weekToDate": "Deze week",
                "monthToDate": "Deze maand",
                "quarterToDate": "Dit kwartaal",
                "yearToDate": "Dit jaar",
                "lastWeek": "Afgelopen week",
                "lastMonth": "Afgelopen maand",
                "lastQuarter": "Afgelopen kwartaal",
                "lastYear": "Afgelopen jaar",
                "all": "Alles",
                "custom": "Aangepast"
            },
            "selectPeriod": "Selecteer periode",
            "startDate": "Startdatum"
        },
        "platformLabelInput": {
            "recognizableName": "Herkenbare naam",
            "info": "Met deze naam kun je je accounts uit elkaar houden. Voeg bijvoorbeeld BE toe als het gaat om een Belgisch verkoopaccount. Deze naam wordt enkel op het Bluemate platform getoond om te wisselen tussen je verkoopaccounts en wordt dus niet gebruikt in de communicatie naar je klanten."
        },
        "plot": {
            "items": "Items",
            "noDataMessage": "Selecteer een serie of pas de filters aan om gegevens te bekijken.",
            "noDataSeriesMessage": "Geen data beschikbaar voor deze serie."
        },
        "portalSelect": {
            "selectedCount_one": "{{count}} geselecteerd",
            "selectedCount_other": "{{count}} geselecteerd",
            "selectAll": "Alles",
            "clear": "Wis"
        },
        "productRow": {
            "readLess": "Minder lezen",
            "readMore": "Meer lezen"
        },
        "setupCard": {
            "emailSetup": {
                "subtitle": "Om automatisch te e-mailen",
                "title": "E-mails instellen"
            },
            "invoiceDesign": {
                "subtitle": "Controleer en pas aan indien nodig",
                "title": "Factuur ontwerpen"
            },
            "invoiceUpload": {
                "subtitle": "Upload facturen naar Bol",
                "title": "Auto-upload"
            },
            "markComplete": "Markeer als afgerond",
            "vatSetup": {
                "subtitle": "Wijk optioneel af van 21%",
                "title": "Btw % producten"
            }
        },
        "statCard": {
            "percentageView": "Percentage weergave",
            "previous": "Vorige",
            "toggleView": "Weergave wisselen"
        },
        "statusTile": {
            "autoEmail": {
                "green": "Auto e-mailen",
                "gray": "Auto e-mailen uit",
                "orange": "Auto e-mailing gepauzeerd",
                "red": "Auto e-mailing uit"
            },
            "autoUpload": {
                "green": "Auto uploaden",
                "gray": "Auto uploaden uit",
                "orange": "Auto uploaden vertraagd",
                "red": "Auto uploaden uit"
            },
            "bolConnection": {
                "green": "Gekoppeld met Bol",
                "greenCompact": "Gekoppeld",
                "gray": "Bol koppeling onbekend",
                "grayCompact": "Bol onbekend",
                "orange": "Bol koppeling: waarschuwing",
                "orangeCompact": "Bol let op",
                "red": "Geen verbinding met Bol",
                "redCompact": "Niet gekoppeld"
            }
        },
        "stepper": {
            "stepOf": "Stap {{step}} van {{total}}: {{subtitle}}",
            "back": "Vorige stap",
            "next": "Volgende",
            "cancel": "Annuleren"
        }
    },
    "dashboard": {
        "advancedSearch": "Uitgebreid zoeken",
        "apiConnectionBar": {
            "connectWithBol": "Koppelen met Bol"
        },
        "assignNum": {
            "customerType": "Type klant",
            "egPlaceholder": "Bijv.",
            "errorEmpty": "Het factuurnummer kan niet leeg zijn",
            "errorInvalid": "Het factuurnummer moet een geldig getal zijn",
            "failed": "Het instellen van het factuurnummer is niet gelukt.",
            "failedTitle": "Instellen mislukt",
            "invoiceData": "Factuurgegevens",
            "invoiceNumberPh": "Factuurnummer",
            "invoiceNumberReq": "Factuurnummer *",
            "lastTimeFilled": "Laatste keer vulde je in:",
            "latestNormalSeries": "Laatste nummer normale reeks:",
            "message": "Kies een factuurnummer voor deze factuur. Het factuurnummer mag niet eerder gebruikt zijn en de facturen moeten met oplopende factuurnummers genummerd worden.",
            "orderDate": "Orderdatum",
            "orderNumber": "Ordernummer",
            "prefix": "Voorvoegsel",
            "reference": "Referentie",
            "success": "Het factuurnummer is ingesteld",
            "title": "Factuurnummer kiezen"
        },
        "bulk": {
            "sendingHistory": "Bulk e-mails worden ingepland"
        },
        "cancelEmails": {
            "confirmBody": "Weet je zeker dat je geen automatische mails voor deze bestelling meer wilt verzenden?",
            "failed": "Het annuleren van de mails is niet gelukt",
            "failedTitle": "Annuleren mislukt",
            "success": "Mails voor deze factuur worden niet meer verzonden",
            "title": "Mails annuleren"
        },
        "connectWithBol": "Koppelen met Bol",
        "connectionError": {
            "connectPrompt": "Verbind Bluemate met Bol om jouw orders automatisch te kunnen ophalen.",
            "nothingSent": "We versturen nog niks.",
            "welcome": "Welkom in de Bluemate app!",
            "willShow": "In dit scherm zie je straks je opgehaalde orders."
        },
        "copied": "gekopieerd",
        "crumbs": {
            "invoiceRequests": "Factuuraanvragen",
            "invoices": "Facturen"
        },
        "download": {
            "failedTitle": "Downloaden mislukt",
            "invoiceFailed": "Het downloaden van de factuur is niet gelukt."
        },
        "empty": {
            "subtitle": "Zodra we de eerste order van Bol ontvangen wordt deze hier getoond. Je kunt via de zoekbalk ook oudere orders opzoeken, dit kan tot 2 jaar terug!",
            "title": "Nog geen orders ontvangen"
        },
        "filter": {
            "all": "Alle",
            "clearFilters": "Filters wissen",
            "cocNumber": "KvK nummer",
            "companyName": "Bedrijfsnaam",
            "country": "Land",
            "customerType": {
                "business": "Zakelijk",
                "private": "Particulier"
            },
            "customerTypeLabel": "Type klant",
            "datePlaceholder": "dd-mm-jjjj",
            "eanProduct": "EAN besteld product",
            "firstName": "Voornaam",
            "invoiceKind": "Soort factuur",
            "invoiceNumber": "Factuurnummer",
            "invoiceStatus": "Status factuur",
            "invoiceType": {
                "credit": "Creditfacturen",
                "sales": "Verkoopfacturen"
            },
            "lastName": "Achternaam",
            "orderNumber": "Ordernummer",
            "orderPeriodLabel": "Periode",
            "orderStatus": {
                "canceled": "Geannuleerd",
                "placed": "Geplaatst",
                "return": "Geretourneerd",
                "return_open": "Open Retour",
                "sent": "Verzonden",
                "credit": "Creditfactuur"
            },
            "orderStatusLabel": "Status bestelling",
            "reference": "Referentie",
            "search": "Zoeken",
            "sectionCustomer": "Klant",
            "sectionInvoice": "Factuur",
            "sectionOrder": "Bestelling",
            "status": {
                "error": "Fout",
                "notSent": "Niet verzonden",
                "sending": "Wordt verzonden",
                "sent": "Verzonden",
                "warning": "Waarschuwing"
            },
            "vatNumber": "BTW nummer"
        },
        "filters": {
            "manyActive": "actieve filters",
            "oneActive": "1 actieve filter",
            "removeFilters": "Verwijder x",
            "searchPlaceholder": "Zoek op ordernummer",
            "statusAll": "Alle statussen"
        },
        "firstImport": {
            "message": "We hebben de oudere order voor je opgezocht en deze toegevoegd aan je account. Deze order is geplaatst voordat je een Bluemate account ingesteld hebt, hierdoor kunnen wij niet automatisch het factuurnummer bepalen. Klik op de order en kies de optie \"Factuurnummer instellen\" om zelf een factuurnummer te kiezen.",
            "understood": "Begrepen"
        },
        "importOverlay": {
            "line1": "We sturen je een e-mail zodra het importeren voltooid is.",
            "line2": "Je kunt ondertussen jouw account naar wens instellen.",
            "title": "De orders van de afgelopen 30 dagen worden geïmporteerd"
        },
        "importStatus": {
            "error": "Probleem bij controleren op nieuwe orders",
            "importing": "Controleren op nieuwe orders",
            "lastCheck": "laatste controle",
            "notConnected": "Niet verbonden met Bol",
            "searchTip": "Via de zoekbalk kun je óók orders ophalen via het ordernummer die van vóór het begin gebruik van Bluemate zijn, tot wel 2 jaar terug.",
            "updated": "Bijgewerkt"
        },
        "importing": {
            "checkStatus": "Check de status rechts bovenin de pagina.",
            "fetching": "Orders aan het ophalen",
            "firstTime": "De eerste keer kan dit enkele minuten duren."
        },
        "introBanner": {
            "invoicesMessage": "Beheer jouw orders en facturen op één plek, zodat je altijd overzicht hebt.",
            "invoicesTitle": "Facturen",
            "requestsMessage": "Upload de facturen automatisch naar bol. Wees factuuraanvragen vóór.",
            "requestsTitle": "Factuur aanvragen"
        },
        "invoiceCustomerBoth": "Zakelijk en Particulier",
        "invoiceCustomerBusiness": "Zakelijk",
        "invoiceCustomerPrivate": "Particulier",
        "notFound": {
            "tipBefore": "Tip: voor zoeken op achternaam, bedrijf, factuurnummer etc. Gebruik",
            "title": "Geen orders gevonden"
        },
        "orders": "Orders",
        "otherAccount": "Deze order komt uit niet-geselecteerd account",
        "orderNumberLabel": "Ordernummer",
        "invoiceNumberLabel": "Factuurnummer",
        "profitLabel": "Winst",
        "quantityBadge": {
            "moreProducts": "Deze order bevat {{count}} verschillende producten",
            "units": "Deze order bevat {{count}} stuks van dit product"
        },
        "period": {
            "from": "Vanaf",
            "label": "Periode",
            "title": "Periode aanpassen",
            "to": "Tot en met"
        },
        "stats": {
            "last30Days": "AFGELOPEN 30 DAGEN"
        },
        "uploadStats": {
            "autoRespond": "Auto aanvragen beantwoorden",
            "autoRespondFailedPrefix": "Het",
            "autoRespondFailedSuffix": "van het automatisch beantwoorden is niet gelukt.",
            "autoRespondFailedTitlePrefix": "Automatisch beantwoorden",
            "autoRespondInfo": "Indien de factuur van een order nog niet is geüpload, kan een klant de factuur aanvragen. Met deze optie wordt er automatisch gereageerd op deze aanvraag met de bijbehorende factuur. Door ook de optie proactief uploaden aan te vinken, zorg je ervoor dat er steeds minder van dit soort aanvragen zijn, omdat de factuur al klaar zal staan en men deze niet meer aanvraagt.",
            "autoRespondPrefix": "Het automatisch beantwoorden van de aanvragen is",
            "autoRespondTitle": "Automatisch aanvragen beantwoorden",
            "disable": "uitschakelen",
            "disabled": "uitgeschakeld",
            "enable": "inschakelen",
            "enabled": "ingeschakeld",
            "failedSuffix": "mislukt",
            "openRequests": "OPEN FACTUURAANVRAGEN",
            "proactiveFailedPrefix": "Het",
            "proactiveFailedSuffix": "van het proactief uploaden is niet gelukt.",
            "proactiveFailedTitlePrefix": "Proactief uploaded",
            "proactiveInfo": "Met proactief uploaden zorg je ervoor dat voor elke nieuwe order, de factuur na voltooiing van order wordt geüpload. Klanten kunnen de btw-factuur dan vinden en downloaden in hun Bol klantportaal. Zo voorkom je factuuraanvragen.",
            "proactiveUpload": "Proactief uploaden",
            "proactiveUploadPrefix": "Het proactief uploaden van de facturen is",
            "recommended": "Aanbevolen",
            "recommendedInfo": "Wij raden aan zowel proactief uploaden als automatisch beantwoorden aan te vinken.",
            "uploaded": "FACTUREN GEÜPLOAD"
        },
        "uploading": {
            "failed": "Het uploaden van de factuur is niet gelukt.",
            "failedTitle": "Uploaden mislukt",
            "success": "De factuur wordt geüpload naar Bol"
        }
    },
    "email": {
        "adminInfo": {
            "active": "Actief",
            "activeSince": "Actief sinds",
            "activity": "Activiteit",
            "all": "Alle",
            "createdAt": "Gemaakt op",
            "disabled": "Uitgeschakeld",
            "enabled": "Ingeschakeld",
            "id": "ID",
            "inactive": "Inactief",
            "invoiceMail": "Factuurmail",
            "loadFailed": "Het laden is mislukt",
            "mailType": "Soort mail",
            "name": "Naam",
            "on": "op",
            "products": "Producten",
            "remaining": "Resterende",
            "reviewInvoiceMail": "Review + factuurmail",
            "showAll": "Alles tonen",
            "showLess": "Minder tonen",
            "status": "Status",
            "updatedAt": "Laatst gewijzigd"
        },
        "attachment": {
            "addInvoice": "+ Factuur van order toevoegen als bijlage",
            "attachmentLabel": "BIJLAGE",
            "attachmentsLabel": "BIJLAGES",
            "confirm": "Bevestig",
            "deleteConfirm": "Weet je zeker dat je deze bijlage wilt verwijderen? Deze wordt dan ook niet meer meegestuurd met ingestelde e-mails.",
            "deleteFailed": "Het verwijderen van de bijlage is niet gelukt.",
            "deleteFailedTitle": "Verwijderen mislukt",
            "deleted": "De bijlage is verwijderd",
            "done": "Klaar",
            "emailUpdated": "De e-mail is bijgewerkt",
            "invoiceOfOrder": "Factuur van order (.pdf)",
            "loadFailed": "Het laden van de bijlages is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "name": "NAAM",
            "no": "Nee",
            "search": "Zoeken",
            "selectTitle": "Selecteer bijlage(s) voor deze mail",
            "selected": "GESELECTEERD",
            "size": "GROOTTE",
            "updateFailed": "Het bijwerken van de e-mail is niet gelukt.",
            "updateFailedTitle": "Bijwerken mislukt",
            "upload": {
                "failed": "Upload (deels) mislukt",
                "manyUploaded": "De bijlages zijn geüploaded",
                "oneUploaded": "De bijlage is geüploaded",
                "upload": "Uploaden"
            },
            "yes": "Ja"
        },
        "cancelEmails": {
            "allCanceled": "Alle ingeplande e-mails zijn geannuleerd",
            "body": {
                "all": "alle",
                "keepOpen": "houd de Emails pagina open",
                "keepOpenPrefix": "Afhankelijk van het aantal ingeplande mails kan het annuleren een tijdje duren,",
                "keepOpenSuffix": "om zeker te zijn dat alle e-mails geannuleerd worden.",
                "middle": "ingeplande e-mails geannuleerd, zodat deze niet meer verzonden worden. Bijvoorbeeld wanneer de ingeplande e-mails een fout bevatten. Deze actie kan niet teruggedraaid worden en geannuleerde e-mails kunnen niet opnieuw ingepland worden.",
                "prefix": "Door de e-mails te annuleren worden"
            },
            "cancelBtn": "E-mails annuleren",
            "cancelFailed": "Het annuleren van de e-mails is niet gelukt.",
            "cancelFailedTitle": "Annuleren mislukt",
            "close": "Sluiten",
            "confirmCheckbox": "Ik bevestig dat alle e-mails geannuleerd moeten worden en begrijp dat dit niet teruggedraaid kan worden",
            "title": "E-mails annuleren"
        },
        "day": {
            "cancel": "Annuleren",
            "confirm": "Bevestigen",
            "onlyWorkDays": "Alleen werkdagen",
            "title": "Aangepast aantal dagen"
        },
        "flow": {
            "addEmail": "Voeg een mail toe aan de E-mail Volgorde",
            "autoMailOff": "Automatisch mailen uit",
            "autoMailOn": "Automatisch mailen aan",
            "bulkMailing": "Bulk mailing naar 30 dagen import...",
            "cancel": "Annuleren",
            "cancelPlanned": "Ingeplande e-mails annuleren…",
            "choose": "Kiezen",
            "click": "Klik",
            "copyFromAccount": "Kopiëren uit ander account...",
            "createFailed": "Het instellen van de e-mail is niet gelukt.",
            "createFailedTitle": "Instellen mislukt",
            "emailsTitle": "E-mails",
            "expectation-1": "Jouw reviews hebben tijd nodig om te groeien. In e-commerce laat gemiddeld 1 op de 40 klanten een review achter.\nMeer reviews geven meer bestellingen - geef dit vliegwiel de tijd om op gang te komen.",
            "expectation-trial": "Langer dan 30 dagen proef nodig? Mail ons.",
            "expectation-2": "Met slimme e-mailcontent kun je jouw conversie ratio flink verbeteren tot wel 1 review per 7 klanten.",
            "expectationLink": "Lees <1>hier</1> hoe.",
            "intro": "Automatiseer e-mails aan jouw klanten zodat je zonder handwerk meer reviews op bol behaalt en/of facturen verstuurt.",
            "label": {
                "creditInvoice": "Creditfactuur mail",
                "invoice": "Factuur mail",
                "other": "Overige mail",
                "product": "Productspecifieke mail",
                "review": "Review mail",
                "reviewInvoice": "Review + factuur mail"
            },
            "moreInfo": "Meer informatie",
            "noTrackingMessage": "Er worden geen open- en click-aantallen bijgehouden vanwege geen gebruik no-reply e-mailadres.",
            "off": "UIT",
            "on": "AAN",
            "open": "Open",
            "policy": "Deze method is in overeenstemming met het beleid van Bol",
            "policyLink": "beleidspunten",
            "policyWarnPrefix": "Je e-mails voldoen niet aan de",
            "policyWarnSuffix": "van Bol.",
            "search": "Zoeken",
            "searchEmails": "E-mails zoeken",
            "searchPlaceholder": "Zoek een e-mail",
            "sent": "Verstuurd",
            "status": "Status",
            "title": "Wat voor mail wil je toevoegen?",
            "copied": "De e-mails zijn gekopieerd",
            "copyFailedMsg": "Het kopiëren van de e-mails is niet gelukt.",
            "copyFailedTitle": "Kopiëren mislukt",
            "closeHistoryTitle": "Eenmalige mail optie sluiten",
            "closeHistoryIntro": "Wij bieden hier de optie om ook <1>eenmalig</1> de e-mails te versturen naar orders van de afgelopen 30 dagen.",
            "closeHistoryQuestion": "Weet je zeker dat je hier geen gebruik van wilt maken?",
            "closeHistoryConsequence": "Dan zal deze knop verdwijnen.",
            "closeHistoryHint": "Voor nieuwe orders kun je de e-mails laten inplannen door simpelweg rechtsboven de knop 'Automatisch mailen' op AAN te zetten.",
            "yesButton": "Ja",
            "noButton": "Nee",
            "policyFailBody1": "Je e-mails voldoen niet aan de beleidspunten van Bol. Er worden meerdere e-mails naar dezelfde klanten verzonden of de factuur is niet als bijlage ingesteld, volgens het beleid van Bol mag iedere klant maar één e-mail ontvangen en moet de factuur als bijlage worden toegevoegd.",
            "policyFailBody2": "De eenmalige e-mails kunnen alleen worden verzonden als er wordt voldaan aan de beleidspunten.",
            "policyFailBody3": "Pas je e-mails aan zodat er maar één mail per klant wordt verstuurd.",
            "policyFailTitle": "Beleidspunten",
            "enableMailingBody": "Zet eerst het automatisch mailen AAN zodat de e-mails ook zal worden verstuurd naar nieuwe orders.",
            "enableMailingTitle": "Zet mailen aan",
            "historyMailsIntro": "Wij bieden hier de optie om <1>eenmalig</1> de e-mails te versturen naar orders van de afgelopen 30 dagen.",
            "historyMailsThinkCarefully": "Denk goed na of de inhoud van jouw e-mail klopt. Deze actie is eenmalig uit te voeren en na uitvoeren verdwijnt deze knop voor altijd.",
            "historyMailsNewOrders": "Je kunt de e-mails laten inplannen voor <1>nieuwe orders</1> door simpelweg rechtsboven de knop 'Automatisch mailen' op AAN te zetten.",
            "historyMailsNowOn": "Dit heb je nu aan staan, dus deze mails zullen worden ingepland.",
            "historyMailsUnderstand": "Ik begrijp dat...",
            "historyMailsBullet1": "Deze actie eenmalig de e-mails verstuurt voor orders van de afgelopen 30 dagen.",
            "historyMailsBullet2": "Deze actie na akkoord niet terug te draaien is.",
            "historyMailsBullet3": "Voor nieuwe orders de e-mails worden ingepland zoals ingesteld als rechtsboven de automatische verzending van de e-mails op AAN staat.",
            "historyMailsTitle": "E-mails voor oude orders verzenden",
            "historyMailsConfirm": "Ja, ik begrijp het & verzenden",
            "scheduled": "De e-mails worden verzonden voor de orders van de afgelopen 30 dagen.",
            "scheduledTitle": "E-mails worden ingepland",
            "sendHistoryFailed": "Het verzenden van de e-mails voor de orders van de afgelopen 30 dagen is niet gelukt.",
            "sendHistoryFailedTitle": "Verzenden mislukt",
            "enableFailed": "Het inschakelen van de e-mail is niet gelukt.",
            "enableFailedTitle": "Inschakelen mislukt",
            "disableFailed": "Het uitschakelen van de e-mail is niet gelukt.",
            "disableFailedTitle": "Uitschakelen mislukt",
            "bolPolicyPrefix": "Eén of meer stappen voldoen niet aan het ",
            "bolPolicyLink": "beleid van Bol",
            "bolPolicySuffix": ". Wil je de automatische verzending van de e-mails toch activeren?",
            "bolPolicyTitle": "Bol beleid",
            "loadFailed": "Het laden van de e-mails is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "loadTemplatesFailed": "Het laden van de e-mail templates is niet gelukt.",
            "pauseToChangeMsg": "Pauzeer eerst <1>rechtsboven</1> het verzenden van mails om wijzingen door te voeren.",
            "pauseToChangeTitle": "Stap wijzigen",
            "importTitle": "E-mails importeren",
            "importAllFromAccount": "Alle e-mails uit een ander account ophalen.",
            "importWarningLabel": "Let op: ",
            "importWarningText": "alle huidige emails worden overschreven!",
            "importEansOnly": "Alleen bestaande EAN's worden meegenomen.",
            "pageChangeDeny": "Ja, verzending inschakelen",
            "pageChangeAllow": "Nee, pagina verlaten",
            "pageChangeTitle": "Automatische verzending e-mails",
            "pageChangeBody": "De automatische verzending van sommige e-mails is niet ingeschakeld, sommige e-mails worden dus niet automatisch verzonden. Wil je de automatische verzending van de e-mails inschakelen voordat je de pagina verlaat?",
            "crumb": "E-mails"
        },
        "flowErrors": {
            "enableFailedBody": "Het inschakelen is niet gelukt doordat de volgende problemen gevonden zijn:",
            "disableFailedBody": "Het uitschakelen is niet gelukt doordat de volgende problemen gevonden zijn:"
        },
        "unsubscribe": {
            "failedMsg": "Het uitschrijven van de maandelijkse e-mail is niet gelukt.",
            "loading": "Je wordt uitgeschreven van de maandelijkse e-mail...",
            "successMsg": "Je bent succesvol uitgeschreven van de maandelijkse e-mail.",
            "title": "Uitschrijven van maandelijkse e-mail"
        },
        "importProducts": {
            "close": "Sluiten",
            "descriptionPrefix": "Je kunt in één keer al je producten koppelen aan de juiste e-mails met deze optie. Maak hiervoor gebruik van ons",
            "descriptionSuffix": "Let op, reeds gekoppelde producten worden hierbij overschreven.",
            "errorsFound": "Tijdens het importeren zijn er fouten gevonden in het importbestand, de producten zijn niet gekoppeld. De volgende fouten zijn gevonden:",
            "importFile": "importbestand",
            "link": "Producten koppelen",
            "linkFailed": "Het koppelen van de producten is niet gelukt.",
            "linkFailedTitle": "Koppelen mislukt",
            "linked": "De producten zijn succesvol gekoppeld",
            "row": "Regel",
            "title": "Bulk producten koppelen",
            "xlsxOnly": "Alleen Excel (XLSX) bestanden kunnen geïmporteerd worden."
        },
        "stats": {
            "adjustPeriod": "Periode aanpassen",
            "avgCtrPrefix": "In 2021 was wereldwijd de gemiddelde klik rate",
            "avgCtrSuffix": "% voor marketing mails.",
            "display": "Weergave",
            "head": {
                "date": "Datum",
                "month": "Maand",
                "quarter": "Kwartaal",
                "week": "Week",
                "year": "Jaar"
            },
            "loadFailed": "Het laden van de statistieken is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "mailsOpened": "Aantal mails geopend",
            "mailsSent": "Aantal mails verzonden",
            "reviewLinksClicked": "Aantal reviewlinks geklikt",
            "splitMethod": {
                "day": "Per dag",
                "month": "Per maand",
                "quarter": "Per kwartaal",
                "week": "Per week",
                "year": "Per jaar"
            },
            "title": "E-mail statistieken"
        },
        "step": {
            "actionEnabled": "ingeschakeld",
            "actionPaused": "gepauzeerd",
            "after": "Na",
            "allCountries": "Alle landen",
            "countries": "landen",
            "delete": "Verwijderen",
            "deleteConfirm": "Weet je zeker dat je deze e-mail wilt verwijderen?",
            "deleteFailed": "Het verwijderen van de stap is niet gelukt.",
            "deleteFailedTitle": "Verwijderen mislukt",
            "deleteTitle": "E-mail verwijderen",
            "deleted": "De e-mail is verwijderd",
            "editContent": "Inhoud wijzigen",
            "editName": "Naam wijzigen",
            "emailIs": "De e-mail is",
            "emailUpdated": "De e-mail is bijgewerkt",
            "enableSending": "Zending inschakelen",
            "for": "voor",
            "fulfilment": {
                "both": "Alle logistiek",
                "fbb": "LVB",
                "fbr": "Eigen logistiek"
            },
            "in": "in",
            "mailWithAttachment": "mail met bijlage",
            "moreInfo": "Meer informatie",
            "new": "Nieuw",
            "no": "Nee",
            "noTemplate": "Je hebt nog geen e-mail template gekozen.",
            "overlapError": "Er wordt al een andere e-mail naar deze klanten verzonden. Stuur maximaal 1 mail per 1 order.",
            "pauseSending": "Zending pauzeren",
            "pausedSuffix": "(gepauzeerd)",
            "send": "stuur",
            "stat": {
                "click": "Klik",
                "open": "Open",
                "sent": "Verstuurd"
            },
            "statsFailed": "Het laden van de statistieken is niet gelukt.",
            "statsFailedTitle": "Laden mislukt",
            "statsOff": "Statistieken staan uit...",
            "testMailFailed": "Het verzenden van de testmail is niet gelukt.",
            "testMailFailedTitle": "Verzenden mislukt",
            "testMailSent": "De testmail is verzonden",
            "testSend": "Test verzenden",
            "to": "naar",
            "updateFailed": "Het bijwerken van de e-mail is niet gelukt.",
            "updateFailedTitle": "Bijwerken mislukt",
            "updating": "bijwerken",
            "via": "via",
            "yes": "Ja"
        },
        "template": {
            "editor": {
                "bccInfo": "E-mailadressen toevoegen in BCC? Voor de veiligheid vraag je dit bij onze support aan.",
                "bccInvalid": "Het BCC adres is niet geldig",
                "cancel": "Annuleren",
                "leavePage": "Nee, pagina verlaten",
                "leavePageWarn": "De wijzigingen gaan verloren als je de pagina verlaat. Wil je de wijzigingen eerst opslaan?",
                "logoPlaceholderWarn": "De e-mail bevat nog placeholder afbeeldingen van het logo van Bluemate. Vervang deze met jouw eigen logo of verwijder de afbeelding.",
                "personPlaceholderWarn": "De e-mail bevat nog placeholder afbeeldingen van personen. Vervang deze met jouw eigen foto of verwijder de afbeelding.",
                "policy": "Beleidspunten:",
                "policyCheck": "Check of jouw mail voldoet aan het beleid van Bol",
                "preview": "Preview",
                "productReview": "Product Review",
                "replyTo": "Antwoordadres",
                "replyToPlaceholder": "Antwoordadres",
                "reset": "Reset",
                "saveChanges": "Ja, wijzigingen opslaan",
                "saveExit": "Opslaan & Exit",
                "saveFailed": "Het opslaan van de e-mail template is niet gelukt.",
                "saveFailedTitle": "Opslaan mislukt",
                "saved": "De e-mail template is opgeslagen",
                "shiftEnterTip": "Tip: gebruik SHIFT + ENTER om een nieuwe regel toe te voegen zonder extra ruimte.",
                "subject": "Onderwerp",
                "templateName": "Naam template",
                "testMailFailed": "Het verzenden van de testmail is niet gelukt.",
                "testMailFailedTitle": "Verzenden mislukt",
                "testMailSent": "De testmail is verzonden",
                "testSend": "Test verzenden",
                "tipsTitle": "Tips voor een effectieve e-mail:",
                "updateFailed": "Het bijwerken van de e-mail template is niet gelukt.",
                "updateFailedTitle": "Bijwerken mislukt",
                "updated": "De e-mail template is bijgewerkt",
                "var": {
                    "client": "Klant",
                    "company": "Bedrijf",
                    "invoice": "Factuur",
                    "leaveReview": "Laat hier je review achter",
                    "productImage": "Product Afbeelding",
                    "productImageUrl": "Product Afbeelding URL",
                    "productReviewLink": "Product Review Link",
                    "productSubtitle": "Product Subtitle",
                    "productTitle": "Product Naam",
                    "productUrl": "Product Review URL",
                    "reviewLinks": "Review Links"
                },
                "variables": "Variabelen"
            },
            "preview": {
                "bcc": "BCC",
                "done": "Klaar",
                "reviewLinks": "Review Links",
                "subject": "Onderwerp",
                "title": "Preview"
            },
            "tips": {
                "bluemateLogo": "Maak het eigen: Gebruik je bedrijfslogo in plaats van het Bluemate-logo.",
                "companyEmail": "Het is niet toegestaan om een e-mailadres van jouw bedrijf in de mail te plaatsen.",
                "goldenStar": "Het gebruik van ster emojis wordt door bol niet meer toegestaan. Verwijder deze",
                "honestReview": "Je gebruikt een knop naar de review pagina, maar verzoekt niet letterlijk om een \"eerlijke review\".",
                "stockPhoto": "Vervang de stockfoto: Uit ons onderzoek blijkt dat persoonlijke foto's van jou\n of je team zorgen voor een hogere kans op reviews."
            }
        },
        "templateSelect": {
            "cancel": "Annuleren",
            "choose": "Kiezen",
            "chooseAnyway": "Toch kiezen",
            "chooseEdit": "Kiezen & Aanpassen",
            "conversionTip": "Conversietip: Voeg persoonlijke foto's toe om je te benadrukken als kleine ondernemer; dit vergroot de kans op reviews.",
            "copied": "De template is gekopieerd",
            "copy": "Kopiëren",
            "copyFailed": "Het kopiëren van de template is niet gelukt.",
            "copyFailedTitle": "Kopiëren mislukt",
            "currentSuffix": "(huidig)",
            "delete": "Verwijderen",
            "deleteConfirm": "Weet je zeker dat je deze template wil verwijderen?",
            "deleteFailed": "Het verwijderen van de E-mail Template is niet gelukt.",
            "deleteFailedTitle": "Verwijderen mislukt",
            "deleteTitle": "Template verwijderen",
            "deleted": "De E-mail Template is verwijderd",
            "description": "Je kunt een template kiezen, aanpassen en voorvertonen.",
            "edit": "Aanpassen",
            "emailTitle": "EMAIL TITEL",
            "emailUpdated": "De e-mail is bijgewerkt",
            "inUseTitle": "Template al in gebruik",
            "inUseWarning": "Deze template wordt ook al gebruikt in andere e-mailflows. Wijzigingen die je hier aanbrengt, worden ook doorgevoerd in die flows. Wil je dit niet? Maak dan een kopie van het template.",
            "lastUpdated": "LAATST BIJGEWERKT",
            "loadDefaultsFailed": "Het laden van de standaard templates is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "loadTemplatesFailed": "Het laden van de e-mail templates is niet gelukt.",
            "newTemplate": "+ Nieuwe E-mail Template maken",
            "newTemplateName": "Nieuwe E-mail Template",
            "newTemplateSubject": "Over jouw bestelling {order_id} van {bedrijf_naam} via Bol",
            "no": "Nee",
            "preview": "Preview",
            "readMore": "Lees meer",
            "sharedBanner": "Let op: Wijzigingen aan een opgeslagen template gelden voor alle e-mailflows die deze template gebruiken. Wil je dit niet, dupliceer dan het template of maak een nieuwe.",
            "showAll": "Alle templates tonen",
            "showSpecific": "Specifieke templates tonen",
            "startEmpty": "Begin leeg",
            "tab": {
                "custom": "Opgeslagen Templates",
                "default": "Template Layouts"
            },
            "title": "Kies jouw E-mail Template",
            "updateFailed": "Het bijwerken van de e-mail is niet gelukt.",
            "updateFailedTitle": "Bijwerken mislukt",
            "view": "Bekijken",
            "yes": "Ja"
        },
        "test": {
            "cancel": "Annuleren",
            "cannotChange": "Vanwege veiligheid is het niet mogelijk dit e-mailadres aan te passen.",
            "invalidEmail": "Vul een geldig e-mailadres in",
            "send": "Verzenden",
            "sendTo": "De test e-mail wordt verzonden naar:",
            "title": "Test notificatie verzenden",
            "emailSection": "E-mail",
            "pushSection": "Push-melding",
            "pushSendTo": "Push-melding wordt ook verzonden naar:"
        }
    },
    "header": {
        "demoAccount": "Dit is een demo account",
        "demoButton": "Nu Registeren",
        "demoSub": "Nu gratis 30 dagen proberen? Geen betaalmethode nodig. Koppel nu jouw eigen bol accounts.",
        "logoutFailed": "Uitloggen mislukt",
        "logoutFailedMessage": "Het uitloggen is niet gelukt.",
        "trialButton": "Abonnement starten...",
        "trialEnded": "Je proefperiode is verlopen",
        "trialSub_one": "Nog {{count}} dag proef te gaan. Als je nu een abonnement start, worden de resterende gratis dagen eerst opgemaakt.",
        "trialSub_other": "Nog {{count}} dagen proef te gaan. Als je nu een abonnement start, worden de resterende gratis dagen eerst opgemaakt.",
        "trialTitle": "Nu abonnement starten?",
        "salesAccount": "Verkoopaccount",
        "signOut": "Uitloggen"
    },
    "history": {
        "action": {
            "create": "Factuur aangemaakt",
            "download": "Factuur gedownload",
            "orderPlaced": "Bestelling geplaatst",
            "orderSent": "Bestelling verzonden",
            "send": "Factuur verzonden",
            "sendOther": "Factuur specifieke mail verzonden",
            "sendProduct": "Specifieke productmail verzonden",
            "sendReview": "Review request verzonden",
            "update": "Factuur bijgewerkt"
        },
        "actionBy": {
            "system": "Systeem",
            "unknown": "Onbekend"
        }
    },
    "invoice": {
        "credit": {
            "andToCreditInvoice": "en naar creditfactuur",
            "col": {
                "ean": "EAN",
                "name": "NAAM",
                "priceIncl": "PRIJS INCL. BTW",
                "quantity": "AANTAL",
                "subtotalIncl": "SUBTOTAAL INCL. BTW",
                "vat": "BTW"
            },
            "create": "Aanmaken",
            "createFailed": "Het aanmaken van de creditfactuur is niet gelukt.",
            "createFailedTitle": "Aanmaken mislukt",
            "createdSuccess": "De credifactuur is aangemaakt",
            "errorFillVatOrPrice": "Vul minimaal het BTW bedrag of de prijs in in",
            "errorPriceTooHigh": "De prijs kan niet hoger zijn dan de originele prijs",
            "errorQuantityMin": "Het aantal moet minimaal 1 zijn",
            "errorQuantityTooHigh": "Het aantal kan niet hoger zijn dan het originele aantal",
            "itemsHeader": "Te Crediteren Productregels",
            "loadFailed": "Het laden van de factuur is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "percentage": "Percentage",
            "price": "Prijs",
            "quantity": "Aantal",
            "updateFailed": "Het wijzigen van de creditfactuur is niet gelukt.",
            "updateFailedTitle": "Wijzigen mislukt",
            "updatedSuccess": "De credifactuur is gewijzigd",
            "vat": "BTW"
        },
        "data": {
            "address": "Adres",
            "city": "Stad",
            "cocNumber": "KvK-nummer",
            "cocPh": "KvK nummer",
            "company": "Bedrijf",
            "email": "E-mailadres",
            "emailDisabled": "Vanwege veiligheid niet aan te passen. Je kunt de factuur downloaden en handmatig zelf mailen.",
            "firstName": "Voornaam",
            "houseNumber": "Huisnummer",
            "lastName": "Achternaam",
            "order": "order",
            "reference": "Referentie",
            "suffix": "Toevoeging",
            "title": "Factuurgegevens",
            "vatNumber": "BTW-nummer",
            "vatPh": "BTW nummer",
            "zipCode": "Postcode"
        },
        "details": {
            "address": "Adres",
            "back": "Terug",
            "cocLabel": "KvK nummer",
            "col": {
                "name": "NAAM",
                "priceExcl": "PRIJS excl. BTW",
                "quantity": "AANTAL",
                "totalExcl": "TOTAAL excl. BTW",
                "vat": "BTW"
            },
            "company": "Bedrijf",
            "creditInvoice": "Creditfactuur",
            "crumbs": {
                "invoices": "Facturen",
                "order": "Order"
            },
            "customer": "Klant",
            "download": "Downloaden",
            "downloadFailed": "Het downloaden van de factuur is niet gelukt.",
            "downloadFailedTitle": "Downloaden mislukt",
            "edit": "Wijzigen",
            "emailLabel": "E-mailadres",
            "invoice": "Factuur",
            "invoiceDate": "Factuurdatum",
            "invoiceNo": "Factuur nr.",
            "items": "Artikelen",
            "name": "Naam",
            "orderNo": "Order nr.",
            "orderPlaced": "Bestelling geplaatst",
            "preview": "Voorbeeld",
            "products": "Producten",
            "recentActivity": "Recente activiteit",
            "send": "Verzenden",
            "sendFailed": "Er is iets misgegaan bij het verzenden van de factuur.",
            "sendFailedTitle": "Verzenden mislukt",
            "sendSuccess": "De factuur is succesvol verstuurd",
            "sending": "De factuur wordt verstuurd...",
            "showAll": "Volledige historie weergeven",
            "showLess": "Minder historie weergeven",
            "status": "Status",
            "title": "Details",
            "total": "Totaal",
            "totalExcl": "Totaal excl. BTW",
            "totalIncl": "Totaal incl. BTW",
            "vatCombi": "Combi.",
            "vatLabel": "BTW nummer",
            "vatLine": "BTW",
            "vatMargin": "Marge",
            "vatReversed": "verlegd",
            "vatReversedFull": "BTW verlegd"
        },
        "edit": {
            "col": {
                "ean": "EAN",
                "name": "NAAM",
                "price": "PRIJS",
                "quantity": "AANTAL",
                "reference": "REFERENTIE",
                "vat": "BTW"
            },
            "itemLabel": {
                "reference": "Referentie",
                "name": "Naam",
                "price": "Prijs",
                "quantity": "Aantal",
                "vat": "BTW"
            },
            "crumbs": {
                "editInvoice": "Factuur wijzigen",
                "invoices": "Facturen",
                "order": "Order"
            },
            "download": "downloaden",
            "downloadFailed": "Het downloaden van de factuur is niet gelukt.",
            "downloadFailedTitle": "Downloaden mislukt",
            "downloadInvoice": "Factuur downloaden",
            "emailNotAvailableAfter": "en deze via het Bol-platform te verzenden naar de klant.",
            "emailNotAvailableBefore": "Het originele e-mailadres van de klant is niet meer beschikbaar voor Bluemate. We raden aan om de factuur te",
            "errorPrice": "Vul de prijs in",
            "errorQuantity": "Vul het aantal in",
            "errorTitle": "Vul de naam in",
            "invoiceLines": "Factuurregels",
            "mailSendFailed": "Het verzenden van de mail is niet gelukt.",
            "save": "Opslaan",
            "sendConfirmBody": "Wil je de gewijzigde factuur direct verzenden?",
            "sendConfirmTitle": "Factuur verzenden",
            "sendFailedTitle": "Verzenden mislukt",
            "sentSuccess": "De factuur is verzonden",
            "unsavedBody": "De factuur is gewijzigd, wil je de wijzigingen opslaan?",
            "unsavedTitle": "Factuur gewijzigd",
            "updateFailed": "Het bijwerken van de factuur is niet gelukt.",
            "updateFailedTitle": "Bijwerken mislukt",
            "updateSuccess": "De factuur is bijgewerkt",
            "yesSend": "Ja, verzenden"
        },
        "peppol": {
            "col": {
                "actions": "ACTIES",
                "amount": "BEDRAG",
                "date": "DATUM",
                "invoiceNumber": "FACTUURNUMMER",
                "name": "NAAM",
                "orderNumber": "ORDERNUMMER",
                "status": "STATUS"
            },
            "copied": "gekopieerd",
            "costsPer": "KOSTEN €0,20 PER E-FACTUUR",
            "disable": "uitschakelen",
            "downloadFailed": "Het downloaden van de factuur is niet gelukt.",
            "downloadFailedTitle": "Downloaden mislukt",
            "enable": "inschakelen",
            "failedSuffix": "mislukt",
            "info": {
                "afterRegistration": "Zodra jouw Peppol registratie gelukt is, kun je de Peppol-integratie inschakelen. Wij halen automatisch jouw geregistreerde Peppol ID op en gebruiken deze om jouw e-facturen te verzenden.",
                "costsBody": "Het verzenden van e-facturen via het Peppol netwerk kost €0,20 per e-factuur. Alleen facturen voor Belgische zakelijke klanten (met BTW-nummer) worden via Peppol verzonden, dit is gemiddeld 0-1% van de orders.",
                "costsTitle": "Kosten",
                "from": "Vanaf",
                "haveRegistrationAfter": ") voor het versturen van de e-facturen via het Peppol netwerk.",
                "haveRegistrationBefore": "Je hebt al een Peppol registratie voor jouw BTW-nummer. We gebruiken jouw Peppol ID (",
                "integration": "Je kunt hiervoor gebruik maken van onze Peppol-integratie, waarmee je volledig automatisch jouw zakelijke e-facturen via het Peppol netwerk kunt verzenden.",
                "mandatoryDate": "1 januari 2026 is het verplicht om als Belgische verkoper de factuur voor zakelijke Belgische orders via het Peppol netwerk te verzenden.",
                "needRegistration": "Het enige wat je hier zelf voor hoeft te regelen is de Peppol registratie van jouw BTW/KBO-nummer. Je kunt dit doen bij een Peppol provider.",
                "registrationTitle": "Peppol registratie",
                "since": "Sinds",
                "title": "E-facturen verzenden via Peppol"
            },
            "last30Days": "AFGELOPEN 30 DAGEN",
            "listTitle": "Peppol e-facturen (voor Belgische zakelijke klanten)",
            "loadFailed": "Het laden van de facturen is niet gelukt.",
            "loadFailedTitle": "Facturen laden mislukt",
            "searchLabel": "Factuur zoeken",
            "searchPlaceholder": "Zoek op ordernummer",
            "sendFailed": "Het verzenden van de factuur via Peppol is niet gelukt.",
            "sendFailedTitle": "Verzending mislukt",
            "sendSuccess": "De factuur is verzonden naar de klant",
            "stat": {
                "delivered": "Peppol e-facturen afgeleverd",
                "failed": "Peppol e-facturen mislukt"
            },
            "state": {
                "all": "Alle",
                "error": "Fout bij verzending",
                "failed": "Verzending mislukt",
                "notSent": "Nog niet verzonden",
                "notSentInfo": "De e-factuur is nog niet verzonden naar de klant",
                "sent": "Afgeleverd",
                "transit": "Verzonden",
                "transitInfo": "De e-factuur is onderweg naar de klant"
            },
            "status": {
                "linked": "Gekoppeld aan Peppol",
                "notLinked": "Niet gekoppeld aan Peppol",
                "notSending": "Peppol B2B e-facturen worden niet verzonden",
                "sending": "Peppol B2B e-facturen worden verzonden"
            },
            "toggleFailedPrefix": "Het",
            "toggleFailedSuffix": "van Peppol is niet gelukt.",
            "totalCosts": "TOTALE KOSTEN",
            "usePeppol": "Peppol gebruiken"
        },
        "request": {
            "allSelected": "Alle aanvragen geselecteerd",
            "archive": "Archiveren",
            "archiveConfirm": "Weet je zeker dat je deze aanvraag wilt archiveren? De aanvraag zal niet meer getoond worden. Deze actie kan niet ongedaan gemaakt worden.",
            "archiveFailed": "Het archiveren van de aanvraag is niet gelukt.",
            "archiveFailedTitle": "Archiveren mislukt",
            "archiveTitle": "Aanvraag archiveren",
            "archivedSuccess": "De aanvraag is gearchiveerd",
            "bulkUploadFailed": "Het uploaden van één of meer facturen is niet gelukt.",
            "bulkUploading": "De facturen worden naar Bol geüpload",
            "col": {
                "orderNumber": "ORDERNUMMER",
                "requestDate": "AANVRAAGDATUM",
                "status": "STATUS",
                "type": "TYPE",
                "uploadedOn": "GEÜPLOAD OP"
            },
            "confirmTitle": "Bevestigen",
            "copiedToClipboard": "gekopieerd",
            "createInvoice": "Factuur aanmaken...",
            "customerType": {
                "business": "Zakelijk",
                "private": "Particulier"
            },
            "data": {
                "city": "Woonplaats",
                "cocNumber": "KvK-nummer",
                "companyName": "Bedrijfsnaam",
                "country": "Land",
                "createAndUpload": "Factuur aanmaken & uploaden",
                "createInvoice": "Factuur aanmaken",
                "errAddress": "Vul het adres in",
                "errCity": "Vul de woonplaats in",
                "errFirstName": "Vul de voornaam in",
                "errHouseNumber": "Vul het huisnummer in",
                "errInvoiceNumber": "Vul het factuurnummer in",
                "errLastName": "Vul de achternaam in",
                "errPrefix": "Vul het voorvoegsel in",
                "errZipCode": "Vul de postcode in",
                "firstName": "Voornaam",
                "houseNumber": "Huisnummer",
                "invoiceNumber": "Factuurnummer",
                "lastFilled": "Laatste keer vulde je in:",
                "lastName": "Achternaam",
                "optional": "optioneel",
                "popupTitle": "Handmatig factuur aanmaken voor order",
                "prefix": "Voorvoegsel",
                "prefixPh": "{jaar}oud-",
                "saveFailed": "Het opslaan van de factuurgegevens is mislukt.",
                "saveFailedTitle": "Opslaan mislukt",
                "savedSuccess": "De factuurgegevens zijn opgeslagen",
                "setNumFailed": "Het instellen van het factuurnummer is niet gelukt.",
                "setNumFailedTitle": "Factuurnummer instellen mislukt",
                "step1Body": "Kies een factuurnummer voor deze factuur. Het factuurnummer mag niet eerder gebruikt zijn en de facturen moeten met oplopende factuurnummers genummerd worden. Lees hierboven waarom.",
                "step1Title": "1) Kies factuurnummer",
                "step2Body": "Deze gegevens zijn ingevuld bij de factuuraanvraag en worden gebruikt voor op de factuur. Je kunt deze nog aanpassen voordat de factuur aangemaakt wordt.",
                "step2Title": "2) Controleer factuurgegevens en vul aan",
                "street": "Straat",
                "vatNumber": "BTW-nummer",
                "whyManualBody": "Deze factuur is waarschijnlijk van voor gebruik Bluemate. We krijgen hierbij (vanwege de AVG) waarschijnlijk niet alle klantgegevens. Deze moet je zelf daarom handmatig nog aanvullen. Doordat de Belastingdienst vereist dat jouw factuurnummering chronologisch oploopt, kunnen we hiervoor niet het standaard factuurnummer gebruiken.",
                "whyManualTitle": "Waarom moet ik dit handmatig doen?",
                "zipCode": "Postcode"
            },
            "download": "Downloaden",
            "downloadFailed": "Het downloaden van de factuur is niet gelukt.",
            "downloadFailedTitle": "Downloaden mislukt",
            "edit": "Wijzigen...",
            "empty": "- Geen factuuraanvragen gevonden -",
            "fetchOrderFailed": "Er is iets misgegaan bij het ophalen van de order.",
            "fetchOrderFailedTitle": "Order ophalen mislukt",
            "loadFailed": "Het laden van de factuuraanvragen is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "orderNotFoundBody": "We konden geen order vinden voor deze aanvraag. Dit betekent zeer waarschijnlijk dat het gaat om een order die ouder is dan twee jaar. Doordat bol geen gegevens geeft voor orders dan twee jaar, kunnen wij deze aanvraag niet voor je verwerken.",
            "orderNotFoundTitle": "Order niet gevonden",
            "orderNumber": "Ordernummer",
            "paginationOf": "van",
            "paginationTo": "t/m",
            "preview": "Voorbeeld",
            "requestPlural": "aanvragen",
            "requestSingular": "aanvraag",
            "searchLabel": "Aanvraag zoeken",
            "searchPlaceholder": "Ordernummer, verzendnummer of klantnummer",
            "selected": "geselecteerd",
            "somethingWrong": "Er is iets misgegaan.",
            "status": {
                "closed": "Gesloten",
                "failed": "Mislukt",
                "open": "Open"
            },
            "tab": {
                "requests": "Aanvragen",
                "settings": "Instellingen"
            },
            "title": "Factuuraanvragen",
            "upload": "Uploaden",
            "uploadAllConfirm": "Hiermee worden de facturen voor alle openstaande factuuraanvragen geüpload. Weet je zeker dat je door wilt gaan?",
            "uploadFailed": "Het uploaden van de factuur is niet gelukt.",
            "uploadFailedTitle": "Uploaden mislukt",
            "uploadingSuccess": "De factuur wordt geüpload naar Bol"
        },
        "send": {
            "attachment": "Bijlage:",
            "customer": "Klant:",
            "disclaimer": "Voor deze e-mail worden niet de instellingen van de E-mails pagina gebruikt.",
            "download": "downloaden",
            "emailNotAvailableAfter": "en deze via het Bol-platform te verzenden naar de klant.",
            "emailNotAvailableBefore": "Het originele e-mailadres van de klant is niet meer beschikbaar voor Bluemate. We raden aan om de factuur te",
            "errorSubject": "Vul het onderwerp in",
            "errorText": "Vul de tekst van de e-mail in",
            "failedTitle": "Verzenden mislukt",
            "invoiceDate": "Factuurdatum:",
            "invoiceNumNotSet": "Deze factuur heeft nog geen factuurnummer en kan daarom niet verzonden worden. Het systeem kan geen factuurnummer bepalen voor orders die ouder zijn dan jouw Bluemate account. Voor deze orders dien je dus zelf het factuurnummer in te stellen.",
            "invoiceNumNotSetPlural": "heeft nog geen factuurnummer en kan daarom niet verzonden worden. Het systeem kan geen factuurnummer bepalen voor orders die ouder zijn dan jouw Bluemate account. Voor deze orders dien je dus zelf het factuurnummer in te stellen.",
            "invoiceNumber": "Factuurnummer:",
            "orderNumber": "Ordernummer:",
            "orderPrefix": "Order",
            "send": "Verzenden",
            "sendFailed": "Het verzenden van de factuur is niet gelukt.",
            "sentSuccess": "De factuur is verzonden",
            "setInvoiceNumTitle": "Factuurnummer instellen",
            "subjectPlaceholder": "Onderwerp van de e-mail",
            "subjectPrefix": "Factuur voor bestelling",
            "subjectRequired": "Onderwerp *",
            "title": "Factuur verzenden"
        },
        "status": {
            "uploaded": "Factuur geüpload",
            "placed": "Order geplaatst",
            "canceled": "Order geannuleerd",
            "orderSent": "Order verzonden",
            "error": "Fout op factuur",
            "scheduled": "Factuur nog niet verzonden",
            "notSent": "Factuur niet verzonden",
            "sent": "Factuur verzonden",
            "warning": "Waarschuwing",
            "transport": "Factuur wordt verstuurd"
        }
    },
    "invoiceUploadSettings": {
        "autoRespond": "Auto aanvragen beantwoorden",
        "autoRespondInfo": "Indien de factuur van een order nog niet is geüpload, kan een klant de factuur aanvragen. Met deze optie wordt er automatisch gereageerd op deze aanvraag met de bijbehorende factuur. Door ook de optie proactief uploaden aan te vinken, zorg je ervoor dat er steeds minder van dit soort aanvragen zijn, omdat de factuur al klaar zal staan en men deze niet meer aanvraagt.",
        "autoRespondTitle": "Automatisch aanvragen beantwoorden",
        "autoUpload": "Automatisch uploaden",
        "deleteRuleConfirm": "Weet je zeker dat je deze regel wilt verwijderen?",
        "deleteRuleTitle": "Regel verwijderen",
        "notify": {
            "desc1": "Stuur mij een e-mail notificatie als een nieuwe factuuraanvraag niet automatisch beantwoord kan worden.",
            "desc2": "Bijvoorbeeld omdat de factuur niet in de Bluemate database zit, als de order van vóór begin gebruik Bluemate is.",
            "emailLabel": "Notificatie e-mailadres",
            "title": "Notificatie e-mail bij vereiste handmatige actie",
            "toggle": "Stuur mij een e-mail notificatie"
        },
        "oldOrders": {
            "infoLine1": "Jouw klanten kunnen voor orders tot 2 jaar terug een factuur aanvragen. Het is mogelijk dat wij deze order niet in het systeem hebben, omdat jouw Bluemate account toen nog niet bestond.",
            "infoLine2": "We kunnen deze factuuraanvraag wel automatisch beantwoorden met een factuur upload, maar doordat de Belastingdienst vereist dat jouw factuurnummering chronologisch oploopt, kunnen we hiervoor niet het standaard factuurnummer gebruiken.",
            "infoLine3": "Je kunt daarom een andere factuurnummerreeks kiezen voor de facturen voor oude orders, op deze manier blijven de nummers chronologisch oplopend.",
            "infoTitle": "Factuuraanvragen voor oude orders",
            "invoiceNumTitle": "Factuurnummer voor oude orders",
            "prefix": "Voorvoegsel",
            "startWith": "Starten met",
            "toggleLabel": "Auto aanvragen beantwoorden voor oude orders"
        },
        "proactiveInfo": "Met proactief uploaden zorg je ervoor dat voor elke nieuwe order, de factuur na voltooiing van order wordt geüpload. Klanten kunnen de btw-factuur dan vinden en downloaden in hun Bol klantportaal. Zo voorkom je factuuraanvragen.",
        "proactiveUpload": "Proactief uploaden",
        "recommended": "Aanbevolen",
        "recommendedInfo": "Wij raden aan zowel proactief uploaden als automatisch beantwoorden aan te vinken.",
        "rule": {
            "allCountries": "Alle landen",
            "autoUploadFor": "automatisch uploaden voor",
            "countries": "landen",
            "in": "in"
        },
        "ruleType": {
            "not": "Niet",
            "only": "Alleen"
        },
        "rules": {
            "addRule": "Regel toevoegen",
            "description": "Facturen worden alleen automatisch geüpload als aan deze voorwaarde wordt voldaan.",
            "title": "Alleen uploaden bij bepaalde voorwaarde"
        },
        "sameAsTopRight": "Dezelfde instellingen als rechtsboven",
        "save": "Opslaan",
        "saveFailed": "Het opslaan van de instellingen is niet gelukt.",
        "saveFailedTitle": "Instellingen opslaan mislukt",
        "savedSuccess": "De instellingen zijn opgeslagen"
    },
    "maintenance": {
        "backToWebsite": "Terug naar de website",
        "invalidPassword": "Ongeldig wachtwoord",
        "message": "Bluemate wordt momenteel bijgewerkt naar de nieuwste versie, u kunt daarom tijdelijk geen gebruik maken van Bluemate. We doen ons best om de update zo spoedig mogelijk uit te voeren. Excuses voor het ongemak.",
        "password": "Wachtwoord",
        "title": "Onderhoud"
    },
    "mcpServer": {
        "crumb": "Agent MCP",
        "eyebrow": "MCP Server",
        "title": "Verbind jouw eigen AI met bol en Bluemate data",
        "intro": "Geef je AI-assistent, zoals ChatGPT of Claude, toegang tot Bluemate en bol.",
        "introDiscover": "Stel vragen en krijg antwoorden via deze MCP verbinding.",
        "installButton": "Lees hoe te installeren",
        "featuresTitle": "Wat kan je ermee?",
        "featureAskTitle": "Vraag het gewoon",
        "featureAskText": "Stel je vraag in gewone taal. Je AI assistent gebruikt de tools in de MCP om het antwoord te vinden.",
        "featureSafeTitle": "Toegang & Veilig",
        "featureSafeText": "Je kiest zelf welke rechten de agent heeft. Bijvoorbeeld alleen-lezen, zodat de agent geen wijzigingen kan maken.",
        "featureClientsTitle": "Werkt met elke AI",
        "featureClientsText": "Claude, ChatGPT, Gemini, Cursor en elke andere AI-assistent die MCP ondersteunt.",
        "examplesTitle": "Voorbeeld van vragen",
        "chat": {
            "monthQuestion": "Hoe ging afgelopen maand?",
            "monthIntro": "September was een goede maand. Je omzet steeg met <0>12%</0> ten opzichte van augustus.",
            "monthColCurrent": "September",
            "monthColPrevious": "Augustus",
            "monthColDiff": "Verschil",
            "monthRowRevenue": "Omzet (incl. btw)",
            "monthRowOrders": "Orders",
            "monthRowAverage": "Gem. orderwaarde",
            "monthRowAds": "Ad spend",
            "monthRowReturns": "Retouren",
            "monthFollowUp": "Wil je dat ik de retourredenen van de braadpan verder uitzoek?",
            "returnsQuestion": "Welke producten worden het vaakst geretourneerd?",
            "returnsIntro": "Dit zijn je meest geretourneerde producten van de afgelopen 12 maanden:",
            "returnsColProduct": "Product",
            "returnsColReturns": "Retouren",
            "returnsFollowUp": "De braadpan wordt het vaakst teruggestuurd. Wil je de retourredenen zien?",
            "seoQuestion": "Hoe kan ik mijn product verbeteren voor SEO?",
            "seoIntro": "Je titel voor de <0>braadpan</0> is Engels en mist de zoekwoorden waar klanten op bol.com op zoeken.",
            "seoCurrent": "<0>Nu:</0> Enamel Cast Iron Casserole 4.2L - Red",
            "seoBetter": "<0>Beter:</0> Gietijzeren braadpan 4,2 L – Dutch oven – Inductie – Rood",
            "seoColKeyword": "Belangrijkste zoekwoorden",
            "seoColVolume": "Zoekvolume / mnd",
            "seoColInTitle": "Nu in titel",
            "seoFollowUp": "De nieuwe titel bevat de 3 grootste zoekwoorden, met \"braadpan\" vooraan. Wil je dat ik ook de beschrijving verbeter?",
            "yes": "Ja",
            "no": "Nee"
        },
        "chatDisclaimer": "Voorbeeldgesprekken met geanonimiseerde demo-data.",
        "bottomTitle": "Verbind je AI-assistent met Bluemate",
        "bottomText": "Open de MCP-pagina voor installatie-instructies per assistent en een overzicht van alle beschikbare tools.",
        "bottomButton": "Open de MCP-pagina"
    },
    "menu": {
        "admin": "Admin",
        "apiConnection": "Koppeling",
        "chromeExtension": "Chrome Extensie",
        "common": "Algemeen",
        "cron": "Cron",
        "defaultTemplates": "Standaard templates",
        "emails": "E-mails",
        "export": "Exporteren",
        "failedPayments": "Mislukte betalingen",
        "home": "Overzicht",
        "invoices": "Facturen",
        "layout": "Layout",
        "login": "Inloggen",
        "mcpServer": "Agent MCP",
        "mobileApp": "Mobiele app",
        "new": "Nieuw",
        "notifications": "Notificaties",
        "orders": "Orders",
        "peppol": "Peppol",
        "platformUsage": "Platformgebruik",
        "products": "Producten",
        "referAFriend": "Refer a friend",
        "requests": "Aanvragen",
        "returns": "Retouren",
        "reviewAnalytics": "Review Inzicht",
        "salesDashboard": "Sales Dashboard",
        "searchRankings": "Search Rankings",
        "searchVolume": "Zoekvolume",
        "security": "Beveiliging",
        "sendEmails": "E-mails verzenden",
        "settings": "Instellingen",
        "subscription": "Abonnement",
        "thirtyDayImport": "30 dagen import",
        "threads": "Threads",
        "title": "Menu",
        "users": "Gebruikers",
        "vatDeclaration": "BTW Aangifte"
    },
    "misc": {
        "infoBanner": {
            "close": "Sluiten"
        },
        "pageChangePermission": {
            "allow": "Ja",
            "body": "De wijzigingen zijn nog niet opgeslagen. Weet je zeker dat je door wilt gaan?",
            "deny": "Nee",
            "title": "Onopgeslagen wijzigingen"
        },
        "urlActions": {
            "activateFailed": "Activeren mislukt",
            "activateFailedMessage": "Het activeren van de Notificaties module is niet gelukt.",
            "addFailed": "Toevoegen mislukt",
            "addFailedMessage": "Het toevoegen van de notificatie is niet gelukt.",
            "moduleAdded": "De Notificaties module is toegevoegd aan het abonnement.",
            "moduleAddedTitle": "Module toegevoegd",
            "notificationAdded": "De order notificatie is toegevoegd.",
            "notificationAddedTitle": "Notificatie toegevoegd"
        },
        "validationErrors": {
            "title": "De volgende fouten zijn opgetreden:"
        }
    },
    "model": {
        "bolInvoiceRequest": {
            "oldOrder": "Oude order, factuur niet in Bluemate, handmatige actie vereist",
            "open": "Open",
            "uploadFailedApiError": "Upload mislukt. Bol API error. Probleem is bekend en doorgegeven.",
            "uploadFailedTimeout": "Upload mislukt. Bol API timeout. Probeer opnieuw.",
            "uploaded": "Geüpload",
            "uploading": "Wordt geüpload",
            "viaAutoRespond": "via auto reactie",
            "viaManual": "via handmatig",
            "viaProactive": "via proactief"
        }
    },
    "notifications": {
        "add": {
            "betaBadge": "Beta",
            "buyBoxDescription": "Ontvang een e-mail wanneer het koopblok verandert",
            "buyBoxLabel": "Koopblok notificatie",
            "headerTitle": "Notificatie toevoegen",
            "typeStepSubtitle": "Kies een type notificatie",
            "channelsStepTitle": "Kanalen & bestemmingen",
            "channelsStepSubtitle": "Instellingen voor bezorging",
            "channelsTitle": "Hoe wil je de notificaties ontvangen?",
            "channelsText": "Kies hieronder één of meer kanalen. Kies je voor e-mail, dan kun je ook het e-mailadres instellen.",
            "emailChannelTitle": "E-mail notificatie",
            "emailChannelText": "Ontvang notificaties per e-mail",
            "emailRequiredHint": "Vul een e-mailadres in om deze notificatie te ontvangen.",
            "pushChannelTitle": "Push-notificatie",
            "pushChannelDevicesText": "Ontvang push-meldingen op de gekozen apparaten",
            "devicesNone": "Selecteer apparaten",
            "devicesRequiredHint": "Selecteer minimaal één apparaat om push-meldingen te ontvangen.",
            "pushOtherDevicesHint": "Op dit apparaat kan dat alleen in de Bluemate-app — je andere apparaten ontvangen de meldingen gewoon.",
            "successStepTitle": "Notificatie toegevoegd",
            "successStepSubtitle": "Bevestiging",
            "successTitle": "Notificatie toegevoegd",
            "successTextMail": "Je ontvangt vanaf nu e-mailmeldingen voor de ingestelde triggers.",
            "successTextPush": "Je ontvangt vanaf nu push-meldingen op de gekozen apparaten voor de ingestelde triggers.",
            "successTextBoth": "Je ontvangt vanaf nu e-mail- en push-meldingen voor de ingestelde triggers.",
            "successTestTitleMail": "Controleer direct of de e-mail goed aankomt:",
            "successTestTitlePush": "Controleer direct of pushberichten goed aankomen:",
            "successTestTitleBoth": "Controleer direct of de e-mail en pushberichten goed aankomen:",
            "successTestBoth": "Verstuur test e-mail + pushmelding",
            "successTestPush": "Verstuur test pushmelding",
            "successTestMail": "Verstuur test e-mail",
            "successClose": "Sluiten",
            "finishLabelShort": "Toevoegen",
            "backShort": "Terug",
            "duplicateTitle": "Notificatie bestaat al",
            "duplicateText": "Er is al een actieve notificatie van dit type voor een of meer van de gekozen kanalen. Weet je zeker dat je deze extra notificatie wilt toevoegen? Dit kan dubbele meldingen opleveren.",
            "duplicateAdjust": "Kanalen aanpassen",
            "duplicateConfirm": "Ja, voeg toe",
            "finishLabel": "Notificatie toevoegen",
            "orderDescription": "Ontvang een e-mail bij nieuwe orders",
            "orderLabel": "Order notificatie",
            "premiumBadge": "Premium notificatie",
            "productHijackDescription": "Ontvang een e-mail wanneer een concurrent ook als verkoper bij jouw product verschijnt.",
            "productHijackLabel": "Productkaping notificatie",
            "addPremium": "Premium toevoegen...",
            "reviewDescription": "Ontvang een e-mail bij nieuwe reviews",
            "reviewLabel": "Review notificatie",
            "stockDescription": "Ontvang een e-mail als de voorraad bijna op is",
            "stockLabel": "Voorraad notificatie",
            "pushTargetUnresolved": "Pushmelding kon niet aan dit apparaat gekoppeld worden. Schakel push in op de notificatiekaart."
        },
        "buyBox": {
            "atLabel": "Bij",
            "eventChange": "Koopblok verandering",
            "minOneEvent": "Kies minimaal één gebeurtenis",
            "eventGot": "Koopblok verkregen",
            "eventLost": "Koopblok verloren",
            "tipLabel": "Tip",
            "tipLine1": "Krijg je veel koopblok-notificaties?",
            "tipLine2": "Dat komt vaak door hoge concurrentie, automatische repricers en veranderende leverbeloftes in het weekend.",
            "tipLine3": "Wil je dat deze meldingen niet meer in je algemene inbox terechtkomen?",
            "tipLinkText": "👉 Lees hier hoe je ze automatisch in een aparte map ontvangt in Gmail of Outlook.",
            "title": "Koopblok notificatie"
        },
        "components": {
            "betaBadge": "Beta",
            "cancel": "Annuleren",
            "confirm": "Bevestigen",
            "deleteNotification": "Notificatie verwijderen",
            "intervalDay": "dag",
            "intervalInstant": "direct",
            "intervalMonth": "maand",
            "intervalPerLabel": "per",
            "intervalWeek": "week",
            "intervalWhen": "Wanneer",
            "notificationUpdateErrorMessage": "Het bijwerken van de notificatie is niet gelukt.",
            "notificationUpdateErrorTitle": "Bijwerken mislukt",
            "notificationUpdatedSnackbar": "De notificatie is bijgewerkt",
            "productsSavedSnackbar": "Producten opgeslagen",
            "premiumBadge": "Premium",
            "premiumInfo": "Deze notificatie is een premium notificatie en is beschikbaar via de Notificaties module.",
            "premiumTrialInfo": "Gratis te gebruiken gedurende jouw proefperiode.",
            "productsForLabel": "voor",
            "selectRemainingInfo": "Met deze optie worden automatisch alle producten geselecteerd die nog niet onder een andere notificatie van dit type vallen.",
            "sendEmailToLabel": "Stuur e-mail naar",
            "sendNotificationToShort": "naar",
            "emailSavedSnackbar": "E-mailadres opgeslagen",
            "sendNotificationVia": "stuur een notificatie via",
            "sendTestNotification": "Test notificatie verzenden",
            "channelEmail": "e-mail",
            "channelsEmail": "E-mail",
            "channelsPush": "Push-melding",
            "channelsEmailPush": "E-mail en push-melding",
            "channelsNone": "geen kanalen",
            "deviceSingular": "apparaat",
            "devicePlural": "apparaten",
            "thisDeviceAppOnly": "{{device}} (alleen in de app)",
            "minOneChannel": "Kies minimaal één verzendkanaal"
        },
        "feedback": {
            "cancel": "Annuleren",
            "headerTitle": "Tip ons waarvoor je nog meer een notificatie voor wilt ontvangen",
            "placeholder": "Waarvoor zou je ook notificaties willen ontvangen?",
            "sendErrorMessage": "Het verzenden van de feedback is niet gelukt.",
            "sendErrorTitle": "Verzenden mislukt",
            "submit": "Feedback verzenden",
            "thanksSnackbar": "Bedankt voor de feedback!"
        },
        "list": {
            "addEmailNotification": "Notificatie toevoegen",
            "breadcrumb": "Notificaties",
            "deleteConfirmMessage": "Weet je zeker dat je deze notificatie wilt verwijderen?",
            "deleteConfirmNo": "Nee",
            "deleteConfirmTitle": "Notificatie verwijderen",
            "deleteConfirmYes": "Ja",
            "infoBannerText": "Ontvang notificaties per e-mail bij belangrijke events, zodat je op de hoogte bent en eventueel actie kunt nemen.",
            "loadErrorMessage": "Er zijn geen notificaties gevonden.",
            "loadErrorTitle": "Notificaties niet gevonden",
            "notificationAddErrorMessage": "Het toevoegen van de notificatie is niet gelukt.",
            "notificationAddErrorTitle": "Toevoegen mislukt",
            "notificationDeleteErrorMessage": "Het verwijderen van de notificatie is niet gelukt.",
            "notificationDeleteErrorTitle": "Verwijderen mislukt",
            "notificationDeletedSnackbar": "De notificatie is verwijderd",
            "notificationSendErrorMessage": "Het verzenden van de notificatie is niet gelukt.",
            "notificationSendErrorTitle": "Verzenden mislukt",
            "notificationSentSnackbar": "De notificatie is verzonden",
            "notificationAddedSnackbar": "De notificatie is toegevoegd",
            "notificationChannelsNotSavedSnackbar": "De notificatie is toegevoegd, maar de bezorgkanalen konden niet worden opgeslagen. Pas ze aan op de kaart.",
            "subtitle": "Ontvang een melding per e-mail of op mobiel bij onderstaande triggers:",
            "title": "Notificaties"
        },
        "order": {
            "productsText": "Bij nieuwe orders voor",
            "title": "Order notificatie"
        },
        "productHijack": {
            "productsText": "Bij een nieuwe verkoper op",
            "title": "Productkaping notificatie"
        },
        "reviews": {
            "allScores": "Alle scores",
            "minOneScore": "Kies minimaal één score",
            "newReviewsWith": "Bij nieuwe reviews met",
            "scoresSuffix": "scores",
            "starPlural": "sterren",
            "starSingular": "ster",
            "title": "Review notificatie"
        },
        "stock": {
            "thresholdInputLabel": "Voorraad minder dan",
            "thresholdLabel": "Bij een voorraad minder dan",
            "title": "Voorraad notificatie"
        },
        "swUnavailable": "Service Worker is niet beschikbaar — push-meldingen werken niet in deze sessie. Herlaad de pagina of gebruik een recente browser.",
        "errors": {
            "NO_ACTIVE_CONNECTION": "Je hebt geen actieve koppeling met Bol.",
            "NO_PRODUCTS_FOUND": "Er zijn geen producten gevonden waarmee de testnotificatie verzonden kan worden.",
            "EMAIL_SEND_FAILED": "Het verzenden van de e-mail is niet gelukt.",
            "NO_EVENTS_SELECTED": "Er zijn geen gebeurtenissen geselecteerd voor deze notificatie.",
            "ACCOUNT_NOT_FOUND": "Het verkoopaccount kan niet gevonden worden.",
            "NOTIFICATION_NOT_FOUND": "De notificatie kan niet gevonden worden."
        }
    },
    "oauth": {
        "authorize": {
            "cancelAction": "Ga terug",
            "cancelQuestion": "Wil je je AI-assistent toch niet koppelen?",
            "continue": "Doorgaan met het ingelogde account",
            "continueAs": "Doorgaan als {{account}}",
            "doneProse": "De koppeling is succesvol ingesteld. Je wordt automatisch teruggestuurd naar je AI-assistent.",
            "failed": "Het koppelen met de externe applicatie is niet gelukt. Probeer het opnieuw.",
            "invalidRequest": "Deze koppelingsaanvraag is onvolledig. Start de koppeling opnieuw vanuit je AI-assistent.",
            "resolving": "Eén moment...",
            "retry": "Opnieuw proberen",
            "returnToApp": "Terug naar je AI-assistent",
            "signInIntro": "Log in met je Bluemate-account om de koppeling af te ronden.",
            "signInTitle": "Log in om te koppelen",
            "signedInAs": "Je bent ingelogd als {{account}}. Ga verder met dit account of log in met een ander account.",
            "signedInUnnamed": "Je bent ingelogd. Ga verder met dit account of log in met een ander account.",
            "statusCancelling": "Annuleren...",
            "statusConnecting": "Verbinding maken met Bluemate MCP...",
            "statusError": "Verbinden mislukt",
            "statusSuccess": "Verbinding gelukt!",
            "step1": "Toegang",
            "step2": "Account",
            "step3": "Klaar",
            "switchAccount": "Inloggen met een ander account",
            "title": "Koppeling met Bluemate MCP-server"
        },
        "bol": {
            "continue": "Doorgaan",
            "retry": "Opnieuw proberen",
            "statusError": "Autorisatie mislukt",
            "statusSuccess": "Koppeling voltooid",
            "statusValidating": "Koppeling testen...",
            "testing": "Eén moment, we testen de verbinding.",
            "title": "Koppeling met Bol"
        },
        "connectionFailed": "Het koppelen met Bol is niet gelukt.",
        "codeNotFound": "We hebben geen autorisatiecode ontvangen."
    },
    "pdfTemplate": {
        "allowLeave": "Ja, pagina verlaten",
        "copied": "De layout is gekopieerd",
        "crumb": "Factuur Layout",
        "denyLeave": "Nee, niet verlaten",
        "editor": {
            "bannerText": "Ontwerp je factuurlayout zodat elke factuur in je eigen huisstijl verstuurd wordt.",
            "bannerTitle": "Factuurlayout",
            "importFrom": "Ophalen uit...",
            "price": "Prijs",
            "productName": "Productnaam",
            "quantity": "Aantal",
            "subtotal": "Subtotaal excl. BTW",
            "vat": "BTW"
        },
        "errors": {
            "copy": "Het kopiëren van de layout is niet gelukt.",
            "copyTitle": "Kopiëren mislukt",
            "preview": "Het aanmaken van een voorbeeld factuur is niet gelukt.",
            "previewTitle": "Voorbeeld mislukt",
            "save": "Het opslaan van de PDF template is niet gelukt",
            "saveTitle": "Opslaan mislukt"
        },
        "importDescription": "Factuur template uit een ander account ophalen.",
        "importTitle": "Template ophalen",
        "saved": "De PDF template is opgeslagen",
        "unsavedChanges": "Eventuele wijzigingen gaan verloren als je de pagina verlaat zonder de wijzigingen op te slaan. Weet je zeker dat je de pagina wilt verlaten?",
        "warningLabel": "Let op: ",
        "warningText": "huidige template wordt overschreven!"
    },
    "productCosts": {
        "add": "toevoegen",
        "addCosts": "+ Kosten toevoegen",
        "addMiscPer": "+ Kosten per",
        "backToList": "Terug naar lijst",
        "choosePackageSize": "Kies pakketmaat",
        "close": "Sluiten",
        "columns": {
            "costPrice": "KOSTPRIJS",
            "endDate": "EINDDATUM",
            "fulfilmentCosts": "FULFILMENT KOSTEN",
            "fulfilmentType": "SOORT LEVERING",
            "miscPerOrder": "OVERIG PER ORDER",
            "miscPerProduct": "OVERIG PER PRODUCT",
            "sendCosts": "VERZENDKOSTEN",
            "startDate": "STARTDATUM"
        },
        "costPrice": "Kostprijs",
        "delete": "Verwijderen",
        "deleteFailed": "Verwijderen mislukt",
        "deleteFailedMessage": "Het verwijderen van de kosten is niet gelukt.",
        "deleted": "De kosten zijn verwijderd",
        "edit": "Wijzigen",
        "editCosts": "Kosten wijzigen",
        "endDate": "Einddatum",
        "fbbPackageSize": "LVB pakketmaat",
        "fulfilment": {
            "fbb": "LVB",
            "fbr": "Eigen levering"
        },
        "fulfilmentCosts": "Fulfilmentkosten",
        "fulfilmentType": "Soort levering",
        "loadFailed": "Laden mislukt",
        "loadFailedMessage": "Het laden van de kosten is niet gelukt.",
        "miscCostsLabel": "Overige kosten",
        "miscPer": "Overige kosten per",
        "noCosts": "Je hebt nog geen kosten ingesteld",
        "noEndDate": "Geen einddatum",
        "of": "van",
        "pageChange": {
            "allow": "Nee, sluiten",
            "body": "De wijzigingen gaan verloren als je doorgaat. Wil je de wijzigingen eerst opslaan?",
            "deny": "Ja, wijzigingen opslaan"
        },
        "priceLow": "Prijs lager dan €16,-",
        "priceNormal": "Prijs vanaf €16,-",
        "productCosts": "Productkosten",
        "salePrice": "Verkoopprijs",
        "saveChanges": "Wijzigingen opslaan",
        "saveFailed": "Opslaan mislukt",
        "saveFailedMessage": "Het opslaan van de kosten is niet gelukt.",
        "saved": "De kosten zijn opgeslagen",
        "sendCostType": {
            "order": "Order",
            "product": "Product"
        },
        "sendCosts": "Verzendkosten",
        "sendCostsPer": "Verzendkosten per",
        "startDate": "Startdatum",
        "tabs": {
            "all": "Alles",
            "fbb": "LVB",
            "ownShipping": "Eigen verzending"
        }
    },
    "productSelection": {
        "availableProducts": "Beschikbare producten",
        "deselectAll": "Alles deselecteren",
        "done": "Klaar",
        "ean": "EAN",
        "importFailed": "Importeren mislukt",
        "importFailedMessage": "Het importeren van je producten is niet gelukt.",
        "importSnackbar": "De producten worden geïmporteerd",
        "loadFailed": "Producten laden mislukt",
        "loadFailedMessage": "Het is niet gelukt om de producten te laden.",
        "loadingProduct": "Product laden...",
        "next": "Volgende",
        "productName": "Productnaam",
        "remainingSelected": "Resterende producten geselecteerd",
        "remainingSelectedInfo": "Linksboven het vakje \"Resterende producten selecteren\" om resterende/geen producten te selecteren",
        "searchPlaceholder": "EAN of productnaam",
        "searchProduct": "Zoek een product",
        "searchedFor": "Gezocht op",
        "selectAll": "Alles selecteren",
        "selectRemaining": "Resterende producten selecteren",
        "selectRemainingInfo": "Met deze optie worden automatisch alle producten geselecteerd waarvoor nog geen andere mail ingesteld is.",
        "selectedProducts": "Geselecteerde producten",
        "sync": "Sync met Bol",
        "title": "Producten selecteren",
        "withSearchTerm": "met zoekterm"
    },
    "products": {
        "bolNameFailed": "De naam van bol kon niet worden opgehaald.",
        "bolWarning": "Alle wijzigingen die je hier maakt, gelden alleen voor Bluemate, niet voor bol zelf.",
        "costs": {
            "label": "Kosten",
            "notSet": "Niet ingevuld"
        },
        "crumb": "Producten",
        "defaultVat": {
            "cancel": "Annuleren",
            "optionsTitle": "Standaard BTW tarieven instellen",
            "save": "Opslaan",
            "title": "Standaard BTW"
        },
        "download": {
            "failed": "Het downloaden van de QR-code is niet gelukt.",
            "failedTitle": "Downloaden mislukt",
            "onlyVisible": "QR-codes zijn alleen beschikbaar voor zichtbare producten. Toon dit product weer, of wacht tot het op bol weer actief is.",
            "tooltip": "Download de QR-code die linkt naar het schrijven van een review. Voeg hem toe aan je verpakking om meer productreviews op bol te krijgen.",
            "unavailable": "Geen QR-code beschikbaar: dit product heeft nog geen productpagina op bol."
        },
        "downloadAll": {
            "label": "Alle QR"
        },
        "editCosts": {
            "add": "Toevoegen",
            "addNewRecord": "Nieuwe kosten toevoegen",
            "advanced": "Geavanceerde opties",
            "cancel": "Annuleren",
            "confirmDelete": "Weet je zeker dat je deze productkosten wilt verwijderen?",
            "costPrice": "Kostprijs per stuk",
            "costPriceHint": "De inkoopprijs van één stuk. Bluemate trekt dit bedrag per verkocht stuk van je omzet af om de winst te berekenen.",
            "costPriceShort": "Totale kosten",
            "created": "De productkosten zijn opgeslagen",
            "datePlaceholder": "dd-mm-jjjj",
            "delete": "Verwijderen",
            "deleteFailed": "Het verwijderen van de productkosten is niet gelukt.",
            "deleteFailedTitle": "Verwijderen mislukt",
            "deleted": "De productkosten zijn verwijderd",
            "descriptionPlaceholder": "Omschrijving voor jezelf",
            "duplicateDate": "Er bestaan al kosten met deze ingangsdatum en dit aantal stuks.",
            "editingRecord": "Je bewerkt de kosten die gelden vanaf {{date}}",
            "from": "Vanaf",
            "fulfilmentBol": "Fulfilment door bol (LVB)",
            "fulfilmentOwn": "Eigen verzending",
            "history": "Geschiedenis",
            "historyEmpty": "Nog geen productkosten ingevuld.",
            "historyHint": "Elke wijziging vanaf een nieuwe datum komt hier als aparte regel te staan. Klik op het potlood om die periode te bewerken. Oudere bestellingen blijven met hun eigen kosten gerekend.",
            "invalidAmount": "Vul een geldig bedrag in",
            "loadFailed": "Het laden van de productkosten is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "lvbSize": "LVB formaat",
            "lvbSizeHint": "Het bol-formaat dat de LVB-fulfilmentkosten bepaalt. Bluemate bepaalt dit automatisch op basis van de afmetingen van het product bij bol.",
            "lvbUnknown": "Onbekend",
            "minQuantity": "Vanaf aantal stuks",
            "minQuantityHint": "Vanaf hoeveel stuks in één bestelregel deze kosten gelden. Laat 1 staan tenzij je met staffels werkt. Bij meerdere staffels gebruikt Bluemate de hoogste die past.",
            "minQuantityShort": "Vanaf aantal",
            "miscCosts": "Overige kosten",
            "miscCostsDesc": "Omschrijving overige kosten",
            "miscCostsDescHint": "Notitie voor jezelf waar deze overige kosten vandaan komen. Heeft geen invloed op de berekening.",
            "miscCostsHint": "Overige kosten per stuk die nog nergens anders staan, bijvoorbeeld verpakking of licentie. Tellen mee in de winstberekening.",
            "negative": "Het bedrag kan niet negatief zijn",
            "no": "Nee",
            "overwrite": "Overschrijven",
            "pickCosts": "Pick & pack kosten (eigen verzending)",
            "pickCostsHint": "Wat het verzendklaar maken van één bestelling je kost. Telt alleen mee bij eigen verzending. Bij LVB rekent Bluemate met de tarieven van bol.",
            "returnCosts": "Retourkosten",
            "returnCostsDesc": "Omschrijving retourkosten",
            "returnCostsDescHint": "Notitie voor jezelf waar deze retourkosten vandaan komen. Heeft geen invloed op de berekening.",
            "returnCostsHint": "Wat één retour je gemiddeld kost, bijvoorbeeld het retourlabel, controleren en opnieuw verpakken. Bluemate trekt dit af zodra een bestelling geretourneerd wordt.",
            "saveFailed": "Het opslaan van de productkosten is niet gelukt.",
            "saveFailedTitle": "Opslaan mislukt",
            "sectionFulfilment": "Fulfilmentkosten",
            "sectionFulfilmentHint": "LVB-formaat en de kosten van je eigen verzending",
            "sectionMisc": "Overige kosten",
            "sectionMiscHint": "Kosten per stuk die nergens anders staan",
            "sectionQuantity": "Aantal",
            "sectionQuantityHint": "Vanaf welk aantal stuks deze kosten gelden",
            "sectionReturns": "Retourkosten",
            "sectionReturnsHint": "Wat één retour je gemiddeld kost",
            "sendCosts": "Verzendkosten (eigen verzending)",
            "sendCostsHint": "De vervoerderskosten per bestelling bij eigen verzending, bijvoorbeeld het pakketlabel. Telt niet mee bij LVB.",
            "stopEditing": "Stoppen met bewerken",
            "titleFor": "Kosten aanpassen voor {{name}}",
            "until": "Tot",
            "untilNow": "nu",
            "updated": "De productkosten zijn bijgewerkt",
            "yes": "Ja",
            "always": "Altijd",
            "fromToday": "Vanaf vandaag",
            "pickFromDate": "Kies vanaf datum"
        },
        "editName": {
            "cancel": "Annuleren",
            "failed": "Het opslaan van de productnaam is niet gelukt.",
            "failedTitle": "Opslaan mislukt",
            "info": "Deze naamswijziging geldt voor de productnaam die op Bluemate en op facturen wordt getoond. Zo kun je een productnaam op Bluemate-facturen bijvoorbeeld korter en herkenbaarder maken.",
            "label": "Productnaam",
            "save": "Opslaan",
            "saved": "De productnaam is opgeslagen",
            "title": "Productnaam aanpassen"
        },
        "empty": {
            "connect": "Maak eerst verbinding met bol om je producten te zien.",
            "subtitle": "Zodra je producten met bol zijn gesynchroniseerd, verschijnen ze hier.",
            "title": "Nog geen producten beschikbaar"
        },
        "filter": {
            "all": "Alle",
            "hidden": "Verborgen"
        },
        "group": {
            "all": "Alle producten",
            "hidden": "Verborgen producten",
            "visible": "Zichtbare producten"
        },
        "hide": {
            "done": "Het product is verborgen",
            "failed": "Het verbergen van het product is niet gelukt.",
            "failedTitle": "Verbergen mislukt"
        },
        "hideDialog": {
            "ackChannels": "Ik begrijp dat dit product niet meer wordt meegenomen in e-mails en notificaties. Als het nu is opgenomen, wordt het uitgesloten.",
            "ackLists": "Ik begrijp dat ik dit product niet meer zie in lijsten en overzichten.",
            "body": "Het product wordt niet meer getoond in de lijsten en overzichten van Bluemate en wordt niet meer gebruikt in e-mails, notificaties enzovoort. Deze optie is bedoeld voor producten die je niet meer verkoopt of niet meer wilt zien. Je kunt het product hier altijd weer tonen. Deze wijziging geldt alleen voor Bluemate en niet voor bol zelf.",
            "cancel": "Annuleren",
            "confirm": "Verbergen",
            "dontShowAgain": "Niet meer tonen",
            "title": "Product verbergen?"
        },
        "importExport": {
            "chooseLabel": "Kies wat je wilt importeren of exporteren:",
            "close": "Sluiten",
            "dropzoneHint": "Of sleep het bestand hierheen (.xlsx)",
            "dropzoneLabel": "Klik om een .xlsx-bestand te kiezen",
            "exportFailed": "Het exporteren is niet gelukt.",
            "exportFailedTitle": "Exporteren mislukt",
            "importDoneWithErrors": "Import voltooid, met fouten",
            "importFailedMsg": "Het importeren is niet gelukt.",
            "importFailedTitle": "Importeren mislukt",
            "importSuccess": "Succesvol {{num}} {{label}} bijgewerkt",
            "label": "Import & Export...",
            "modeCost": "Kosten",
            "modeVat": "BTW",
            "onlyXlsxAccepted": "We accepteren alleen .xlsx bestanden, gebruik het voorbeeldbestand.",
            "partialImportError": "{{imported}} regels zijn geïmporteerd, maar {{errors}} kon{{suffix}} niet geïmporteerd worden. Zie het bestand hieronder voor de details.",
            "row": "regel",
            "rows": "regels",
            "templateLink": "Download het voorbeeldbestand",
            "title": "Importeren & Exporteren",
            "upload": "Uploaden",
            "vat": {
                "vat": "BTW",
                "exportTitle": "Exporteren",
                "exportDescription": "Download een Excel-overzicht van al je producten met hun huidige BTW-tarieven.",
                "exportButton": "Exporteer BTW (.xlsx)",
                "importTitle": "Importeren",
                "importDescription": "Upload een Excel-bestand om de BTW-tarieven in bulk bij te werken.",
                "formatNote": "formaat: EAN, BTW % per land",
                "applyToExisting": "Pas BTW ook toe op bestaande facturen",
                "downloadErrorFile": "Download import-fouten.xlsx"
            },
            "costs": {
                "productCosts": "Productkosten",
                "subtitle": "Je kunt productkosten ook per product aanpassen door in de tabel op de cel met productkosten te klikken.",
                "exportTitle": "Exporteren",
                "exportDescription": "Download een Excel-overzicht van al je ingestelde productkosten.",
                "exportButton": "Exporteer productkosten (.xlsx)",
                "importTitle": "Importeren",
                "importDescription": "Upload een Excel-bestand om de productkosten in bulk bij te werken.",
                "formatNote": "formaat: EAN, Startdatum, Kostprijs, Vanaf aantal artikelen, Fulfilment kosten, Verzendkosten, Retourlabel kosten, Overige retour kosten, Beschrijving overige retour kosten, Overige kosten, Beschrijving overige kosten"
            }
        },
        "intro": {
            "qrInfoTooltip": "Zo werken de QR-codes",
            "title": "Fysieke QR codes voor meer reviews",
            "body2": "Gebruik fysieke QR-codes voor meer productreviews. Download en print de unieke QR-code per product en stop hem bij je verpakking. Scannen brengt klanten direct naar de reviewpagina van het product op bol, zodat een review achterlaten makkelijk is. We houden het aantal scans bij.",
            "gotIt": "Begrepen",
            "imageAlt": "QR-kaartje in een pakket"
        },
        "load": {
            "failed": "Het laden van de producten is niet gelukt.",
            "failedTitle": "Laden mislukt"
        },
        "menu": {
            "editCosts": "Kosten aanpassen…",
            "editName": "Naam aanpassen…",
            "editVat": "BTW aanpassen…",
            "hide": "Verbergen…",
            "show": "Tonen"
        },
        "notFound": {
            "subtitle": "Probeer een andere zoekterm of een ander filter.",
            "title": "Geen producten gevonden"
        },
        "scansLabel": "QR-scans",
        "scansTooltip": "Het aantal keren dat deze QR-code is gescand",
        "scansUnavailable": "Voor verborgen en op bol inactieve producten worden scans hier niet getoond. Scans van gedrukte QR-codes blijven wel geregistreerd.",
        "searchPlaceholder": "Zoek op EAN of titel",
        "show": {
            "done": "Het product wordt weer getoond",
            "failed": "Het opnieuw tonen van het product is niet gelukt.",
            "failedTitle": "Tonen mislukt"
        },
        "status": {
            "hidden": "Verborgen",
            "hiddenTooltip": "Je hebt dit product zelf verborgen. Het wordt niet meer getoond in lijsten en overzichten en niet gebruikt in e-mails en notificaties. Deze wijziging geldt alleen voor Bluemate, niet op bol zelf — je kunt het hier weer tonen.",
            "inactive": "Inactief op bol",
            "inactiveTooltip": "Dit product is niet meer actief op bol. Het telt niet mee in e-mails en notificaties. Deze status komt van bol en verandert niet als je het product hier verbergt of toont.",
            "visible": "Zichtbaar"
        },
        "subtitle": "Beheer hier jouw producten: naam, BTW, kosten, zichtbaarheid en QR-codes.",
        "subtitleReviews": "Wil je meer reviews verzamelen?<0/>Voeg fysieke QR codes toe in jouw verpakking.<0/>Deze leiden een klant direct naar de review pagina van het product op bol. Bekijk een <1>voorbeeld</1>.",
        "sync": {
            "button": "Sync met Bol",
            "failed": "Het ophalen van de producten is niet gelukt.",
            "failedTitle": "Ophalen mislukt",
            "fetching": "Bezig met ophalen van producten",
            "fetchingCount": "Bezig met ophalen van {{count}} producten",
            "started": "De producten worden opgehaald"
        },
        "title": "Producten",
        "vat": {
            "default": "Standaard",
            "label": "BTW"
        }
    },
    "referAFriend": {
        "crumb": "Refer a friend",
        "disclaimer": "Het tegoed gaat van jouw facturen af. Zo betaal je minder of niks. Referrals zijn niet te combineren met andere promoties. Zelf-referrals zijn niet toegestaan. Bluemate behoudt zich het recht voor om het programma op elk moment te wijzigen of te beëindigen. Bluemate behoudt zich het recht voor om referrals te weigeren. Bluemate behoudt zich het recht voor om de voorwaarden van dit programma op elk moment te wijzigen.",
        "emailPlaceholder": "E-mailadres",
        "friendEmail": "Vriend(in) e-mailadres Bluemate",
        "howItWorks": "Hoe werkt het?",
        "intro": "Sinds kort vragen we bij registratie hoe gebruikers ons hebben gevonden. Maar liefst 26% hoort van ons via een vriend(in). We willen graag samen in dit succes delen. Ontvang beide €50 tegoed in Bluemate.",
        "myEmail": "Mijn e-mailadres Bluemate",
        "snackbar": "Bedankt! Het verzoek is ingediend, we nemen z.s.m. contact met je op.",
        "step1": "Jij bent al een betalend gebruiker bij Bluemate. Laat jouw vriend(in) een betaald abonnement bij Bluemate beginnen.",
        "step2": "Vul hieronder het e-mailadres in waarmee hij/zij geregistreerd is en verzend de mail.",
        "step3": "Zodra jouw vriend(in) de eerste factuur heeft betaald, ontvangen jullie beide een €50 tegoed in Bluemate.",
        "step4": "Herhaal dit zo vaak als je wilt met meer vrienden!",
        "submit": "Indienen",
        "submitFailed": "Indienen mislukt",
        "submitFailedMessage": "Het indienden van het verzoek is niet gelukt.",
        "terms": {
            "existingAccount": "Mijn vriend(in) heeft een bestaand Bluemate account met dit e-mailadres.",
            "firstPayment": "Ik begrijp dat de tegoeden worden toegekend nadat mijn vriend(in) de eerste factuur heeft betaald.",
            "paidSub": "Ik begrijp dat zowel ik als mijn vriend(in) het abonnement gestart moeten hebben."
        },
        "title": "Tip een vriend(in) en krijg beide €50"
    },
    "returns": {
        "banner": {
            "body": "Bekijk retour statussen van bol. Maak creditfacturen en bekijk redenen.",
            "title": "Retouren"
        },
        "count": {
            "accepted": "verwerkt",
            "canceled": "geannuleerd",
            "open": "openstaand",
            "rejected": "geweigerd"
        },
        "creditInvoiceCreated": "Creditfactuur aangemaakt",
        "creditInvoiceSent": "Creditfactuur verzonden",
        "crumb": "Retouren",
        "details": {
            "close": "Sluiten",
            "credit": "Crediteren",
            "creditInvoice": "Creditfactuur",
            "creditInvoiceSent": "Creditfactuur verzonden",
            "customer": "Klant",
            "description": "Omschrijving",
            "handling": "Verwerking",
            "na": "n.v.t.",
            "notCredited": "Niet gecrediteerd",
            "notFound": "Niet gevonden",
            "options": "Opties",
            "orderNumber": "Ordernummer",
            "originalInvoice": "Originele factuur",
            "processedAt": "Verwerkt op",
            "reason": "Reden",
            "registeredAt": "Aangemeld op",
            "returnPrefix": "Retour",
            "rmaId": "RMA ID",
            "sendCreditInvoice": "Creditfactuur verzenden",
            "showOnBol": "Weergeven op Bol",
            "status": "Status",
            "toCreditInvoice": "Naar creditfactuur",
            "toInvoice": "Naar factuur"
        },
        "dialog": {
            "createCreditTitle": "Creditfactuur aanmaken",
            "creditCreatedMessage": "De creditfactuur is aangemaakt. Wil je deze ook direct naar de klanten versturen?",
            "creditCreatedTitle": "Creditfactuur aangemaakt",
            "creditOrderTitle": "Bestelling crediteren",
            "creditsCreatedMessage": "De creditfacturen zijn aangemaakt. Wil je deze ook direct naar de klanten versturen?",
            "creditsCreatedTitle": "Creditfacturen aangemaakt",
            "multipleItemsMessage": "Er zijn meerdere items gevonden bij deze retourbestelling. Wil je alle items toevoegen aan de creditfactuur?",
            "notProcessedMessage": "De retourzending is nog niet verwerkt en kan dus nog geannuleerd of geweigerd worden. Wil je de bestelling toch crediteren?"
        },
        "error": {
            "createCreditFailed": "Het aanmaken van de creditfactuur is niet gelukt.",
            "createCreditFailedTitle": "Creditfactuur aanmaken mislukt",
            "loadFailed": "Het laden van de retouren is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "sendCreditFailed": "Het verzenden van de creditfactuur is niet gelukt.",
            "sendCreditInvoiceFailed": "Het verzenden van de creditfactuur is niet gelukt.",
            "sendCreditInvoicesFailed": "Het verzenden van de creditfacturen is niet gelukt.",
            "sendFailedTitle": "Verzenden mislukt"
        },
        "filter": {
            "statusLabel": "Retourstatus"
        },
        "header": {
            "date": "DATUM",
            "orderId": "ORDER ID",
            "returnId": "RETOUR ID",
            "rmaId": "RMA ID",
            "status": "STATUS"
        },
        "notFound": {
            "and": "en",
            "searchTerm": "de zoekterm '{{search}}'",
            "statusTerm": "de status {{status}}",
            "subtitle": "Er kunnen geen retouren{{term}}gevonden worden.",
            "title": "Geen retouren gevonden",
            "with": "met"
        },
        "pager": {
            "of": "van"
        },
        "search": {
            "label": "Retour zoeken",
            "placeholder": "Zoeken..."
        },
        "snackbar": {
            "creditCreated": "De creditfactuur is aangemaakt.",
            "creditSent": "De creditfactuur is verzonden",
            "invoiceSent": "De factuur is verzonden",
            "invoicesSent": "De facturen zijn verzonden"
        },
        "status": {
            "accepted": "Verwerkt",
            "all": "Alle",
            "canceled": "Geannuleerd",
            "open": "Openstaand",
            "rejected": "Geweigerd"
        }
    },
    "feedback": {
        "tooltip": "Feedback of probleem melden",
        "title": "Feedback of probleem melden",
        "subtitle": "Laat ons weten wat er beter kan of wat er niet werkt. Geef ons duidelijke details.",
        "placeholder": "Voorbeeld A: \"Sinds dinsdagochtend lukt het uploaden van facturen naar Bol niet meer. Bij bestelnummer 1234567890 krijg ik 'Factuur niet geaccepteerd'.\"\n\nVoorbeeld B: \"Ik zou het nice vinden als ik automatisch een e-mail kan ontvangen bij een retour.\"",
        "submit": "Verzenden",
        "cancel": "Annuleren",
        "thanksSnackbar": "Bedankt voor je feedback!",
        "sendErrorTitle": "Verzenden mislukt",
        "sendErrorMessage": "Het verzenden van de feedback is niet gelukt."
    },
    "reverseCharge": {
        "cancel": "Annuleren",
        "createFailed": "BTW verlegging mislukt",
        "createFailedMessage": "Het aanmaken van de verlegde BTW factuur is niet gelukt.",
        "createdMessage": "De huidige factuur is gecrediteerd en een nieuwe (verlegde) factuur is aangemaakt. Wil je de creditfactuur en nieuwe factuur naar de klant verzenden?",
        "createdSnackbar": "De verlegde BTW factuur is aangemaakt",
        "createdTitle": "Factuur aangemaakt",
        "description": "Voor het verleggen van de BTW is het vereist dat er een juist BTW nummer van de klant op de factuur geplaatst wordt. Controleer hieronder het BTW nummer en het land van de klant voordat de BTW verlegd wordt. De huidige factuur wordt gecrediteerd en er zal een nieuwe (verlegde) factuur aangemaakt worden.",
        "error": "Fout",
        "errors": {
            "countryRequired": "Kies het land",
            "vatPrefix": "Het BTW nummer moet beginnen met de landcode",
            "vatRequired": "Vul het BTW nummer in"
        },
        "no": "Nee",
        "sendFailed": "Verzenden mislukt",
        "sendFailedMessage": "Het verzenden van de facturen is niet gelukt.",
        "sentSnackbar": "De facturen zijn verzonden",
        "submit": "BTW verleggen",
        "title": "BTW verleggen",
        "validationFailed": "Validatie mislukt",
        "validationTimeoutMessage": "We kunnen het BTW nummer niet valideren omdat de VIES service tijdelijk niet bereikbaar is. Hierdoor kunnen wij niet garanderen dat het BTW nummer correct is, wil je toch doorgaan (eigen risico)?",
        "vatNumber": "BTW nummer *",
        "yes": "Ja"
    },
    "reviewAnalytics": {
        "banner": {
            "body": "Bekijk in één overzicht alle reviews op jouw producten. Ontdek trends met BluemateAI.",
            "title": "Review inzichten",
            "hideProducts": "Verbergen van producten die je niet meer verkoopt? Nu mogelijk, kies welke te verbergen op de \"Producten\" pagina. Producten die 2 weken op inactief staan op bol, worden automatisch verborgen."
        },
        "chart": {
            "negative": "Negatief",
            "positive": "Positief"
        },
        "crumb": "Review Inzicht",
        "export": {
            "all": "Alles",
            "allScores": "Alle scores",
            "cancel": "Annuleren",
            "confirmDeleteMessage": "Weet je zeker dat je deze export wilt verwijderen?",
            "createNewExport": "Nieuwe export maken",
            "createdAt": "AANGEMAAKT OP",
            "deleteExport": "Export verwijderen",
            "deleteFailed": "Verwijderen mislukt",
            "deleteFailedMessage": "Het verwijderen van de export is niet gelukt.",
            "deselect": "deselecteren",
            "downloadExport": "export downloaden",
            "downloadFailed": "Downloaden mislukt",
            "downloadFailedMessage": "Het downloaden van de export is niet gelukt.",
            "export": "Exporteren",
            "exportDeleted": "De export is verwijderd",
            "exportFailed": "Exporteren mislukt",
            "exportFileNotFound": "Het exportbestand kan niet gevonden worden.",
            "exportForAccounts": "Reviews exporteren voor accounts",
            "exportReviews": "Reviews exporteren",
            "exportReviewsFor": "Reviews exporteren voor",
            "filterByScore": "Filteren op score",
            "fromDate": "Vanaf datum",
            "fromDateHeader": "VANAF DATUM",
            "loadExportsFailed": "Het laden van de exports is niet gelukt.",
            "loadFailed": "Laden mislukt",
            "no": "Nee",
            "noExports": "Je hebt nog geen exports gemaakt",
            "ok": "Oké",
            "optional": "Optioneel",
            "processInfo": "Het exporteren van de reviews is gestart. Afhankelijk van het aantal reviews kan dit even duren, je kunt de pagina in de tussentijd verlaten.",
            "ready": "Gereed",
            "reviewsExporting": "Reviews worden geëxporteerd...",
            "select": "selecteren",
            "selectedScores": "GESELECTEERDE SCORES",
            "startExportFailedMessage": "Het starten van de export is niet gelukt.",
            "status": "STATUS",
            "toDate": "T/m datum",
            "toDateHeader": "TOT DATUM",
            "yes": "Ja"
        },
        "feedProductSelect": {
            "analyseWithAI": "Analyseren met BluemateAI...",
            "chooseProduct": "Kies een product",
            "emptyMessage": "Data aan het verzamelen, kom morgen terug...",
            "loadFailed": "Laden mislukt",
            "loadProductsFailed": "Het laden van de producten is niet gelukt.",
            "nameOrEan": "Naam of EAN"
        },
        "nps": {
            "info": "De NPS (net promoter score) geeft aan hoe waarschijnlijk jouw klanten het product dat ze kochten aan zouden raden aan anderen. Deze score wordt berekend door het percentage positieve reviews (5 sterren) te verminderen met het percentage negatieve reviews (1, 2 of 3 sterren). Deze score loopt van -100 t/m 100, waarbij -100 aangeeft dat er alleen maar negatieve reviews zijn en 100 aangeeft dat er alleen maar positieve reviews zijn.",
            "title": "Net Promoter Score"
        },
        "period": {
            "last30Days": "Afgelopen 30 dagen"
        },
        "periodLabel": {
            "day": "dag",
            "days": "dagen",
            "last": "AFGELOPEN"
        },
        "productReviews": {
            "analyse": {
                "analyseWithAI": "Analyseren met BluemateAI",
                "customers": "Klant persona",
                "failed": "AI analyse mislukt",
                "improvements": "Verbeterpunten",
                "negative": "Negatieve punten",
                "positive": "Positieve punten",
                "target": "Typische doelgroep"
            },
            "leastStars": "Minste sterren",
            "loadCountsFailed": "Het laden van de review aantallen is niet gelukt.",
            "loadFailed": "Laden mislukt",
            "loadProductsFailed": "Het laden van de producten is niet gelukt.",
            "mostHelpful": "Meest behulpzaam",
            "mostStars": "Meeste sterren",
            "newest": "Nieuwste",
            "noReviews": "Dit product heeft nog geen reviews",
            "noReviewsFound": "Er kunnen geen reviews gevonden worden.",
            "productLoadFailed": "Product kon niet worden geladen",
            "productLoading": "Product wordt geladen...",
            "sortBy": "Sorteer op",
            "viewInSellerAccount": "Bekijk product in jouw verkoopaccount",
            "viewOnBol": "Bekijk product op bol"
        },
        "reviewComponent": {
            "daysAgo": "dagen geleden",
            "new": "Nieuw",
            "today": "Vandaag",
            "viewAllReviews": "Alle reviews van dit product bekijken en analyseren",
            "viewOnBol": "Bekijk product op bol",
            "yesterday": "Gisteren"
        },
        "reviewFeed": {
            "title": "Reviews",
            "clearFilter": "Filter wissen",
            "emptyCollecting": "Data aan het verzamelen, kom morgen nog eens terug.",
            "emptyIntro": "Hier zie je straks al jouw productreviews in één handig overzicht.",
            "filterStars": "Filter aantal sterren",
            "loadFailed": "Laden mislukt",
            "loadFeedFailed": "Het laden van de feed is niet gelukt.",
            "loadMore": "Meer laden",
            "viewAllReviews": "Alle reviews van dit product bekijken en analyseren",
            "viewInSellerAccount": "Bekijk product in jouw verkoopaccount",
            "viewOnBol": "Bekijk product op bol",
            "countTooltip": "Het totaal aantal reviews in de lijst hieronder"
        },
        "reviewsTable": {
            "emptyMessage": "Data aan het verzamelen, kom morgen terug...",
            "loadFailed": "Laden mislukt",
            "loadProductsFailed": "Het laden van de producten is niet gelukt.",
            "name": "Naam",
            "negative": "Negatief",
            "period": "Periode",
            "periodReviews": "Periode reviews",
            "positive": "Positief",
            "rating": "Rating",
            "score": "Score",
            "search": "Zoeken",
            "total": "Totaal",
            "totalReviews": "Totaal reviews",
            "until": "t/m"
        },
        "stats": {
            "negativeReviews": "NEGATIEVE REVIEWS",
            "positiveReviews": "POSITIEVE REVIEWS",
            "totalReviews": "TOTAAL REVIEWS",
            "view": "bekijken"
        },
        "statsDisplay": {
            "hideChart": "Grafiek verbergen",
            "showChart": "Grafiek tonen"
        },
        "tabs": {
            "export": "Exporteren",
            "feed": "Feed",
            "products": "Producten",
            "settings": "Instellingen"
        }
    },
    "salesDashboard": {
        "bannerBody": "Analyseer je verkopen, winst en omzet per product en periode in één overzicht.",
        "bannerTitle": "Verkoopdashboard",
        "chart": {
            "revenueLabel": "Omzet"
        },
        "infoMessage": "We berekenen deze cijfers aan de hand van de binnenkomende orders en retouren van Bol.\nDeze cijfers zijn niet altijd hetzelfde als degene die bol zelf in zijn portaal gebruikt.\nGebruik deze cijfers daarom alleen ter indicatie.\nVoor hulp bij de BTW-aangifte, hebben we de BTW-aangifte tool.",
        "chooseAccounts": "Kies account(s)",
        "combineSales": "Sales combineren",
        "crumb": "Sales Dashboard",
        "customPeriod": {
            "apply": "Toepassen",
            "cancel": "Annuleren",
            "datePlaceholder": "dd-mm-jjjj",
            "from": "Vanaf",
            "title": "Aangepaste periode",
            "until": "Tot en met"
        },
        "emptyMessage": "Geen verkopen gevonden",
        "exportFailedMsg": "Het exporteren van de data is niet gelukt.",
        "exportFailedTitle": "Exporteren mislukt",
        "exportToExcel": "Exporteren naar Excel",
        "period": {
            "currentMonth": "Deze maand",
            "custom": "Aangepast...",
            "lastMonth": "Vorige maand",
            "sevenDays": "Afgelopen 7 dagen",
            "thirtyDays": "Afgelopen 30 dagen",
            "today": "Vandaag",
            "total": "Afgelopen 90 dagen",
            "yesterday": "Gisteren"
        },
        "productCostsUpload": {
            "cancel": "Annuleren",
            "chooseFile": "Kies een .xlsx bestand om te uploaden...",
            "downloadAllCosts": "alle productkosten die je al ingesteld hebt.",
            "downloadHere": "Download hier",
            "exportFailedMsg": "Het exporteren van de data is niet gelukt.",
            "exportFailedTitle": "Exporteren mislukt",
            "importFailedMsg": "Het importeren van de productkosten is niet gelukt.",
            "importFailedTitle": "Importeren mislukt",
            "importedSnackbar": "De productkosten zijn geïmporteerd",
            "intro": "Je kunt hier de kosten (<0>excl. BTW</0>) van producten in bulk uploaden.",
            "partialSuccess": "Het importeren van de productkosten is deels gelukt, maar de volgende fouten zijn gevonden:",
            "partialSuccessTitle": "Importeren deels gelukt",
            "rowLabel": "Regel",
            "templateInfo": "het voorbeeld van het juiste format.",
            "title": "Productkosten importeren",
            "upload": "Uploaden",
            "uploadImportFile": "Importbestand uploaden",
            "uploadOnlyXlsx": "Upload enkel een .xlsx bestand (Excel standaard) in de opmaak uit het voorbeeld.",
            "viewDownloadHere": "Bekijk en download hier"
        },
        "recalculate": "Opnieuw berekenen",
        "search": "Zoeken",
        "stats": {
            "calculatedWithCosts": "wordt enkel berekend met producten waarvoor de kosten zijn ingesteld.",
            "margin": "WINSTMARGE",
            "marginInfoTitle": "De winstmarge",
            "previousPeriod": "VORIGE PERIODE",
            "profit": "WINST",
            "profitInfoTitle": "De winst",
            "quantity": "AANTAL VERKOCHT",
            "revenue": "OMZET"
        },
        "totalPeriodRevenue": "TOTALE PERIODE OMZET",
        "uploadProductCosts": "Productkosten importeren"
    },
    "salesDashboardV2": {
        "allShops": "Alle winkels",
        "breadcrumb": "Sales Dashboard",
        "columns": "Kolommen",
        "comparison": "Vergelijking",
        "editCosts": {
            "loadFailed": "Het laden van het product is niet gelukt.",
            "loadFailedTitle": "Laden mislukt"
        },
        "errorLoadProducts": "Het laden van de producten is niet gelukt.",
        "errorLoadTotals": "Het laden van de totalen is niet gelukt.",
        "export": "Export",
        "uploadProductCosts": "Productkosten importeren",
        "filters": {
            "addFilter": "Filter toevoegen",
            "and": "en",
            "apply": "Toepassen",
            "between": "Tussen",
            "deleteFilter": "Filter verwijderen",
            "equals": "Gelijk aan",
            "gt": "Groter dan",
            "gte": "Groter dan of gelijk aan",
            "lt": "Kleiner dan",
            "lte": "Kleiner dan of gelijk aan",
            "matchAll": "Match alle regels",
            "matchAny": "Match een van de regels",
            "notEquals": "Niet gelijk aan",
            "value": "Waarde"
        },
        "loadFailed": "Laden mislukt",
        "margin": "Marge",
        "nColumns": "{{count}} kolommen",
        "nShops": "{{count}} winkels",
        "numOrders": "Aantal orders",
        "oneColumn": "1 kolom",
        "oneShop": "1 winkel",
        "period": "Periode",
        "productDetails": {
            "salesProductStats": {
                "adRevenue": "Omzet uit Ads",
                "avgMargin": "Marge (gemiddeld)",
                "costs": "Kosten",
                "costsCum": "Kosten (opgeteld)",
                "cumulative": "Opgeteld",
                "allProductsCumulative": "Alle producten opgeteld",
                "errorLoadProduct": "Het laden van het product is niet gelukt.",
                "loadFailed": "Laden mislukt",
                "organicRevenue": "Omzet organisch",
                "profit": "Winst",
                "profitCum": "Winst (opgeteld)",
                "profitExcl": "Winst (excl. BTW)",
                "quantitySold": "Aantal verkocht",
                "quantitySoldCum": "Aantal verkocht (opgeteld)",
                "returnQuantity": "Aantal retour",
                "returnQuantityCum": "Aantal retour (opgeteld)",
                "returnRevenue": "Retour omzet",
                "returnRevenueCum": "Retour omzet (opgeteld)",
                "returnRevenueExcl": "Retour omzet (excl. BTW)",
                "revenue": "Omzet",
                "revenueCum": "Omzet (opgeteld)",
                "revenueExcl": "Omzet (excl. BTW)",
                "revenueIncl": "Omzet (incl. BTW)",
                "viewOnBol": "Bekijken op Bol",
                "globalPerformance": "Globale Prestaties",
                "barGraph": "Staafdiagram",
                "lineGraph": "Lijndiagram"
            }
        },
        "profitExcl": "Winst excl. BTW",
        "returnRevenueAlt": "Omzet retour",
        "revenueExcl": "Omzet excl. BTW",
        "revenueIncl": "Omzet incl. BTW",
        "salesFrom": "Sales from",
        "searchPlaceholder": "Zoek producttitel of EAN...",
        "shops": "Winkels",
        "table": {
            "adCosts": "Advertentie kosten",
            "adRevenue": "Advertentie omzet",
            "advertising": "Adverteren",
            "commission": "Commissie",
            "costs": "Kosten",
            "marginPct": "Marge %",
            "noProducts": "Geen producten gevonden",
            "noProductsHint": "Pas je filters aan of voeg zoekwoorden toe.",
            "noResults": "0 resultaten",
            "organicRevenue": "Organische omzet",
            "organicSold": "Organisch verkocht",
            "paginationRange": "{{firstRow}}–{{lastRow}} van {{total}}",
            "previous": "Vorige",
            "product": "Product",
            "productCosts": "Productkosten",
            "productPlural": "producten",
            "productSingular": "product",
            "profit": "Winst",
            "quantitySold": "Aantal verkocht",
            "returnCommission": "Retour commissie",
            "returnCosts": "Retour kosten",
            "returnQuantity": "Aantal retour",
            "returnRevenue": "Retour omzet",
            "returns": "Retouren",
            "revenue": "Omzet",
            "rowsPerPage": "Rijen per pagina",
            "sales": "Verkopen",
            "vat": "BTW",
            "stock": "Voorraad",
            "stockInfo": "Huidige voorraad van het product, onafhankelijk van de geselecteerde periode."
        },
        "importExport": {
            "title": "Productkosten Importeren & Exporteren"
        }
    },
    "searchRankings": {
        "addKeywords": {
            "add": "Toevoegen",
            "bulkHint": "In bulk toevoegen?",
            "busy": "Bezig...",
            "clickHere": "Klik hier",
            "keyword": "Keyword",
            "placeholder": "Voer een zoekwoord in",
            "snackbarAdded": "Keyword toegevoegd",
            "snackbarError": "Er is iets misgegaan",
            "title": "Keyword toevoegen"
        },
        "allStores": "Alle winkels",
        "noStores": "Niets geselecteerd",
        "apiBannerTitle": "Welkom bij Search Rankings!",
        "apiBanner": "Bekijk hier hoe hoog jouw producten in de zoekresultaten verschijnen.\nTrack de keywords van Bol en voeg zelf jouw belangrijkste keywords toe.\n\nVernieuw eerst jouw koppeling met Bol:",
        "banner": {
            "text": "Volg hier wekelijks de posities van je producten in de zoekresultaten van bol.\nPer product tonen we de belangrijkste zoektermen volgens bol.\nJe kunt ook zelf extra zoektermen toevoegen om te volgen.\n\nDe getoonde posities zijn de gemiddelde rankings die wij van bol ontvangen.\nDeze kunnen afwijken van de zoekresultaten die je zelf op bol ziet, omdat bol regelmatig A/B-testen uitvoert."
        },
        "columns": {
            "buyboxPercent": "Koopblok %",
            "categories": "Categorieën",
            "keywords": "Keywords",
            "month": "Maand",
            "monthly": "Maandelijks",
            "nps": "NPS",
            "quarter": "Kwartaal",
            "review": "Review",
            "reviews": "Reviews",
            "searchVolume": "Zoekvolume",
            "tooltipBuyboxPercent": "Percentage tijd met het koopblok",
            "tooltipMonth": "Data beschikbaar na 30 dagen tracking",
            "tooltipNps": "Klanttevredenheid op basis van reviews. Wordt automatisch geladen zodra er reviews beschikbaar zijn",
            "tooltipQuarter": "Data beschikbaar na 90 dagen tracking",
            "tooltipRankMonth": "Gemiddelde ranking afgelopen 30 dagen op basis van keywords",
            "tooltipRankQuarter": "Gemiddelde ranking afgelopen 90 dagen op basis van keywords",
            "tooltipRankWeek": "Gemiddelde ranking afgelopen 7 dagen op basis van keywords",
            "tooltipReview": "Review data wordt automatisch geladen zodra er reviews beschikbaar zijn",
            "week": "Week"
        },
        "controlBar": {
            "allStores": "Alle winkels",
            "noStores": "Niets geselecteerd",
            "avg": "Gem.",
            "best": "Beste",
            "columns": "Kolommen",
            "columnsCount": "{{count}} kolommen",
            "comingSoon": "Binnenkort beschikbaar",
            "country": "Land",
            "export": "Export",
            "import": "Import",
            "oneColumn": "1 kolom",
            "oneStore": "1 winkel",
            "period": "Periode",
            "searchProducts": "Zoek producten...",
            "stores": "Winkels",
            "storesCount": "{{count}} winkels"
        },
        "crumb": "Search Rankings",
        "dialog": {
            "addKeywordFailedMessage": "Het toevoegen van het keyword is niet gelukt.",
            "addKeywordFailedTitle": "Toevoegen mislukt"
        },
        "importKeywords": {
            "busy": "Bezig...",
            "csvFile": "CSV-bestand",
            "csvFormat": "CSV-formaat (kolom EAN ; kolom keyword)",
            "dropZoneHint": "Formaat: EAN;keyword per regel",
            "dropZoneText": "Klik om een bestand te selecteren of sleep het hierheen",
            "howItWorks": "Hoe werkt het?",
            "import": "Importeren",
            "importLabel": "Keywords importeren:",
            "moreProducts": "...en {{count}} andere product(en)",
            "paste": "Plakken",
            "previewLabel": "{{keywordCount}} keyword(s) voor {{eanCount}} product(en)",
            "progressText": "Importeren...",
            "snackbarFailed": "{{total}} keywords mislukt",
            "snackbarFailedAll": "Importeren is mislukt",
            "snackbarImported": "{{total}} keywords geïmporteerd",
            "title": "Keywords importeren",
            "uploadCsvTxt": "Upload een CSV- of TXT-bestand met puntkomma-gescheiden kolommen:",
            "uploadFile": "Bestand uploaden",
            "useThisFormat": "Gebruik het volgende formaat:",
            "withSemicolon": "Met puntkomma"
        },
        "kpi": {
            "avgRank": "Gem. zoekpositie",
            "bestRank": "Beste zoekpositie",
            "keywordsTop10": "Keywords in Top 10",
            "keywordsTop3": "Keywords in Top 3",
            "totalCategories": "Totaal categorieën",
            "totalKeywords": "Totaal keywords",
            "totalSearchVolume": "Totaal zoekvolume",
            "visibility": "Zichtbaarheid",
            "visibilityTooltip": "Percentage van producten zichtbaar in de top 10"
        },
        "positionFilter": {
            "all": "Alle",
            "bottom100": ">100",
            "label": "Positiefilters:",
            "top1": "Top 1",
            "top10": "Top 10",
            "top3": "Top 3",
            "top30": "Top 30",
            "top5": "Top 5"
        },
        "snackbar": {
            "exportDone": "Excel export voltooid.",
            "keywordAdded": "Keyword \"{{keyword}}\" toegevoegd, eerste data is morgen beschikbaar",
            "preferencesSaved": "Voorkeuren opgeslagen"
        },
        "upgradeForHigherLimit": "Upgrade voor hoger limiet",
        "upgradeLimit": {
            "confirm": "Naar abonnement gaan",
            "errorMessage": "Het toevoegen van de module is niet gelukt.",
            "errorTitle": "Toevoegen mislukt",
            "message": "Upgrade om extra zoektermen te kunnen tracken.\n\nVoeg Bluemate Premium toe in jouw abonnement en ga van 100 naar 10.000 zoektermen.",
            "snackbarAdded": "De module is toegevoegd aan het abonnement",
            "title": "Bluemate Premium"
        },
        "table": {
            "eanCopied": "EAN gekopieerd",
            "emptyText": "Pas je filters aan of voeg zoekwoorden toe.",
            "emptyTitle": "Geen producten gevonden",
            "firstPage": "Eerste pagina",
            "lastPage": "Laatste pagina",
            "nextPage": "Volgende pagina",
            "noResults": "0 resultaten",
            "paginationInfo": "{{first}}–{{last}} van {{total}}",
            "prevPage": "Vorige pagina",
            "productPortfolio": "Product",
            "rankInclusiveSponsored": "Inclusief sponsored",
            "rankSponsoredPosition": "Sponsored positie",
            "rowsPerPage": "Rijen per pagina",
            "viewOnBol": "Bekijk op bol.com",
            "noDataAddKeyword": "Geen data van bol. Voeg keywords toe."
        },
        "productDetails": {
            "monthlySearchVolume": "Zoekvolume van afgelopen maand",
            "showKeyword": "Toon Keyword",
            "hideKeyword": "Verberg Keyword",
            "autoCreatedKeyword": "Via Bol API",
            "manualCreatedKeyword": "Handmatig toegevoegd",
            "winningBid": "Winnend bod voor advertenties",
            "openSearchVolume": "Open keyword in Zoekvolume",
            "loadingSuggestions": "Suggesties aan het laden...",
            "suggestion": "Suggestie",
            "addKeyword": "Keyword toevoegen",
            "ignoreSuggestion": "Suggestie negeren",
            "showCategory": "Toon Categorie",
            "hideCategory": "Verberg Categorie",
            "errorLoadingKeywords": "Er is iets misgegaan bij het laden van de Keywords.",
            "errorLoadingCategories": "Er is iets misgegaan bij het laden van de categorieën.",
            "keywordRestored": "Keyword hersteld",
            "keywordArchived": "Keyword gearchiveerd",
            "keywordArchiveError": "Er is iets misgegaan bij het archiveren van de Keyword.",
            "categoryArchived": "Categorie gearchiveerd",
            "categoryRestored": "Categorie hersteld",
            "categoryArchiveError": "Er is iets misgegaan bij het archiveren van de categorie.",
            "hideArchived": "Verberg gearchiveerd",
            "showArchived": "Gearchiveerd ({archivedKeywordsCount})",
            "noKeywords": "Nog geen keywords voor dit product. Voeg er een toe om rankings te tracken.",
            "noCategories": "Nog geen categorieën gevonden voor dit product",
            "loadNewSuggestions": "Laad nieuwe suggesties",
            "noDataFromBol": "Geen data van bol ontvangen"
        },
        "buyBox": "Koopblok",
        "searchVol": "Zoek Vol.",
        "keywordsLimitReached": "Keywords limiet bereikt",
        "addAKeyword": "Voeg een keyword toe..."
    },
    "searchVolume": {
        "aiAnalysis": "Markttrendanalyse met BluemateAI",
        "analyzeBtn": "Analyseren met BluemateAI",
        "analyzeFailedMessage": "Het analyseren van de data is niet gelukt.",
        "analyzeFailedTitle": "Analyse mislukt",
        "averageMonthly": "Gemiddeld zoekvolume per maand",
        "banner": {
            "body": "Bekijk de zoekvolumes op bol. Vergelijk termen om kansen te vinden.",
            "title": "Zoekvolume"
        },
        "chooseSearchTerm": "Kies een zoekterm",
        "combineTerms": "Meerdere zoekwoorden combineren",
        "combinedSuffix": " - Opgeteld",
        "country": {
            "be": "België",
            "nl": "Nederland"
        },
        "crumb": "Zoekvolume",
        "keyword": "Zoekwoord",
        "keywordPlaceholder": "Voer hier een zoekwoord in",
        "loadFailedMessage": "Het laden van de zoekvolume is niet gelukt.",
        "loadFailedTitle": "Laden mislukt",
        "nlVsBePeriod": "Nederland vs België per periode",
        "nlVsBeTotal": "Nederland vs België totaal",
        "period": {
            "label": "Periode",
            "last14Days": "Laatste 14 dagen",
            "last2Years": "Laatste 2 jaar",
            "last3Months": "Laatste 3 maanden",
            "last6Months": "Laatste 6 maanden",
            "lastMonth": "Laatste maand",
            "lastWeek": "Laatste week",
            "lastYear": "Laatste jaar"
        },
        "periodLabel": {
            "12months": "12 maanden",
            "14days": "14 dagen",
            "24months": "24 maanden",
            "31days": "31 dagen",
            "3months": "3 maanden",
            "6months": "6 maanden",
            "7days": "7 dagen"
        },
        "relatedTerms": "Gerelateerde zoekwoorden",
        "removeAll": "Alles verwijderen",
        "search": "Zoeken",
        "seasonal": "Seizoensgebonden (4 jaar historische data)",
        "title": "Vind zoekvolume en gerelateerde zoekwoorden",
        "totalVolume": "Totaal zoekvolume",
        "totalVolumePrevious": "Totaal zoekvolume (voorgaande",
        "volume": "Zoekvolume"
    },
    "sidebarMenu": {
        "comingSoon": "(binnenkort beschikbaar)",
        "mobileFriendly": "Deze pagina werkt goed op mobiel"
    },
    "settings": {
        "accountUsers": {
            "accessRevoked": "De toegang tot het account is ingetrokken",
            "addUserForPrice": "Gebruiker toevoegen voor +€5/maand",
            "addUserTitle": "Gebruiker toevoegen",
            "bannerBody": "Voeg hier nieuwe gebruikers toe aan het Bluemate account.",
            "bannerTitle": "Gebruikers",
            "chooseRole": "Kies rol...",
            "colAccessSince": "TOEGANG SINDS",
            "colEmail": "E-MAIL",
            "colInvitedBy": "UITGENODIGD DOOR",
            "colInvitedOn": "UITGENODIGD OP",
            "colLastLogin": "LAATST INGELOGD",
            "colLastModified": "LAATST GEWIJZIGD",
            "colLastSent": "LAATST VERZONDEN",
            "colName": "NAAM",
            "colType": "TYPE",
            "crumbAccountUsers": "Gebruikersbeheer",
            "deleteFailedMsg": "Het verwijderen van de gebruiker is niet gelukt.",
            "deleteFailedTitle": "Verwijderen mislukt",
            "deleteInvitationConfirm": "Weet je zeker dat je deze uitnodiging wilt intrekken?",
            "deleteInvitationTitle": "Uitnodiging intrekken",
            "detailed": "Gedetailleerd",
            "editInvitationTitle": "Uitnodiging wijzigen",
            "email": "E-mailadres",
            "invitationResent": "De uitnodiging is opnieuw verzonden",
            "invitationRevoked": "De uitnodiging is ingetrokken",
            "invitationSent": "De uitnodiging is verzonden",
            "invitationUpdated": "De uitnodiging is bijgewerkt",
            "invitationsTitle": "Uitnodigingen",
            "inviteFailedMsg": "Het uitnodigen van de gebruiker is niet gelukt.",
            "inviteFailedTitle": "Uitnodigen mislukt",
            "inviteUser": "+ Gebruiker uitnodigen",
            "loadFailedTitle": "Laden mislukt",
            "loadInvitationsFailedMsg": "Het laden van de uitnodigingen is niet gelukt.",
            "loadUsersFailedMsg": "Het laden van de gebruikers is niet gelukt.",
            "no": "Nee",
            "noInvitations": "- Er zijn geen uitnodigingen gevonden -",
            "noUsers": "- Geen gebruikers gevonden -",
            "resend": "Opnieuw verzenden",
            "revoke": "Intrekken",
            "revokeConfirm": "Weet je zeker dat je de toegang van deze gebruiker tot jouw account wilt verwijderen?",
            "revokeFailedTitle": "Intrekken mislukt",
            "revokeInvitationFailedMsg": "Het intrekken van de uitnodiging is niet gelukt.",
            "revokeTitle": "Toegang verwijderen",
            "rightsUpdated": "De rechten zijn bijgewerkt",
            "role": "Rol",
            "roleAccountantInfo": "Heeft alleen-lezen rechten. Kan wel bekijken, downloaden en exporten, maar kan geen wijzigingen doorvoeren.",
            "roleAdminInfo": "Heeft alle rechten, ook gebruikers toevoegen en verwijderen.",
            "roleCustomerServiceInfo": "Heeft geen toegang tot plekken met financiële cijfers (sales dashboard, btw hulptool, exports, etc). Kan enkel factuuracties uitvoeren.",
            "roleEmployeeInfo": "Kan alles behalve gebruikers toevoegen/verwijderen, abonnement stoppen of verkoopaccount verwijderen",
            "save": "Opslaan",
            "sendFailedMsg": "Het verzenden van de uitnodiging is niet gelukt",
            "sendFailedTitle": "Uitnodiging verzenden mislukt",
            "setRightsTitle": "Rechten instellen",
            "updateFailedTitle": "Bijwerken mislukt",
            "updateInvitationFailedMsg": "Het bijwerken van de uitnodiging is niet gelukt.",
            "updateRightsFailedMsg": "Het bijwerken van de rechten is niet gelukt.",
            "userAlreadyHasAccess": "Deze gebruiker heeft al toegang tot het account.",
            "usersTitle": "Gebruikers",
            "yes": "Ja"
        },
        "api": {
            "activate": "Activeren",
            "activateFailedMsg": "Het activeren van de API key is niet gelukt.",
            "activateFailedTitle": "Activeren mislukt",
            "activated": "De API koppeling is geactiveerd",
            "bannerBody": "Beheer jouw koppeling tussen bol en Bluemate.",
            "bannerTitle": "Koppeling met Bol",
            "colActiveUntil": "ACTIEF TOT",
            "colName": "NAAM",
            "colSellerNumber": "BOL VERKOOPNUMMER",
            "colStatus": "STATUS",
            "crumbApi": "API",
            "crumbSettings": "Instellingen",
            "deactivateFailedMsg": "Het deactiveren van de API koppeling is niet gelukt.",
            "deactivateFailedTitle": "Deactivatie mislukt",
            "demoNotAllowedMsg": "Deze actie is niet toegestaan in het demo account.",
            "demoNotAllowedTitle": "Actie niet toegestaan",
            "disconnect": "Koppeling verbreken",
            "disconnectConfirm": "Weet je zeker dat je deze API koppeling wilt verbreken?",
            "disconnectTitle": "API koppeling verbreken",
            "disconnected": "De API koppeling is verbroken",
            "emptyLabel": "Je hebt geen API koppeling",
            "expiredMsg": "De API koppeling is verlopen en kan niet meer gebruikt worden. Je kunt in je Bol account nieuwe API sleutels aanmaken en de API koppeling daarmee instellen via de Wijzigen optie van de API koppeling.",
            "expiredTitle": "Koppeling verlopen",
            "listTitle": "Koppeling met Bol (Retailer API)",
            "loadFailedMsg": "Het laden van je API keys is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "modify": "Wijzigen",
            "no": "Nee",
            "reconnect": "Opnieuw koppelen",
            "setupApi": "API koppeling instellen",
            "yes": "Ja"
        },
        "common": {
            "accountDeleted": "Je account is verwijderd",
            "accountUpdateFailed": "Het wijzigen van je bedrijfsgegevens is niet gelukt.",
            "additionalCompanyInfo": "Aanvullende bedrijfsgegevens",
            "additionalCompanyInfoSub": "Deze informatie gebruiken we op de factuur voor jouw klanten",
            "address": "Adres *",
            "bannerBody": "Beheer hier jouw persoonlijke - en bedrijfsgegevens. Deze informatie gebruiken we voor communicatie, facturatie en betaling. Zorg dat dit klopt!",
            "bannerTitle": "Instellingen & bedrijfsgegevens",
            "changesSaved": "De wijzigingen zijn opgeslagen",
            "city": "Stad *",
            "cocNumber": "KvK nummer",
            "companyEmail": "E-mailadres * (ontvangst van klanten mails)",
            "companyInfo": "Bedrijfsgegevens",
            "companyInfoSub": "Deze gegevens gebruiken we richting jouw klanten",
            "companyName": "Bedrijfsnaam *",
            "createAccount": "Account aanmaken",
            "crumbCommon": "Algemeen",
            "crumbSettings": "Instellingen",
            "deleteAccountConfirm": "Weet je zeker dat je je account wilt verwijderen? Hierbij gaan alle gegevens definitief verloren.",
            "deleteAccountFailed": "Het verwijderen van je account is niet gelukt.",
            "deleteAccountTitle": "Account verwijderen",
            "deleteFailedTitle": "Verwijderen mislukt",
            "deleteLogin": "Login verwijderen",
            "deleteLoginFailed": "Het verwijderen van je login is niet gelukt.",
            "deleteSalesAccount": "Verwijder dit verkoopaccount ({{label}})",
            "deleteWholeAccount": "Verwijder geheel Bluemate account",
            "deleteWholeAccountConfirm": "Weet je zeker dat je je gehele account wilt verwijderen?",
            "deleteWholeAccountTitle": "Geheel Bluemate account verwijderen",
            "errAddress": "Vul het adres in",
            "errCity": "Vul de stad in",
            "errCompanyEmail": "Vul het e-mailadres in",
            "errCompanyName": "Vul de bedrijfsnaam in",
            "errEmail": "Vul je e-mailadres in",
            "errEmailInvalid": "Vul een geldig e-mailadres in",
            "errFirstname": "Vul je voornaam in",
            "errLastname": "Vul je achternaam in",
            "errPhone": "Vul het telefoonnummer in",
            "errZipCode": "Vul de postcode in",
            "firstname": "Voornaam *",
            "here": "hier",
            "iban": "IBAN",
            "lastAccountDeletedMsg": "Je hebt geen accounts meer op het platform. Wil je een nieuw account aanmaken?",
            "lastAccountDeletedTitle": "Account verwijderd",
            "lastname": "Achternaam *",
            "leavePage": "Nee, pagina verlaten",
            "loginDeleted": "Je login is verwijderd",
            "no": "Nee",
            "personalInfo": "Persoonlijke informatie",
            "personalInfoSub": "Hiermee houden we contact met elkaar",
            "save": "Opslaan",
            "saveChanges": "Ja, wijzigingen opslaan",
            "subscriptionInvoiceNotice": "Let op, jouw eigen Bluemate abonnement factuurgegevens wijzigen? Dat doe je",
            "telNumber": "Telefoonnummer *",
            "unsavedChanges": "De wijzigingen gaan verloren als je de pagina verlaat. Wil je de wijzigingen eerst opslaan?",
            "updateFailedTitle": "Wijzigen mislukt",
            "userEmail": "Account mailadres * (om mee in te loggen)",
            "userEmailDisabled": "Wil je het hoofdaccount e-mailadres waarmee je inlogt aanpassen? Vraag dit aan bij onze support.",
            "userUpdateFailed": "Het wijzigen van je persoonlijke gegevens is niet gelukt.",
            "vatNumberDefault": "BTW nummer standaard",
            "vatNumberOptional": "BTW nummer (indien van toepassing)",
            "vatNumberPerCountry": "Afwijkend BTW nummer per land",
            "yes": "Ja",
            "zipCode": "Postcode *"
        },
        "demoAccount": "Demo account",
        "email": {
            "attention": "Let op:",
            "bannerBody": "Beheer hier hoe e-mails worden verzonden, getrackt en opgebouwd. Deze instellingen hebben invloed op statistieken en de precieze inhoud van e-mails.",
            "bannerTitle": "E-mailinstellingen",
            "close": "Sluiten",
            "do": "WEL",
            "dont": "NIET",
            "example": "Voorbeeld:",
            "leavePage": "Nee, pagina verlaten",
            "maxProductNameChars": "Maximaal aantal tekens in productnaam",
            "maxProductNameInfo": "Met deze instelling kan je instellen hoeveel tekens er maximaal in de e-mails gebruikt worden voor de productnaam. Producten met een langere naam dan dit aantal tekens worden afgekapt door \"...\".",
            "moreInfo": "Meer informatie",
            "noReplyInfo1": "In april 2022 heeft Bol een update in zijn e-mailsysteem doorgevoerd waardoor externe links (alle links die niet direct naar Bol leiden) als tekst worden toegevoegd in de mail. Bol geeft aan dit uit veiligheidsoverwegingen te hebben gedaan, omdat klanten hierdoor kunnen zien waar ze heen gestuurd worden voordat ze op een link / knop klikken.",
            "noReplyInfo2": "Door deze update werd de layout van de e-mails die via ons platform werden verzonden mogelijk verstoord, hierdoor hebben wij onze statistieken van de e-mails tijdelijk uitgeschakeld.",
            "noReplyInfo3": "Inmiddels hebben we in gesprek met Bol een oplossing gevonden waarmee wij weer statistieken van de e-mails kunnen tonen. Met deze oplossing worden de e-mails verzonden door een \"noreply\" adres, waardoor het platform van Bol de mail anders verwerkt en niet de links als tekst in de mails plaatst. De klant zal de mail ontvangen van het adres noreply@verkopen.Bol. Het gevolg hiervan is dat de klant niet meer zal kunnen reageren op de e-mail, omdat deze van het \"noreply\" adres van Bol komt.",
            "noReplyKeywords": "onderweg, verstuurd, verzonden, shipped, is geleverd, factuur, bevestiging, track & trace, track and trace, nieuwsbrief, wil je ons helpen, bedankt, thank, dankjewel, dankuwel, pakbon, wat vindt u van, levering, ingepakt, bezorgd, ingepland, aangemeld, afgeleverd, verzending, ontvangen, nota, invoice, pending, planned, received",
            "noReplyKeywordsInfo": "bij het gebruik van bepaalde kernwoorden in het onderwerp van de mail zal de e-mail ongeacht je keuze door het \"noreply\" adres van Bol verzonden worden. Bol geeft aan dat het om de volgende kernwoorden gaat:",
            "noReplyStatus": "\"noreply\" afzender wordt {{label}} gebruikt, er worden {{statsLabel}} mail statistieken verzameld, klanten kunnen {{replyLabel}} rechtstreeks reageren op de mails",
            "none": "GEEN",
            "productNameSub": "Beperk het aantal tekens dat gebruikt wordt voor de productnaam in e-mails.",
            "productNameTitle": "Productnaam",
            "save": "Opslaan",
            "saveChanges": "Ja, wijzigingen opslaan",
            "saveFailedMsg": "Het opslaan van de instellingen is niet gelukt.",
            "saveFailedTitle": "Opslaan mislukt",
            "sendToCanceledStatus": "E-mails voor geannuleerde bestellingen worden {{label}} verzonden",
            "sendToCanceledSub": "Met deze instelling bepaal je of er mails verzonden moeten worden voor bestellingen die geannuleerd zijn.",
            "sendToCanceledTitle": "Mails voor geannuleerde bestellingen verzenden",
            "settingsSaved": "De instellingen zijn opgeslagen",
            "statsSub": "Gebruik de \"noreply\" afzender om statistieken over je mails te kunnen verzamelen.",
            "statsTitle": "E-mail statistieken",
            "ublStatus": "UBL bijlage {{label}} toevoegen aan e-mails",
            "ublSub": "Voeg naast de PDF factuur ook een UBL bestand toe aan de e-mails. UBL bestanden worden vaak gebruikt voor automatische verwerking in de boekhouding.",
            "ublTitle": "UBL bijlage",
            "unlimited": "Onbeperkt",
            "unsavedChanges": "De wijzigingen gaan verloren als je de pagina verlaat. Wil je de wijzigingen eerst opslaan?"
        },
        "export": {
            "apply": "Toepassen",
            "bannerBody": "Exporteer jouw facturen en factuurgegevens.",
            "bannerTitle": "Facturen exporteren",
            "cancel": "Annuleren",
            "chooseFields": "Velden kiezen",
            "colAction": "ACTIE",
            "colFileType": "BESTANDSTYPE",
            "colPeriod": "PERIODE",
            "colRequestDate": "AANVRAAG DATUM",
            "combinedInfo": "Alle factuur- en BTW totalen worden bij elkaar opgeteld en op één factuur gezet.",
            "country": "Land",
            "create": "Aanmaken",
            "createFailedMsg": "Het aanmaken van de export is niet gelukt.",
            "createFailedTitle": "Aanmaken mislukt",
            "crumbExport": "Exporteren",
            "crumbSettings": "Instellingen",
            "customerAll": "Alle klanten",
            "customerBusiness": "Zakelijke klanten",
            "customerPrivate": "Particuliere klanten",
            "customerType": "Type klant",
            "datePlaceholder": "dd/mm/jjjj",
            "disclaimer1": "Het aanmaken van het bestand kan even duren. Zodra deze klaar is, staat de download hieronder klaar. Je kunt ondertussen deze pagina verlaten.",
            "disclaimer2": "Gebruik van gegevens op eigen risico.",
            "download": "Downloaden",
            "downloadFailedMsg": "Het downloaden van het bestand is niet gelukt.",
            "downloadFailedTitle": "Downloaden mislukt",
            "downloads": "Downloads",
            "downloadsSub": "Download de aangemaakte export hieronder.",
            "errFromDate": "Kies de datum vanaf wanneer de facturen geëxporteerd moeten worden.",
            "errToBeforeFrom": "De Tot en met datum kan niet voor de Vanaf datum zijn.",
            "errToDate": "Kies de datum tot en met wanneer de facturen geëxporteerd moeten worden.",
            "error": "Fout",
            "errorTitle": "Fout",
            "exportCreating": "De export wordt aangemaakt",
            "exportSub": "Exporteren van de facturen of gegevens van een bepaalde periode.",
            "exportTitle": "Exporteren",
            "exporting": "Bezig met exporteren...",
            "field": "veld",
            "fields": "velden",
            "fieldsSelected": "{{count}} {{label}} geselecteerd",
            "fileType": "Bestandstype",
            "filenameBase": "Bestandsnaam baseren op",
            "filters": "Filters",
            "from": "Vanaf",
            "fulfilmentBoth": "Iedere verzending",
            "fulfilmentFbb": "LVB",
            "fulfilmentFbr": "Eigen verzending",
            "fulfilmentType": "Type verzending",
            "invoice": "factuur",
            "invoiceCount": "{{count}} {{label}} geselecteerd",
            "invoiceFields": "Factuur velden",
            "invoices": "facturen",
            "loadCountFailedMsg": "Het laden van het aantal facturen is niet gelukt.",
            "loadExportsFailedMsg": "Het laden van de exports is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "nameInvoiceNumber": "Factuurnummer",
            "nameOrderId": "Ordernummer (Bol)",
            "noFiles": "- nog geen bestanden aangemaakt -",
            "orderFields": "Factuurregel velden",
            "period": "Periode",
            "ready": "Gereed",
            "reverseChargeOnly": "Alleen verlegde BTW",
            "selectFieldsTitle": "Exportvelden selecteren",
            "to": "Tot en met",
            "typeCombinedPdf": "Gecombineerde PDF",
            "typeCsv": "CSV (Excel)",
            "typeCsvCustom": "CSV (aangepast)",
            "typePdf": "PDF",
            "typeUbl": "UBL (boekhouding standaard)"
        },
        "invoice": {
            "autoCreateCredit": "Creditfacturen automatisch aanmaken",
            "autoCreditInfo1": "Bluemate importeert automatisch periodiek al je retourzendingen van de afgelopen 3 maanden. Wanneer een retourzending door jou als verkoper is verwerkt en Bol het bedrag van de retourzending aan je klant heeft terugbetaald kunnen wij automatisch een creditfactuur aanmaken aan de hand van de retourzending. Deze creditfactuur kunnen wij ook direct, of met een vertraging, naar je klant verzenden.",
            "autoCreditInfo2": "De creditfactuur kan alleen automatisch aangemaakt worden wanneer de retourzending volledig afgehandeld is en Bol het bedrag aan je klant heeft teruggestort.",
            "autoCreditTitle": "Automatische creditfacturen",
            "autoSendCredit": "Creditfacturen automatisch verzenden",
            "automate": "Automatiseren",
            "bannerBody": "Beheer de details van jouw facturen. Automatiseer creditfacturen.",
            "bannerTitle": "Factuurinstellingen",
            "creditNumberInfo": "De norm is dat de creditfactuur de nummerreeks van de gewone factuur volgt. Met deze optie kun je ervoor zorgen dat de creditfactuur een aparte nummerreeks volgt. Bijvoorbeeld {{year}}-credit-0001",
            "creditSettings": "Creditfactuur instellingen",
            "crumbInvoices": "Facturen",
            "crumbSettings": "Instellingen",
            "day1": "1 dag na verwerking",
            "day14": "14 dagen na verwerking",
            "day3": "3 dagen na verwerking",
            "day7": "7 dagen na verwerking",
            "dayCustom": "Aangepast",
            "dayCustomInput": "{{days}} dagen na verwerking",
            "dayReturnProcessed": "Retour verwerkt",
            "differNumbers": "Aparte factuurnummerreeks voor creditfacturen gebruiken",
            "emailForCredit": "E-mail voor creditfacturen",
            "emailForCreditSub": "Deze mail wordt gebruikt voor de verzending van creditfacturen (automatisch & handmatig)",
            "errInvalid": "Niet geldig",
            "example": "Voorbeeld",
            "filenameBase": "Bestandsnaam baseren op",
            "invoiceNumber": "Factuurnummer",
            "leavePage": "Nee, pagina verlaten",
            "loadFailedMsg": "Het laden van de instellingen is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "moreInfo": "Meer informatie",
            "numbering": "Factuurnummering",
            "ok": "Oké",
            "orderNumber": "Ordernummer",
            "prefix": "Voorvoegsel",
            "save": "Opslaan",
            "saveChanges": "Ja, wijzigingen opslaan",
            "saveFailedMsg": "Het opslaan van de factuurinstellingen is niet gelukt.",
            "saveFailedTitle": "Opslaan mislukt",
            "settingsSaved": "De instellingen zijn opgeslagen",
            "startWith": "Starten met",
            "unsavedChanges": "De wijzigingen gaan verloren als je de pagina verlaat. Wil je de wijzigingen eerst opslaan?",
            "updateFailedMsg": "Het bijwerken van de instellingen is niet gelukt.",
            "updateFailedTitle": "Bijwerken mislukt",
            "yearCodeInfo": "Met de tekstcode {jaar} vullen we automatisch het juiste jaartal in."
        },
        "language": {
            "en": "Engels",
            "label": "Taal",
            "nl": "Nederlands"
        },
        "password": {
            "bannerBody": "We raden aan tweestapsverificatie in te schakelen. Je hoeft dan ook je e-mail niet meer te verifieren.",
            "bannerTitle": "Beveiliging",
            "changeFailedMsg": "Het wijzigen van je wachtwoord is niet gelukt.",
            "changeFailedTitle": "Wijzigen mislukt",
            "changeSub": "We raden sterk aan om iedere 60 dagen je wachtwoord te wijzigen",
            "changeTitle": "Wachtwoord wijzigen",
            "changed": "Je wachtwoord is gewijzigd",
            "confirmPassword": "Bevestig wachtwoord *",
            "confirmPasswordPlaceholder": "Bevestig wachtwoord",
            "crumbSecurity": "Beveiliging",
            "crumbSettings": "Instellingen",
            "currentPassword": "Huidig wachtwoord *",
            "currentPasswordPlaceholder": "Huidig wachtwoord",
            "dataUsageSub": "Hier geef je aan of het ons is toegestaan jouw data mee te nemen om onze Product Research inschattingen te verbeteren. Jouw exacte verkoopcijfers worden nooit getoond aan anderen.",
            "dataUsageTitle": "Data gebruiken voor verbetering",
            "dataUsageToggleTitle": "Verbeteren toegestaan",
            "disableFailedTitle": "Uitschakelen mislukt",
            "errConfirm": "Bevestig het nieuwe wachtwoord",
            "errCurrent": "Vul je huidige wachtwoord in",
            "errMismatch": "De wachtwoorden komen niet overeen",
            "errNew": "Vul een nieuwe wachtwoord in",
            "leavePage": "Nee, pagina verlaten",
            "newPassword": "Nieuw wachtwoord *",
            "newPasswordPlaceholder": "Nieuw wachtwoord",
            "off": "UIT",
            "on": "AAN",
            "save": "Opslaan",
            "saveChanges": "Ja, wijzigingen opslaan",
            "twoFactorDisableExplanation": "Voer de tweestapsverificatie code in om deze uit te schakelen.",
            "twoFactorDisableFailedMsg": "Het uitschakelen van de tweestapsverificatie is niet gelukt.",
            "twoFactorDisabled": "Tweestapsverificatie is uitgeschakeld",
            "twoFactorSub": "Met tweestapsverificatie voeg je een extra beveiligingslaag toe aan je account.",
            "twoFactorTitle": "Tweestapsverificatie",
            "unsavedChanges": "De wijzigingen gaan verloren als je de pagina verlaat. Wil je de wijzigingen eerst opslaan?"
        },
        "subscription": {
            "accountNumberLabel": "Rekeningnummer:",
            "activateFailedTitle": "Activeren mislukt",
            "activeNotificationsHeader": "De volgende notificaties staan nog aan:",
            "activeNotificationsTitle": "Actieve notificaties",
            "activeUsers": "actieve gebruikers",
            "addBtn": "+ Toevoegen",
            "addNewVat": "Nieuw BTW-nummer toevoegen",
            "addition": "Toevoeging",
            "address": "Adres",
            "allPrices": "Alle prijzen",
            "apply": "Toepassen",
            "applyCoupon": "Coupon toepassen",
            "applyCouponTitle": "Coupon toepassen",
            "applyDiscountBtn": "50% korting voor 6 maanden toepassen",
            "attention": "Let op,",
            "bluemateSubscription": "Bluemate - Abonnement",
            "cancel": "Annuleren",
            "cancelFailedMsg": "Het stoppen van het abonnement is niet gelukt.",
            "cancelFailedTitle": "Stopzetten mislukt",
            "cancelMessage1": "We vinden het jammer dat je je {{action}}.",
            "cancelMessage2": "Als je op de knop hieronder klikt, stopt het abonnement direct.",
            "cancelMessage3": "Je betaalt alleen nog voor het aantal orders dat we al hebben verwerkt tot nu.",
            "cancelMessage4Bold": "1 laatste incasso",
            "cancelMessage4Post": "verwachten voor de afgelopen maand.",
            "cancelMessage4Pre": "Je kunt dus nog",
            "cancelMessage5": "Graag hieronder met ons delen waarom je stopt. Het helpt ons altijd :)",
            "cancelSignature": "Groet Dave en Levi.",
            "cancelSubscriptionAction": "abonnement wilt stoppen",
            "cancelSubscriptionBtn": "Ik begrijp het, abonnement stoppen",
            "cancelSubscriptionTitle": "Abonnement stoppen",
            "changePaymentMethod": "Betaalwijze aanpassen",
            "choosePaymentMethod": "Welke betaalmethode wil je aan je account koppelen?",
            "city": "Stad",
            "close": "Sluiten",
            "companyName": "Bedrijfsnaam",
            "continue": "Doorgaan",
            "country": "Land",
            "coupon": "Coupon",
            "couponApplied": "De coupon is toegepast op jouw abonnement",
            "couponFailedMsg": "Het toepassen van de coupon is mislukt.",
            "couponFailedTitle": "Toepassen mislukt",
            "couponInfo": "Vul hieronder een coupon in om toe te passen op jouw abonnement.",
            "creditcard": "Creditcard",
            "crumbSettings": "Instellingen",
            "crumbSubscription": "Abonnement",
            "currentSubscription": "Huidig abonnement",
            "currentSubscriptionSub": "huidig abonnement",
            "customerDetailsDisclaimer": "Let op, deze gegevens worden enkel gebruikt voor de facturen die je van ons ontvangt. Deze gegevens worden niet gebruikt op de facturen die we naar jouw klanten sturen.",
            "deactivateFailedTitle": "Deactiveren mislukt",
            "deleteAccountAction": "account wilt verwijderen",
            "deleteAccountBtn": "Ik begrijp het, account verwijderen",
            "deleteAccountTitle": "Account verwijderen",
            "detailsUpdateFailedMsg": "Het bijwerken van de gegevens is niet gelukt.",
            "detailsUpdateFailedTitle": "Bijwerken mislukt",
            "detailsUpdated": "De gegevens zijn bijgewerkt",
            "disclaimer1": "Nooit teveel betalen.",
            "disclaimer2": "Prijs wordt maandelijks bepaald door het aantal orders.",
            "disclaimer3": "Prijzen excl. 21% BTW.",
            "discountAmount": "€{{amount}} korting",
            "discountApplied": "De korting is toegepast op jouw abonnement",
            "discountApplyFailedMsg": "Het toepassen van de korting is niet gelukt.",
            "discountApplyFailedTitle": "Korting toepassen mislukt",
            "discountOffer1": "Jammer dat je wilt vertrekken.",
            "discountOffer2": "Bluemate bewijst zich over de tijd.",
            "discountOffer3": "Kijk het nog even aan met 50% korting voor 6 maanden.",
            "discountOffer4": "Daarna kunnen we samen verder kijken.",
            "discountOfferTitle": "50% korting voor 6 maanden",
            "discountPercent": "{{discount}}% korting",
            "discountValidUntil": "Korting geldig tot {{date}}",
            "editDetails": "Gegevens wijzigen",
            "editSubscription": "Abonnement wijzigen",
            "email": "E-mailadres",
            "errFeedbackRequired": "Graag nog wat feedback achter laten over waarom je weggaat.",
            "extraAccounts": "{{count}} extra verkoop{{suffix}}",
            "failedTitle": "Mislukt",
            "feedbackPlaceholder": "Feedback hier altijd welkom :)",
            "ideal": "iDeal",
            "invoiceDetailsTitle": "Factuurgegevens",
            "invoiceEmail": "E-mail voor facturatie",
            "last30Days": "afgelopen 30 dagen",
            "loadFailedMsg": "Het laden van je abonnement is niet gelukt.",
            "loadFailedTitle": "Laden mislukt",
            "millions": "Miljoenen",
            "moduleInfo1": "Met de module Notificaties houd je 24/7 jouw producten in de gaten.",
            "moduleInfo2": "Vanwege de serverkosten, is er een kleine extra bijdrage.",
            "modulePriceInfo": "Totale prijs met alle verkoopaccounts inbegrepen.",
            "modulePro1": "Ontvang belangrijke meldingen direct in jouw inbox.",
            "modulePro2": "Bijvoorbeeld bij een koopblok verlies of een lage voorraad.",
            "modulePro3": "Zo ben je altijd up-to-date, zodat jij actie kunt ondernemen en geen omzet verlies.",
            "moreThan": "Meer dan",
            "mostPicked": "Meest gekozen",
            "noNewInvoiceMsg": "Er is nog geen nieuwe factuur gemaakt voor de mislukte betaling, neem contact met ons op om het abonnement te hervatten.",
            "notificationsActivateFailedMsg": "Het activeren van de Notificaties module is niet gelukt.",
            "notificationsActivated": "De Notificaties module is geactiveerd",
            "notificationsDeactivateFailedMsg": "Het deactiveren van de Notificaties module is niet gelukt.",
            "notificationsDeactivated": "De Notificaties module is gedeactiveerd",
            "notificationsDescription": "Krijg 24/7 een melding bij o.a. koopblok verlies en nieuwe reviews",
            "notificationsModule": "Notificaties module",
            "numOrders": "Aantal orders",
            "ok": "Oké",
            "openInvoiceTitle": "Openstaande factuur",
            "payOpenInvoice": "Openstaande factuur betalen",
            "paymentDisclaimer": "Betaling verloopt altijd middels een automatische incasso",
            "paymentMethodLabel": "Betaalmethode:",
            "perMonth": "per maand",
            "previousPeriods": "vorige periodes",
            "priceForOrders": "Prijs bij {{count}} orders per maand",
            "proMoreThan": "Meer dan {{count}} actieve gebruikers",
            "proPartner": "Officieel partner van bol",
            "proStars": "4.9 uit 5 sterren op Google",
            "proceedCancel": "Nee, ik wil toch opzeggen",
            "removeNotificationsHint": "Verwijder deze. Vervolgens is de Notificaties module te deactiveren.",
            "save": "Opslaan",
            "sepa": "SEPA",
            "showLess": "Toon minder",
            "showMore": "Toon meer",
            "sinceUntilToday": "Sinds {{date}} tot vandaag",
            "somethingWrong": "Er is iets mis gegaan.",
            "starsReviews": "uit 5 sterren op Google reviews",
            "start": "starten",
            "startSubscription": "Abonnement starten",
            "startSubscriptionAction": "Abonnement starten",
            "statusActive": "Actief",
            "statusInactive": "Inactief",
            "statusFailure": "Fout",
            "statusTrial": "Proefperiode",
            "statusCanceled": "Gestopt",
            "statusFree": "Gratis",
            "statusUnpaid": "Onbetaald",
            "statusTitle": "Status",
            "stop": "stopzetten",
            "streetNumber": "Straat + nummer",
            "subscriptionAction": "Abonnement {{action}}",
            "subscriptionCanceled": "Het abonnement is opgezegd",
            "successInvoices": "succesvolle facturen verstuurd!",
            "thanksFeedback": "Bedankt voor je feedback!",
            "thanksTitle": "Bedankt",
            "thisPeriod": "Deze periode",
            "trialUntilThenPaid": "Proef nog tot {{date}}, daarna betaald",
            "until": "tot {{date}}",
            "usageThisPeriod": "Verbruik deze periode",
            "vatAdded": "Het BTW-nummer is toegevoegd",
            "vatDeleteFailedMsg": "Het verwijderen van het BTW-nummer is niet gelukt.",
            "vatDeleteFailedTitle": "Verwijderen mislukt",
            "vatDeleted": "Het BTW-nummer is verwijderd",
            "vatInvalid": "Het BTW-nummer is niet geldig",
            "vatNumber": "BTW-nummer",
            "vatNumberFailed": "Het instellen van het BTW-nummer is niet gelukt",
            "vatNumberInfo": "Voor het starten van het abonnement hebben we jouw BTW-nummer nodig. Vul deze hieronder in om door te gaan.",
            "vatNumberRequired": "Vul het BTW-nummer in",
            "vatNumberSaved": "Het BTW-nummer is opgeslagen",
            "vatNumberTitle": "BTW-nummer instellen",
            "vatNumbers": "BTW-nummers",
            "vatPending": "BTW-nummer wordt gevalideerd",
            "vatUnavailable": "Het BTW-nummer kan niet gevalideerd worden",
            "vatVerified": "BTW-nummer gevalideerd",
            "verifiedPartner": "VERIFIED PARTNER",
            "viewInvoices": "Facturen bekijken",
            "zipCode": "Postcode"
        },
        "productsMoved": {
            "body": "Je vindt je productinstellingen (naam, BTW, kosten, QR-codes en zichtbaarheid) voortaan op de pagina Producten.",
            "button": "Ga naar Producten",
            "title": "Productinstellingen zijn verhuisd"
        },
        "subscriptionDemoBlocked": "Abonnement instellingen zijn niet beschikbaar in het demo account.",
        "tabs": {
            "accountUsers": "Gebruikers",
            "common": "Algemeen",
            "connection": "Koppeling Bol",
            "email": "E-mails",
            "export": "Exporteren",
            "invoices": "Factuurinstellingen",
            "password": "Beveiliging",
            "subscription": "Abonnement",
            "vat": "Producten & BTW"
        },
        "vat": {
            "addCustomFor": "Afwijken BTW tarief toevoegen voor:",
            "addDefaultFor": "Standaard BTW tarief toevoegen voor:",
            "applyChanges": "Wijzigingen toepassen",
            "cancel": "Annuleren",
            "changesSaved": "De wijzigingen zijn opgeslagen",
            "choose": "Kiezen...",
            "chooseCountry": "Kies een land",
            "crumbProducts": "Producten & BTW",
            "crumbSettings": "Instellingen",
            "customRate": "Aangepast tarief",
            "defaultsSaved": "De standaard BTW tarieven zijn opgeslagen",
            "editDefaults": "Standaard BTW tarieven instellen",
            "errMaxPercent": "Het percentage kan niet meer zijn dan 100%",
            "errNegativeAmount": "Het BTW bedrag kan niet negatief zijn",
            "errNegativePercent": "Het percentage kan niet negatief zijn",
            "noCustomRate": "Geen afwijken BTW tarief ingesteld. Gebruikt standaard tarief.",
            "noNewInvoicesOnly": "Nee, alleen voor nieuwe facturen",
            "productRetroactiveMsg": "Wil je de gewijzigde BTW percentages met terugwerkende kracht toepassen? Hiermee worden alle facturen met dit product bijgewerkt.",
            "retroactiveMsg": "Wil je de gewijzigde BTW percentages met terugwerkende kracht toepassen? Hiermee worden alle facturen waar de gewijzigde producten op staan bijgewerkt.",
            "save": "Opslaan",
            "saveDefaultsFailedMsg": "Het opslaan van de standaard BTW tarieven is niet gelukt.",
            "saveDefaultsFailedTitle": "Opslaan mislukt",
            "saveFailedMsg": "Het opslaan van de wijzigingen is niet gelukt.",
            "saveFailedTitle": "Opslaan mislukt",
            "setCustomRatesFor": "Afwijkende BTW tarieven instellen voor {{name}}",
            "useBolName": "Gebruik Bol naam",
            "vatAmountPerUnit": "BTW bedrag per stuk",
            "vatPercent": "BTW percentage",
            "yesRetroactive": "Ja, met terugwerkende kracht"
        }
    },
    "subscription": {
        "existingUser": {
            "address": "Adres",
            "addressPlaceholder": "Straatnaam + huisnummer",
            "cancel": "Annuleren",
            "city": "Plaats",
            "dataMessage": "Voor het starten van de proefperiode hebben we de volgende gegevens nodig:",
            "errors": {
                "address": "Vul het adres in",
                "city": "Vul de plaats in",
                "okay": "Oké",
                "startFailed": "Het starten van de proefperiode is niet gelukt.",
                "startFailedTitle": "Proefperiode starten mislukt",
                "zipCode": "Vul de postcode in"
            },
            "messageLine1": "Voor het toevoegen van een verkoopaccount heb je een eigen abonnement nodig.",
            "messageLine2": "Door verder te gaan starten we een gratis proefperiode van 30 dagen, deze loopt automatisch af.",
            "messageLine3": "Alleen als jij het wilt, wordt er daarna een abonnement gestart.",
            "messageLine4": "Je kunt de proefperiode te allen tijde stopzetten.",
            "startTrial": "Proefperiode starten",
            "title": "Abonnement vereist",
            "zipCode": "Postcode"
        },
        "ideal": {
            "confirm": {
                "error": "Het is niet gelukt de betaling te bevestigen.",
                "errorTitle": "Bevestigen mislukt",
                "waitingText": "De betaling wordt bevestigd, dit kan een aantal minuten duren."
            },
            "errors": {
                "email": "Vul het e-mailadres in",
                "emailInvalid": "Vul een geldig e-mailadres in",
                "name": "Vul de naam rekeninghouder in"
            },
            "form": {
                "accept": "Accepteren",
                "accountHolder": "Naam rekeninghouder *",
                "bank": "Bank *",
                "disclaimer": "Door ondertekening van dit formulier geeft u toestemming aan Bluemate B.V. en Stripe standaard Europese incasso-opdrachten te sturen naar uw bank om een bedrag van uw rekening af te schrijven en aan uw bank om een bedrag van uw rekening af te schrijven overeenkomstig deze opdracht. Als u het niet eens bent met deze afschrijving kunt u deze laten terugboeken. Een dergelijk verzoek moet binnen acht weken na de datum van afschrijving worden ingediend. Vraag uw bank naar de voorwaarden.",
                "email": "E-mailadres *",
                "explanation": "Er wordt ter bevestiging €0,01 van je rekening afgeschreven. Zodra je bankrekening bevestigd is wordt dit direct teruggestord.",
                "title": "Automatisch betalen met iDeal"
            },
            "setup": {
                "error": "Het instellen van iDeal is niet gelukt.",
                "errorTitle": "Instellen mislukt"
            }
        },
        "stats": {
            "active": "Actief",
            "canceled": "Opgezegd",
            "day": "Dag",
            "display": "Weergave",
            "errors": {
                "load": "Het laden van de statistieken is niet gelukt.",
                "loadTitle": "Laden mislukt"
            },
            "expired": "Proef verlopen",
            "free": "Gratis",
            "inactive": "Inactief",
            "month": "Maand",
            "page": "Pagina",
            "perDay": "Per dag",
            "perMonth": "Per maand",
            "perQuarter": "Per kwartaal",
            "perWeek": "Per week",
            "perYear": "Per jaar",
            "quarter": "Kwartaal",
            "title": "Abonnementstatussen",
            "trial": "Proefperiode",
            "week": "Week",
            "year": "Jaar"
        }
    },
    "survey": {
        "choices": {
            "majorityWins": "De meeste stemmen gelden.",
            "maxTwo": "Maximaal twee keuzes",
            "title": "Welke feature(s) zou je willen zien in Bluemate?",
            "want": "Ja, dit wil ik"
        },
        "close": "Sluiten",
        "confirmation": {
            "line1": "We gaan het bekijken.",
            "line3": "Ontwikkelen is veel werk, en we zijn met z'n tweeën, dus verwacht niet te snel resultaat :)",
            "line4": "Samen op naar een nog mooier product!",
            "signoff": "Groeten, Davey & Levi",
            "title": "Bedankt voor jouw antwoord!"
        },
        "diffValue": {
            "label": "Anders..."
        },
        "feature": "Feature",
        "header": {
            "choices": "Features",
            "intro": "Vraag",
            "thanks": "Bedankt!",
            "values": "Waarde"
        },
        "intro": {
            "greeting": "Groeten van Dave en Levi, team Bluemate.",
            "subtitle": "Stem op welke feature(s) we nu gaan maken!",
            "title": "Hey! - Wat zullen we nu bouwen? 🛠️",
            "vote": "Ja, ik stem mee!"
        },
        "notNow": "Nu even niet",
        "questions": {
            "advertisingCosts": {
                "description": "De kosten en resultaten van je Bol sponsored products nu ook in het sales dashboard.",
                "title": "Kosten Bol Advertising in het Sales Dashboard"
            },
            "diff": {
                "title": "Anders namelijk..."
            },
            "hijack": {
                "description": "Krijg een melding zodra de titel, tekst of afbeeldingen van een door jou aangeboden product door iemand is gewijzigd.",
                "title": "Product hijack notificatie"
            },
            "notifications": {
                "description": "Ontvang notificaties per SMS of e-mail bij bijvoorbeeld een lage voorraad, verlies van het koopblok of een negatieve review.",
                "title": "Notificaties"
            },
            "prodResearch": {
                "description": "Bekijk alle producten op Bol en zie hoeveel omzet (inschatting) deze maken.",
                "title": "Product Research Tool"
            },
            "productListGen": {
                "description": "Ga je een nieuw product verkopen? Geef een korte omschrijving en krijg een SEO geoptimaliseerde product titel en beschrijving gemaakt met AI.",
                "title": "Product listing AI generator"
            },
            "profitCalc": {
                "description": "Wat houd je eigenlijk onderaan de streep over? Bereken je winst en marge na het invullen van al je kosten voor een nieuw product.",
                "title": "Winst calculator"
            },
            "searchTermRanking": {
                "description": "Bekijk hoe hoog jouw producten terugkomen in de zoekresultaten van Bol voor de belangrijkste zoekwoorden inclusief ontwikkeling over tijd.",
                "title": "Zoekresultaten ranking"
            },
            "stock": {
                "description": "Krijg een melding wanneer er nieuwe voorraad ingekocht moet worden per product aan de hand van jouw levertijden en geplande sales forecast.",
                "title": "Vooraad inkoop notificatie"
            }
        },
        "saveFailed": "Opslaan mislukt",
        "saveFailedMessage": "Het opslaan van je keuze is niet gelukt.",
        "values": {
            "back": "Terug",
            "comment": "Overige feedback",
            "commentPlaceholder": "Nog overige suggesties te delen? Je kunt ze hier achterlaten.",
            "submit": "Antwoord indienen",
            "title": "Hoe blij ben je met deze features?"
        }
    },
    "systemMessage": {
        "apiExpiry": {
            "prefix": "De koppeling met jouw Bol account",
            "renew": "Nu vernieuwen",
            "suffix": "Om te voorkomen dat bestellingen niet meer verwerkt worden, verzoeken we je om de koppeling te vernieuwen."
        },
        "close": "Sluiten",
        "dismissDialog": {
            "body1": "Je kunt de waarschuwing voor het verlopen van deze koppeling uitschakelen. We zullen voor deze koppeling dan geen melding meer tonen. Je zult nog wel automatische e-mails ontvangen over het verlopen van jouw koppeling.",
            "body2": "Weet je zeker dat je deze melding niet meer wilt tonen voor deze koppeling?"
        },
        "expired": "is verlopen",
        "expiresInDays": "verloopt over {{days}} dagen",
        "hideNotification": "Melding verbergen",
        "no": "Nee",
        "notificationHidden": "De melding wordt niet meer getoond",
        "yes": "Ja"
    },
    "tracking": {
        "close": "Sluiten",
        "decideLater": "Later beslissen",
        "detailedExplanation": "uitgebreide uitleg",
        "emailStats": "E-mail statistieken",
        "info": {
            "keywords": "onderweg, verstuurd, verzonden, shipped, is geleverd, factuur, bevestiging, track & trace, track and trace, nieuwsbrief, wil je ons helpen, bedankt, thank, dankjewel, dankuwel, pakbon, wat vindt u van, levering, ingepakt, bezorgd, ingepland, aangemeld, afgeleverd, verzending, ontvangen, nota, invoice, pending, planned, received",
            "noteLabel": "Let op:",
            "noteText": "bij het gebruik van bepaalde kernwoorden in het onderwerp van de mail zal de e-mail ongeacht je keuze door het \"noreply\" adres van Bol verzonden worden. Bol geeft aan dat het om de volgende kernwoorden gaat:",
            "paragraph1": "In april 2022 heeft Bol een update in zijn e-mailsysteem doorgevoerd waardoor externe links (alle links die niet direct naar Bol leiden) als tekst worden toegevoegd in de mail. Bol geeft aan dit uit veiligheidsoverwegingen te hebben gedaan, omdat klanten hierdoor kunnen zien waar ze heen gestuurd worden voordat ze op een link / knop klikken.",
            "paragraph2": "Door deze update werd de layout van de e-mails die via ons platform werden verzonden mogelijk verstoord, hierdoor hebben wij onze statistieken van de e-mails tijdelijk uitgeschakeld.",
            "paragraph3": "Inmiddels hebben we in gesprek met Bol een oplossing gevonden waarmee wij weer statistieken van de e-mails kunnen tonen. Met deze oplossing worden de e-mails verzonden door een \"noreply\" adres, waardoor het platform van Bol de mail anders verwerkt en niet de links als tekst in de mails plaatst. De klant zal de mail ontvangen van het adres noreply@verkopen.bol.com Het gevolg hiervan is dat de klant niet meer zal kunnen reageren op de e-mail, omdat deze van het \"noreply\" adres van Bol komt."
        },
        "mainBody": "De e-mails kunnen worden verzonden door een \"noreply\" adres waardoor de e-mails bij Bol door een ander mailsysteem verwerkt worden. Onze links zullen dan niet als tekst worden toegevoegd aan de e-mail. Het gevolg hiervan is dat klanten niet meer de mail zullen kunnen beantwoorden.",
        "mainIntroPrefix": "Door een update in de mailsystemen van Bol (",
        "mainIntroSuffix": ") hebben wij tijdelijk onze statistieken van de mails uit moeten schakelen. Inmiddels hebben we samen met Bol een oplossing gevonden waarmee wij de statistieken weer kunnen verzamelen:",
        "mainQuestion": "Wil je gebruik maken van de \"noreply\" afzender of wil je je eigen afzender gebruiken?",
        "saveFailed": "Opslaan mislukt",
        "saveFailedMessage": "Het opslaan van je keuze is niet gelukt.",
        "saved": "Je keuze is opgeslagen",
        "useNoreply": "Noreply afzender gebruiken",
        "useOwn": "Eigen afzender gebruiken"
    },
    "trialEnd": {
        "afterPayment": "Na betaling kun je de pagina herladen en pakt het systeem het automatisch weer op!",
        "checkPriceResume": "Check je prijs, koppel een betaalmethode en hervat je gebruik.",
        "continueWithBluemate": "Doorgaan met Bluemate",
        "debitFailedFor": "De automatische incasso voor",
        "emailsPaused": "Er worden tijdelijk geen mails naar je klanten verzonden en geen facturen geüpload.",
        "failed": "is mislukt.",
        "featureUnavailable": "Deze feature is niet beschikbaar zonder abonnement.",
        "generateInvoiceFailed": "Het genereren van een nieuwe factuur is niet gelukt.",
        "generateNewInvoice": "Via onderstaande knop kan je een nieuwe factuur laten genereren.",
        "goToSettings": "Ga naar instellingen",
        "goToSettingsToStart": "Ga naar de instellingen om je abonnement te starten.",
        "invoiceFailed": "Factuur mislukt",
        "newInvoiceCreated": "We hebben een nieuwe factuur gemaakt,",
        "noProblem": "Geen probleem, kan gebeuren :)",
        "paused": "Abonnement is gepauzeerd",
        "periodPrefix": "de periode",
        "periodSeparator": "t/m",
        "periodSuffix": "van je abonnement",
        "premiumFeature": "Premium Feature",
        "redirectedToPayment": "Je wordt automatisch doorgestuurd naar de betaalpagina.",
        "resumeSubscription": "Abonnement hervatten",
        "subscriptionEnded": "Je abonnement is afgelopen.",
        "viewAndPay": "deze kun je via onderstaande knop inzien en betalen.",
        "viewAndPayInvoice": "Factuur inzien en betalen",
        "yourSubscription": "je abonnement"
    },
    "twoFactor": {
        "enable": {
            "enabledSnackbar": "Tweestapsverificatie is ingeschakeld",
            "generateFailedMessage": "Het genereren van je persoonlijke code is niet gelukt.",
            "generateFailedTitle": "Code genereren mislukt",
            "okButton": "Oké",
            "validateFailedMessage": "Het valideren van de code is niet gelukt.",
            "validateFailedTitle": "Validatie mislukt"
        },
        "reset": {
            "failedMessage": "Het uitschakelen van de tweestapsverificatie is mislukt.",
            "failedTitle": "Uitschakelen mislukt",
            "okButton": "Oké",
            "successMessage": "De tweestapsverificatie is succesvol uitgeschakeld, je kunt nu inloggen met jouw e-mailadres en wachtwoord.",
            "successTitle": "Tweestapsverificatie uitgeschakeld"
        }
    },
    "util": {
        "access": {
            "rights": {
                "accountUsers": "Gebruikersbeheer",
                "apiTab": "Koppeling Bol tab",
                "archiveRequests": "Aanvragen archiveren",
                "bolConnection": "Koppeling Bol",
                "bulkDownload": "Bulk downloaden",
                "bulkUploadPercentages": "Bulk percentages uploaden",
                "cancelEmails": "Mails annuleren",
                "copyEmail": "E-mail kopiëren van ander account",
                "createCreditInvoice": "Creditfactuur aanmaken",
                "createExport": "Export maken",
                "credit": "Crediteren",
                "dashboardPage": "Home pagina",
                "deleteAccount": "Account verwijderen",
                "deleteNotifications": "Notificaties verwijderen",
                "disconnectApi": "Koppeling verbreken",
                "downloadExport": "Export downloaden",
                "downloadExports": "Exports downloaden",
                "downloadInvoiceSpec": "Factuurspecificaties downloaden",
                "downloadPreview": "Downloaden/Voorbeeld",
                "editAutoEmail": "Automatisch mailen wijzigen",
                "editCompany": "Bedrijfsgegevens wijzigen",
                "editCustomer": "Klantgegevens wijzigen",
                "editEmails": "E-mails wijzigen",
                "editItems": "Factuurregels wijzigen",
                "editNotifications": "Notificaties wijzigen",
                "editProductTitle": "Productnaam wijzigen",
                "editSettings": "Instellingen wijzigen",
                "editUsers": "Gebruikers wijzigen",
                "editVat": "BTW% wijzigen",
                "emails": "E-mails",
                "emailsPage": "E-mails pagina",
                "emailsTab": "E-mails tab",
                "export": "Exporteren",
                "exportCalculation": "Berekening exporteren",
                "exportInvoices": "Facturen exporteren",
                "exportTab": "Exporteren tab",
                "feedTab": "Feed tab",
                "general": "Algemeen",
                "inviteUsers": "Gebruikers toevoegen",
                "invoiceRequests": "Aanvragen",
                "invoiceRequestsPage": "Aanvragen pagina",
                "invoiceSettings": "Factuurinstellingen",
                "invoiceSettingsTab": "Factuurinstellingen tab",
                "invoices": "Facturen",
                "layoutPage": "Layout pagina",
                "notificationsPage": "Notificaties pagina",
                "ordersPage": "Orders pagina",
                "searchRankingsPage": "Search Rankings pagina",
                "productsPage": "Producten pagina",
                "productsTab": "Producten tab",
                "productsVat": "Producten (BTW)",
                "productsVatTab": "Producten (BTW) tab",
                "requestSettings": "Aanvragen instellingen",
                "returns": "Retouren",
                "returnsPage": "Retouren pagina",
                "reverseCharge": "BTW verleggen",
                "reviewAnalyticsPage": "Review Inzicht pagina",
                "salesDashboardPage": "Sales Dashboard pagina",
                "searchTermsPage": "Zoek Trends pagina",
                "send": "Verzenden",
                "sendCreditInvoice": "Creditfactuur verzenden",
                "sendTestMail": "Testmail verzenden",
                "setInvoiceNumber": "Factuurnummer instellen",
                "setProductCosts": "Productkosten instellen",
                "settingsPage": "Instellingen pagina",
                "settingsTab": "Instellingen tab",
                "setupApi": "Koppeling instellen",
                "showInBol": "Weergeven in Bol",
                "subscriptionTab": "Abonnement tab",
                "syncBol": "Sync met bol",
                "uploadInvoices": "Facturen uploaden",
                "users": "Gebruikers",
                "vatDeclarationPage": "BTW Aangifte pagina",
                "viewDetails": "Details inzien",
                "viewOrderStats": "Order statistieken inzien",
                "viewReviews": "Reviews inzien",
                "viewStats": "Statistieken inzien"
            },
            "role": {
                "accountant": "Boekhouder",
                "admin": "Administrator",
                "customerService": "Klantenservice",
                "employee": "Medewerker",
                "owner": "Eigenaar"
            },
            "tab": {
                "emails": "E-mails",
                "notifications": "Notificaties",
                "orders": "Orders",
                "pageAccess": "Toegang tot pagina's",
                "reviewAnalytics": "Review Inzicht",
                "salesDashboard": "Sales Dashboard",
                "settings": "Instellingen",
                "vatDeclaration": "BTW Aangifte"
            }
        },
        "bolValidation": {
            "duplicateMail": "Er wordt al een andere e-mail naar deze klanten verzonden. Stuur maximaal 1 mail per 1 order.",
            "duplicateMailGeneral": "Er worden meerdere e-mails naar dezelfde klanten verzonden, volgens het beleid van Bol mag iedere klant maar één e-mail ontvangen. Het kan zijn dat Bol deze e-mails blokkeert en je loopt het risico op beleidspuntenaftrek.",
            "invoiceAttachment": "Deze e-mail bevat niet de factuur als bijlage.",
            "invoiceAttachmentGeneral": "Eén of meer e-mails bevat niet de factuur als bijlage, volgens het beleid van Bol moet de factuur als bijlage meegezonden worden. Het kan zijn dat Bol deze e-mails blokkeert en je loopt het risico op beleidspuntenaftrek.",
            "overlap": "Deze e-mail heeft overlap met e-mail '{{step2}}'. Stuur maximaal 1 mail per 1 order",
            "prefixedError": "{{step}}: {{error}}"
        },
        "component": {
            "validationErrors": "Validatiefouten"
        },
        "dashboard": {
            "cancelEmails": "Mails annuleren",
            "connectedWithBol": "Gekoppeld met Bol",
            "copyId": "ID kopiëren",
            "credit": "Crediteren...",
            "creditInvoice": "Creditfactuur",
            "creditInvoiceDetails": "Creditfactuur details",
            "daysCount_one": "{{count}} dag",
            "daysCount_other": "{{count}} dagen",
            "details": "Details",
            "download": "Downloaden",
            "edit": "Wijzigen...",
            "noBolConnection": "Geen verbinding met Bol",
            "preview": "Voorbeeld",
            "reverseCharge": "BTW verleggen...",
            "sendInvoice": "Factuur verzenden...",
            "sendPeppol": "Verzenden via Peppol",
            "setInvoiceNumber": "Factuurnummer instellen...",
            "statusCredited": "Gecrediteerd",
            "statusDownloaded": "Gedownload",
            "statusEdited": "Gewijzigd",
            "statusInvoiceSent": "Factuur verzonden",
            "statusMailSendIn": "E-mail wordt over {{days}} verzonden",
            "statusMailSendToday": "E-mail wordt vandaag verzonden",
            "statusNoInvoiceNumber": "Zonder factuurnummer",
            "statusOrderCanceled": "Bestelling geannuleerd",
            "statusOrderNotSent": "Bestelling nog niet verzonden",
            "statusOrderSent": "Bestelling verzonden",
            "statusOpenReturn": "Open Retour",
            "statusOpenReturnTooltip": "Retour aangemeld bij bol. Zodra geaccepteerd/gewijzigd, wordt hier automatisch bijgewerkt. Indien auto crediteren aan (zie Instellingen), wordt credit gemaakt.",
            "statusReturned": "Retour",
            "statusReturnedTooltip": "Deze order is geaccepteerd als retour. Indien er een creditfactuur is gemaakt, vind deze in een aparte regel in deze lijst.",
            "statusReviewRequestSent": "Reviewverzoek verzonden",
            "statusSent": "Verzonden",
            "statusVatReversed": "BTW verlegd",
            "statusWillSend": "Wordt verzonden",
            "uploadInvoice": "Factuur uploaden"
        },
        "emailStep": {
            "allCountries": "Alle landen",
            "allProducts": "Alle producten",
            "attachmentCreditInvoice": "Creditfactuur.pdf",
            "attachmentInvoice": "Factuur.pdf",
            "attachmentsCount": "{{count}} bijlages",
            "chooseProducts": "Kies product(en)",
            "chooseTemplate": "Kies template",
            "countriesCount": "{{count}} landen",
            "custom": "Aangepast",
            "customerAll": "Alle klanten",
            "customerBusiness": "Zakelijke klanten",
            "customerPrivate": "Particuliere klanten",
            "day": "dag",
            "days": "dagen",
            "flow": {
                "invoice": {
                    "description": "Een mail met de BTW factuur als bijlage",
                    "title": "Factuur mail"
                },
                "other": {
                    "description": "Stel zelf een ander soort mail samen.",
                    "title": "Andere mail"
                },
                "product": {
                    "description": "Verstuur een mail alleen bij bepaalde bestelde producten. Bijvoorbeeld een product handleiding mail met bijlage.",
                    "title": "Productniveau mail"
                },
                "review": {
                    "description": "Vraag om een productreview op Bol.",
                    "title": "Review mail"
                },
                "reviewInvoice": {
                    "description": "Vraag om een productbeoordeling inclusief link en voeg de factuur toe als bijlage.",
                    "title": "Review + Factuur mail (aanbevolen)"
                }
            },
            "logisticsAll": "Alle logistiek",
            "logisticsLvb": "LVB",
            "logisticsOwn": "Eigen logistiek",
            "nDaysAfterShipment": "{{amount}} {{days}} na zending",
            "none": "Geen",
            "orderReceived": "Order ontvangen",
            "orderSent": "Order verzonden",
            "productsCount_one": "{{count}} product",
            "productsCount_other": "{{count}} producten",
            "remainingProducts": "Resterende producten",
            "remainingProductsCount_one": "Resterende {{count}} product",
            "remainingProductsCount_other": "Resterende {{count}} producten",
            "reviewInvoiceTooltip": "Voor beste conversie, verzend je Review + Factuur mail minimaal 7 dagen na zending. Dan heeft je klant de bestelling waarschijnlijk ontvangen en kunnen testen.",
            "selectedProducts": "Geselecteerde producten",
            "title": {
                "creditInvoice": "MAIL MET CREDITFACTUUR",
                "invoice": "FACTUUR MAIL",
                "other": "ANDERE MAIL",
                "product": "PRODUCT MAIL",
                "review": "REVIEW MAIL",
                "reviewInvoice": "REVIEW + FACTUUR MAIL"
            },
            "workDay": "werkdag",
            "workDays": "werkdagen"
        },
        "pdf": {
            "noBolConnection": "geen Bol koppeling",
            "notSet": "niet ingesteld",
            "var": {
                "amountsExclVat": "Bedragen excl. BTW",
                "deliveryAddress": "Afleveradres",
                "deliveryCity": "Afleverstad",
                "deliveryCountry": "Afleverland",
                "deliveryExtra": "Afleveradres toevoeging",
                "deliveryZip": "Afleverpostcode",
                "firstName": "Voornaam",
                "lastName": "Achternaam",
                "orderDate": "Orderdatum",
                "orderId": "Ordernummer"
            }
        },
        "return": {
            "credit": "Crediteren",
            "creditInvoice": "Creditfactuur",
            "details": "Details",
            "originalInvoice": "Originele factuur",
            "sendCreditInvoice": "Creditfactuur verzenden",
            "showInBol": "Weergeven in Bol"
        },
        "salesDashboard": {
            "allCountries": "Alle landen",
            "col": {
                "avgCommission": "Gemiddelde commissie",
                "avgPrice": "Verkoopprijs bol",
                "avgPriceIncl": "Verkoopprijs bol incl. BTW",
                "commission": "Totale commissie",
                "commissionPercentage": "Commissie %",
                "costs": "Productkosten",
                "margin": "Marge %",
                "name": "Naam",
                "numOrders": "Aantal orders",
                "profit": "Winst",
                "profitPerProduct": "Winst per product",
                "quantity": "Aantal verkocht",
                "returnedQuantity": "Aantal retour",
                "revenue": "Omzet",
                "revenueIncl": "Omzet incl. BTW",
                "vatPercentage": "BTW percentage"
            },
            "group": {
                "costs": "Kosten",
                "profit": "Winst",
                "returns": "Retouren",
                "revenue": "Omzet"
            },
            "info": {
                "avgPrice": "Gemiddelde prijs van alle orders van dit product",
                "avgPriceIncl": "Gemiddelde prijs van alle orders van dit product, inclusief BTW",
                "marginNeedsCost": "De winstmarge kan pas berekend worden als de kostprijs ingevuld is.",
                "profitNeedsCost": "De winst kan pas berekend worden als de kostprijs ingevuld is."
            },
            "setVat": "BTW instellen"
        },
        "subscription": {
            "somethingWentWrong": "Er is iets misgegeaan",
            "status": {
                "active": "Actief",
                "canceled": "Gestopt",
                "free": "Gratis",
                "inactive": "Inactief",
                "trial": "Proefperiode",
                "unknown": "Onbekend"
            }
        },
        "update": {
            "addUsersTitle": "Gebruikers toevoegen",
            "autoReturnsCreditsTitle": "Automatische retouren en creditfacturen",
            "bolApiUpgradeTitle": "Bol API upgrade",
            "bolPolicyPointsTitle": "Beleidspunten Bol",
            "bolSearchTrendsTitle": "Bol zoektrends",
            "buyBoxLossTitle": "Wil jij ook een alert bij koopblok verlies?",
            "combineSalesTitle": "Sales combineren",
            "deleteSalesAccountTitle": "Verkoopaccount verwijderen",
            "emailCountrySelectionTitle": "E-mail landselectie",
            "emailProductSelectionTitle": "E-mail productselectie",
            "emailStatsTitle": "E-mail statistieken",
            "emailsRemainingProductsTitle": "E-mails voor resterende producten",
            "financialDashboardTitle": "Financieel Dashboard",
            "globalSearchVatImportTitle": "Globaal zoeken & BTW importeren",
            "improvedEmailEditorTitle": "Verbeterde e-mail template editor",
            "lowStockTitle": "Wil jij ook een alert bij lage voorraad?",
            "multipleAccountsTitle": "Meerdere accounts koppelen",
            "newOrdersLine1": "Nieuw: ontvang nu een e-mail wanneer je nieuwe orders heb ontvangen.",
            "newOrdersLine2": "Onze robots kunnen nu jouw orders 24/7 in de gaten houden.",
            "newOrdersTitle": "Wil jij ook een alert bij nieuwe orders?",
            "oldOrderRequestsTitle": "Factuuraanvragen voor oude orders",
            "optimizationsExpansionTitle": "Optimalisaties & uitbreiding functionaliteiten",
            "reviewAnalyticsRenewedTitle": "Review Inzicht - vernieuwd!",
            "reviewNotificationsTitle": "Review Notificaties!",
            "salesDashboardImprovementsTitle": "Verbeteringen Sales Dashboard",
            "searchVolumesRenewedTitle": "Zoekvolumes vernieuwd",
            "uploadRulesTitle": "Uploadregels",
            "vatOptionsGeneralTitle": "BTW opties & Algemene verbeteringen",
            "wantThis": "Wil jij dit ook?",
            "yesAddNotification": "Ja, notificatie toevoegen"
        },
        "utils": {
            "subscriptionInactive": "Jouw abonnement is niet actief. Activeer jouw abonnement om deze functie te gebruiken.",
            "tryAgainLater": "Probeer het later opnieuw of neem contact met ons op."
        }
    },
    "vat": {
        "custom": {
            "invalidPercentage": "Vul een geldig percentage in",
            "label": "Aangepast tarief",
            "ok": "Oké"
        },
        "split": {
            "addRate": "tarief toevoegen",
            "amountPerUnitLabel": "BTW bedrag per stuk",
            "apply": "Toepassen",
            "cancel": "Annuleren",
            "choose": "Kiezen...",
            "disclaimer": "Het gebruik van samengestelde BTW is op eigen risico.",
            "disclaimerInfo": "Wij ontvangen van Bol geen informatie over BTW tarieven en kunnen daarom geen automatische berekeningen en wijzigingen toepassen op samengestelde BTW bedragen. Bij prijswijzigingen dienen de samengestelde BTW bedragen handmatig aangepast te worden.",
            "explanationPart1": "Samengestelde BTW wordt toegepast wanneer 1 product uit meerdere artikelen bestaat, waarbij voor ieder artikel een ander BTW tarief geldt. Uiteraard gelden hier regels voor, meer informatie hierover is terug te vinden bij",
            "explanationPart2": "Omdat wij van Bol geen informatie ontvangen over de samenstelling van de producten en BTW tarieven, kunnen wij niet automatisch samengestelde BTW tarieven toepassen. Het is daarom mogelijk om handmatig de BTW bedragen (per stuk) in te stellen, deze worden dan gebruikt voor de bepaling van de totale BTW.",
            "explanationPart3": "Omdat dit geen automatisch proces is, dienen de BTW bedragen handmatig bijgewerkt te worden wanneer de prijs bij Bol wijzigt. Het gebruik van samengestelde BTW is dan ook op eigen risico.",
            "percentageLabel": "BTW percentage",
            "taxAuthority": "de Belastingdienst",
            "title": "Samengestelde BTW",
            "validateMinimum": "Kies minimaal 2 BTW tarieven om samengestelde BTW in te stellen.",
            "whatIs": "Wat is samengestelde BTW?"
        },
        "type": {
            "margin": "Marge",
            "split": "Samengest.",
            "splitFull": "Samengesteld",
            "reversed": "Verlegd",
            "kor": "KOR",
            "default": "Standaard",
            "custom": "Aangepast..."
        }
    },
    "vatDeclaration": {
        "banner": {
            "body": "Bereken in één klik je btw bedragen over je bol verkopen. Let op: laat controleren door jouw boekhouder.",
            "title": "BTW-aangifte"
        },
        "bolInvoicesTitle": "Gebruikte facturen & specificaties van Bol",
        "box": {
            "calculating": "Wordt berekend...",
            "costsExcl": "Kosten excl. BTW",
            "costsIncl": "Kosten incl. BTW",
            "noData": "Geen beschikbare data gevonden",
            "preTax": "Voorbelasting",
            "revenueExcl": "Omzet excl. BTW",
            "revenueIncl": "Omzet incl. BTW",
            "reversedIncl": "Omzet met verlegde BTW",
            "tax": "Af te dragen BTW"
        },
        "canLeaveWindow": "Je kunt dit venster verlaten en later terugkomen.",
        "choosePeriod": "Kies een periode",
        "continueDefaultVat": "Doorgaan met standaard BTW tarief",
        "crumb": "Hulp bij BTW aangifte",
        "downloadExcelTitle": "Download Excel specificatie",
        "downloadPdfTitle": "Download PDF factuur",
        "downloads": "Downloads",
        "error": {
            "calculateFailed": "Het berekenen van de BTW aangifte is niet gelukt.",
            "calculateFailedTitle": "Berekenen mislukt",
            "downloadFailedTitle": "Downloaden mislukt",
            "downloadFileFailed": "Het downloaden van het bestand is niet gelukt.",
            "downloadInvoiceFailed": "Het downloaden van de factuur is niet gelukt.",
            "exportFailed": "Er is iets misgegaan bij het exporteren van de berekening.",
            "exportFailedTitle": "Exporteren mislukt",
            "notificationFailed": "Het instellen van de notificatie is niet gelukt.",
            "notificationFailedTitle": "Instellen mislukt",
            "somethingWrong": "Er is iets misgegaan",
            "systemError": "Er is iets misgegaan in ons systeem."
        },
        "export": {
            "action": "ACTIE",
            "button": "Berekening exporteren",
            "csv": "CSV bestand",
            "dialogMessage": "Je kunt de berekening exporteren naar een csv bestand of een Excel bestand. Welk bestandstype wil je gebruiken?",
            "dialogTitle": "Berekening exporteren",
            "download": "Downloaden",
            "error": "Fout",
            "excel": "Excel bestand",
            "exporting": "Bezig met exporteren...",
            "fileType": "BESTANDSTYPE",
            "noneExported": "- nog geen berekeningen geëxporteerd -",
            "title": "BTW berekening exporteren"
        },
        "firstUse": {
            "attention": "Let op het volgende:",
            "bullet1": "- Deze tool is enkel bedoeld als een hulpmiddel.",
            "bullet2": "- Wij kunnen geen garanties geven over de compleetheid en correctheid.",
            "bullet3": "- Deze tool dient niet ter vervanging van een boekhouder.",
            "bullet4": "- Wij kunnen verder geen ondersteuning bieden bij het opmaken van belastingaangiftes.",
            "calc1": "Wij maken deze berekening door de Excel specificaties van de verkoopfacturen van jouw Bol account te downloaden en te verwerken.",
            "calc2": "In deze specificaties ontbreekt het BTW percentage van jouw producten, daarom nemen wij het in Bluemate ingestelde BTW percentages van jouw producten over.",
            "calc3": "Zorg dus dat de BTW percentages van producten correct in Bluemate zijn ingesteld.",
            "calc4": "Indien aanwezig, nemen wij ook de via Bluemate handmatig verlegde BTW van facturen over.",
            "calc5": "Vervolgens tellen wij de bedragen bij elkaar op tot de totalen, en geven deze per categorie weer.",
            "confirm": "Ja, ik begrijp het",
            "intro1": "De BTW aangifte tool helpt bij het berekenen van de BTW bedragen van jouw Bol verkopen.",
            "intro2": "Je kan deze cijfers inzien over een bepaalde periode (bijvoorbeeld over een kwartaal of jaar), per land én per omzetgroep.",
            "intro3": "Handig als hulp voor bij jouw BTW aangiftes!",
            "title": "Welkom bij de BTW aangifte hulp!"
        },
        "generalInfo": "We berekenen deze cijfers aan de hand van jouw maandelijkse factuurspecificaties van Bol. Deze vullen wij nog aan met de BTW percentages van jouw producten, zoals ingesteld in Bluemate en met eventuele verlegd BTW via Bluemate. Zorg dus dat de BTW percentages van producten in Bluemate goed zijn ingesteld.",
        "invalidatedWarning": "Sinds de laatste berekening van de BTW aangifte zijn de {{type}} instellingen gewijzigd. Hierdoor moet de berekening mogelijk opnieuw gedaan worden.",
        "invoiceHeader": {
            "info": "Download hier de originele Bol facturen (PDF) of factuurspecificaties (Excel).",
            "invoiceNumber": "FACTUURNUMMER",
            "period": "PERIODE"
        },
        "lastOrderInfo": "Voor deze berekening gebruiken we dezelfde factuurspecificaties van bol in Excel die jij ook ontvangt. We vullen deze aan met de BTW-gegevens van Bluemate. De data die we hebben opgehaald bevat orders tot en met {{lastOrderString}}. Dit kan twee dingen betekenen:",
        "lastOrderOption1": "als dit de laatste order van de maand was.",
        "lastOrderOption1Bold": "Jouw berekening is nu compleet",
        "lastOrderOption2": "als er na {{lastOrderString}} nog orders waren. In dat geval komt rond {{availableFromString}} een nieuwe Excel-sheet beschikbaar bij bol. Voer deze berekening vanaf {{availableFromString}} opnieuw uit.",
        "lastOrderOption2Bold": "Jouw berekening is nu nog niet compleet",
        "lastOrderTitle": "Data van bol ontvangen tot {{lastOrderString}} – Volledige gegevens waarschijnlijk beschikbaar vanaf {{availableFromString}}",
        "list": {
            "amountExcl": "Bedrag excl. BTW",
            "category": "Categorie",
            "costsAtBol": "Gemaakte kosten bij Bol",
            "revenueAtBol": "Omzet bij Bol",
            "total": "Totaal",
            "vatAmount": "BTW bedrag"
        },
        "mailDisabled": "Je krijgt geen mail meer zodra de berekening voltooid is",
        "mailEnabled": "Je krijgt een mail zodra de berekening voltooid is",
        "mailNotify": "Stuur mij een mail zodra de berekening voltooid is",
        "newProductsBody": "Ons systeem heeft tijdens de berekening van de BTW aangifte {{missingProducts}} nieuwe producten gevonden die we nog niet eerder hebben gezien. Dit zijn waarschijnlijk producten van die periode destijds, die je nu niet meer actief verkoopt. Deze producten hebben we toegevoegd in Instellingen > Producten (BTW).",
        "newProductsDefault": "Voor deze producten wordt momenteel het standaard BTW tarief per land (Nederland {{dutchVat}}%, België {{beVat}}%) gehanteerd.",
        "newProductsQuestion": "Wil je andere BTW tarieven instellen of wil je doorgaan met het standaard BTW tarief?",
        "newProductsRateUnknown": "Van deze producten weten we het BTW tarief nog niet.",
        "newProductsTitle": "Nieuwe producten gevonden!",
        "period": {
            "custom": "Aangepast...",
            "months": "Maanden",
            "quarters": "Kwartalen",
            "years": "Jaren"
        },
        "preTaxInfo": "De voorbelasting is de BTW die je zelf hebt betaald over de gemaakte kosten bij Bol. Deze BTW krijg je van de Belastingdienst terug via de BTW-aangifte.",
        "processingPeriod": "Bezig met het verwerken van periode {{periodLabel}}",
        "recalculate": "Opnieuw berekenen",
        "recalculateNow": "Nu opnieuw berekenen",
        "reverseDisclaimer": "Voor verkooppartners buiten Nederland wordt de BTW van de kosten door Bol verlegd. In de factuurspecificatie van Bol wordt dit niet duidelijk aangegeven, hierdoor kunnen wij de BTW bedragen van de kosten (voorbelasting) niet goed berekenen. Wij raden aan een boekhouder/accountant te raadplegen voor het doen van je BTW-aangifte.",
        "reversedInfo": "Als je bestellingen van buitenlandse zakelijke klanten ontvangt, dan kan het zijn dat je de BTW hebt verlegd naar de klant. Tijdens de BTW aangifte moet je de omzet opgeven waarvan de BTW verlegd is.",
        "setOtherVat": "Ander BTW tarief instellen",
        "statusLabel": "Status:",
        "taxInfo": "De af te dragen BTW is de BTW die je ontvangen hebt van jouw klanten. Deze BTW draag je af aan de Belastingdienst via de BTW-aangifte.",
        "totals": "Totalen",
        "until": "t/m",
        "vatLabel": "BTW",
        "vatReversed": "BTW verlegd"
    },
    "apiConnectionBanner": {
        "button": "Nu Bol koppeling vernieuwen",
        "explanation": "Na inloggen bij bol, koppel ons met \"retailer\" én \"adverteerder\" zodat wij alle data hebben.",
        "title": "Nieuwe API koppeling vereist"
    },
    "noData": "Geen data",
    "week": "Week",
    "month": "Maand",
    "category": "Categorie",
    "categories": "Categorieën",
    "close": "Sluit",
    "graph": "Grafiek",
    "all": "Alle",
    "mobileApp": {
        "crumb": "Mobiele app",
        "eyebrow": "Mobiele app",
        "safariChip": "Alleen via Safari op iPhone of iPad",
        "stepWord": "Stap",
        "title": "Bluemate als app op je telefoon",
        "intro": "Installeer Bluemate als app op je telefoon. Als geïnstalleerde app start Bluemate sneller en ontvang je push-meldingen over koopblok-wissels, lage voorraad en nieuwe reviews. Kies hieronder je toestel voor de stappen.",
        "alreadyInstalled": "Je gebruikt Bluemate nu als geïnstalleerde app. De stappen hieronder zijn alleen nog ter naslag — bijvoorbeeld om Bluemate ook op een ander toestel te installeren.",
        "ios": {
            "title": "Installeren op iPhone of iPad",
            "step1": "Tik in Safari onderaan het scherm op het deel-icoon (een vierkantje met een pijl omhoog).",
            "step2": "Scroll omlaag en kies 'Zet op beginscherm' (Add to Home Screen).",
            "step3": "Bevestig met 'Voeg toe' (Add). Bluemate verschijnt daarna als app-icoon op je beginscherm.",
            "shotAlt": "Bluemate installatiestap"
        },
        "platformApple": "iPhone / iPad",
        "platformAndroid": "Android",
        "android": {
            "title": "Installeren op Android",
            "browsersNote": "Chrome, Brave, Edge en andere Chromium-browsers",
            "step1": "Open Bluemate in een browser op basis van Chromium, zoals Chrome, Brave of Edge.",
            "step2": "Tik in de banner 'Bluemate als app installeren' bovenaan op 'Installeren'. Bluemate verschijnt daarna als app op je startscherm.",
            "step3": "Volg de banner hieronder om Bluemate te installeren:",
            "shotAlt": "Bluemate installatiestap op Android",
            "shortcutWarningTitle": "Kies \"Installeren\", niet \"Snelkoppeling maken\"",
            "shortcutWarning": "Biedt je browser de keuze tussen installeren en een snelkoppeling maken? Kies dan altijd 'Installeren' (of 'App installeren'). Een snelkoppeling is alleen een bladwijzer naar de website: die krijgt het browser-icoon in plaats van het Bluemate-icoon, opent in een browsertab en kan géén push-meldingen ontvangen. Het zekerst is de knop 'Installeer' in de banner hierboven — die installeert altijd de echte app.",
            "shortcutFix": "Al per ongeluk een snelkoppeling gemaakt? Verwijder die van je startscherm en installeer opnieuw via de knop hierboven.",
            "optionWord": "Optie",
            "bannerOptionTitle": "Met één tik, via de banner",
            "bannerOptionIntro": "De snelste weg: je browser opent de installatiedialoog meteen.",
            "bannerOptionFallback": "Zie je de banner niet? Je browser biedt de knop niet altijd aan. Gebruik dan optie 2 hieronder — die werkt altijd.",
            "menuOptionTitle": "Via het menu van je browser",
            "menuOptionIntro": "Werkt altijd, ook als de banner er niet staat. Let wel goed op de laatste stap.",
            "menuStep1": "Tik rechtsboven in Chrome op het menu met de drie puntjes (⋮).",
            "menuStep2": "Kies 'App installeren'. Heet het bij jou 'Installeren en snelkoppeling maken' of 'Toevoegen aan startscherm'? Dat is dezelfde ingang.",
            "menuStep3": "Krijg je de keuze, kies dan 'Installeren' en bevestig — niet 'Snelkoppeling maken'. Bluemate verschijnt met het eigen icoon op je startscherm."
        }
    },
    "pwa": {
        "install": "Installeer",
        "installBluemateTitle": "Installeer Bluemate als app",
        "installBluemate": "Voeg Bluemate toe aan je bureaublad of startscherm. Als geïnstalleerde app start Bluemate sneller en kun je push-meldingen ontvangen over koopblok-wissels, lage voorraad en nieuwe reviews. Tik of klik op 'Installeer' om de installatiedialoog van je browser te openen.",
        "openInSafari": "Open in Safari",
        "openInChrome": "In Chrome openen",
        "iosInstallTitle": "Installeer Bluemate op je iPhone of iPad",
        "iosInstallHint": "Als geïnstalleerde app start Bluemate sneller en kun je push-meldingen ontvangen over koopblok-wissels, lage voorraad en nieuwe reviews. Bekijk de installatiegids voor de stappen.",
        "iosInstallGuide": "Installatiegids",
        "iosNonSafariInstallHint": "Bluemate kan op iOS alleen via Safari op het beginscherm worden geïnstalleerd. Tik op de knop hieronder om deze pagina in Safari te openen en de installatie te starten.",
        "androidIncompatibleInstallTitle": "Installeer Bluemate op je Android-toestel",
        "androidIncompatibleInstallHint": "Je huidige browser ondersteunt geen één-klik installatie van Bluemate als app. Tik op de knop hieronder om Bluemate te openen in Google Chrome — daar kun je de app met één tik installeren. Heb je Chrome nog niet? Dan opent de Play Store om Chrome te installeren.",
        "macSafariInstallTitle": "Installeer Bluemate op je Mac",
        "macSafariInstallHint": "Als geïnstalleerde app opent Bluemate in een eigen venster zonder adresbalk. Zo installeer je de app in Safari:\n1. Klik in de adresbalk op het deel-icoon (vierkantje met pijl omhoog).\n2. Kies 'Voeg toe aan Dock'.\n3. Bluemate verschijnt in je Dock — start hem daarvandaan zoals elke andere Mac-app. Vereist macOS Sonoma (14) of nieuwer.",
        "firefoxDesktopInstallTitle": "Bluemate installeren in Firefox voor desktop",
        "firefoxDesktopInstallHint": "Bluemate kan als app worden geïnstalleerd — het start sneller en ontvangt push-meldingen. Firefox voor desktop heeft echter geen ingebouwde installatieknop voor web-apps. Je hebt twee opties:\n1. Open deze pagina in Chrome, Edge of Safari om Bluemate met één klik te installeren (aanbevolen).\n2. Of maak een handmatige snelkoppeling naar deze pagina op je bureaublad via je besturingssysteem.",
        "unsupportedBrowserTitle": "Browser wordt niet volledig ondersteund",
        "unsupportedBrowserHint": "Je huidige browser ondersteunt geen moderne web-app functies. Hierdoor werken push-meldingen en de installatie als app niet. Open Bluemate in een recente versie van Chrome, Edge, Safari of Firefox voor de volledige ervaring — al deze browsers zijn gratis beschikbaar.",
        "offlineDismiss": "Toch doorgaan",
        "offlineMessage": "Controleer je internetverbinding en probeer het opnieuw.",
        "offlineReconnected": "Verbinding hersteld",
        "offlineRetry": "Opnieuw proberen",
        "offlineStillNoConnection": "Nog steeds geen verbinding",
        "offlineTitle": "Geen verbinding",
        "updatedToast": "Bluemate is bijgewerkt naar de nieuwste versie.",
        "connectionBlocked": "Verbinding geblokkeerd na netwerkwissel. Sluit de app volledig en open hem opnieuw.",
        "actionError": "Er ging iets mis. Probeer het opnieuw.",
        "androidManualInstallTitle": "Installeer Bluemate op je Android-toestel",
        "androidManualInstallHint": "Als geïnstalleerde app start Bluemate sneller en kun je push-meldingen ontvangen over koopblok-wissels, lage voorraad en nieuwe reviews. Tik hieronder op 'Installatiegids' voor de stappen.",
        "androidInstallGuide": "Installatiegids"
    },
    "push": {
        "adminOnlyBadge": "Alleen zichtbaar voor admin!",
        "cancel": "Annuleren",
        "deniedHelp": {
            "gotIt": "Begrepen",
            "intro": "Meldingen zijn geblokkeerd in je browser- of systeeminstellingen. Zo zet je ze weer aan:",
            "ios1": "Open de app Instellingen op je iPhone of iPad.",
            "ios2": "Ga naar 'Meldingen' en zoek 'Bluemate' in de lijst.",
            "ios3": "Zet 'Sta meldingen toe' aan, kom terug en vink dit apparaat opnieuw aan bij een notificatie.",
            "android1": "Tik op het slot-icoon (of ⋮ → Site-informatie) naast de adresbalk bovenaan.",
            "android2": "Open 'Machtigingen' → 'Meldingen'.",
            "android3": "Zet het op 'Toestaan' (of 'Rechten resetten'), kom terug en vink dit apparaat opnieuw aan bij een notificatie.",
            "androidPwa1": "Houd het Bluemate-icoon op je beginscherm ingedrukt → 'App-info' (of open Android-instellingen → 'Apps' → 'Bluemate').",
            "androidPwa2": "Tik op 'Meldingen'.",
            "androidPwa3": "Zet meldingen aan, kom terug in de app en vink dit apparaat opnieuw aan bij een notificatie.",
            "desktop1": "Klik op het slot-icoon links van de adresbalk.",
            "desktop2": "Zet 'Meldingen' op 'Toestaan', vernieuw de pagina en vink dit apparaat opnieuw aan bij een notificatie.",
            "alreadyOnMobile": "Staan meldingen daar al aan? Zet ze dan één keer UIT en weer AAN in de systeeminstellingen, open de app opnieuw en vink dit apparaat opnieuw aan.",
            "alreadyOnDesktop": "Staat het al op 'Toestaan'? Zet meldingen dan één keer UIT en weer AAN — in je browserinstellingen én in de systeeminstellingen van je computer — vernieuw daarna de pagina."
        },
        "deviceAdded": "Toegevoegd:",
        "deviceComputer": "Computer",
        "deviceLastSeen": "Laatst gezien:",
        "devicePhone": "Mobiel apparaat",
        "deviceTablet": "Tablet",
        "devices": "Apparaten",
        "devicesNone": "Geen apparaten geregistreerd",
        "editName": "Naam wijzigen",
        "editNameHint": "Geef dit apparaat een herkenbare naam",
        "emailReceivesCount_one": "Ontvangt {{count}} notificatie",
        "emailReceivesCount_other": "Ontvangt {{count}} notificaties",
        "emailRecipients": "E-mailadressen",
        "emailRecipientsNone": "Geen e-mailadressen geconfigureerd",
        "emailRedirected": "(Wordt omgeleid)",
        "error": "Er ging iets mis, probeer het opnieuw",
        "errors": {
            "unsupported": "Je browser ondersteunt geen push-meldingen.",
            "missing-vapid": "Push-meldingen zijn niet geconfigureerd op deze omgeving. Neem contact op met support.",
            "missing-keys": "Er ontbreken versleutelingssleutels. Probeer het opnieuw of herstart je browser.",
            "empty-subscription": "De browser gaf een lege pushregistratie terug. Probeer het opnieuw of herstart je browser.",
            "install-required": "Installeer Bluemate eerst als app om meldingen te ontvangen.",
            "sw-not-ready": "Service worker is nog niet klaar. Herlaad de pagina en probeer het opnieuw.",
            "enable-failed": "Het inschakelen van meldingen is mislukt. Probeer het opnieuw.",
            "disable-failed": "Het uitschakelen van meldingen is mislukt. Probeer het opnieuw.",
            "register-failed": "Registreren van het apparaat bij de server is mislukt. Probeer het opnieuw.",
            "no-user": "Je bent niet ingelogd of er is geen verkoopaccount geselecteerd.",
            "deviceLimit": "Maximaal aantal apparaten bereikt. Verwijder er eerst een.",
            "unexpected": "Er is iets misgegaan met pushmeldingen. Probeer het later opnieuw."
        },
        "firstRun": {
            "title": "Meldingen op deze telefoon",
            "body": "Wil je pushmeldingen ontvangen op deze telefoon?",
            "yes": "Ja",
            "settingsHint": "Je kunt pushmeldingen later altijd nog inschakelen via je meldingsinstellingen.",
            "later": "Misschien later"
        },
        "formFactorComputer": "Computer",
        "formFactorPhone": "Telefoon",
        "formFactorTablet": "Tablet",
        "healthWarn": "Meldingen ingeschakeld, maar een controle faalde — ze komen mogelijk niet aan.",
        "insecureContext": "Push-meldingen werken alleen via een beveiligde (versleutelde) https-verbinding. Via een gewone http-verbinding kan Bluemate meldingen niet correct inschakelen.",
        "installFirst": "Meldingen zijn alleen beschikbaar in de Bluemate-app",
        "installedApp": "geïnstalleerde app",
        "loading": "Laden...",
        "logoutDevice": "Apparaat uitloggen",
        "logoutDeviceConfirm": "Weet je zeker dat je dit apparaat wilt uitloggen?",
        "logoutDeviceDone": "Apparaat is uitgelogd",
        "mismatch": {
            "title": "Andere gebruiker",
            "adminBody": "Deze pushmelding is bedoeld voor een andere gebruiker. Wisselen?",
            "adminSwitchBtn": "Wisselen",
            "userBody": "Deze pushmelding is bedoeld voor een ander account. Wil je uitloggen om in te loggen op het juiste account?",
            "userLogoutBtn": "Uitloggen",
            "switchFailed": "Wisselen naar de andere gebruiker is niet gelukt."
        },
        "namePlaceholder": "Bijv. MacBook werk",
        "notGranted": "Meldingen niet ingeschakeld: geen toestemming gegeven.",
        "openSecure": "Open Bluemate via https in een nieuw venster",
        "refresh": "Status en apparaten vernieuwen",
        "save": "Opslaan",
        "suppressedHelp": {
            "title": "Meldingen inschakelen",
            "androidIntro": "Je browser toont de meldingsvraag niet opnieuw nadat deze is weggeklikt. Zo zet je meldingen alsnog aan:",
            "iosIntro": "De meldingsvraag wordt niet opnieuw getoond nadat deze is weggeklikt. Zo zet je meldingen alsnog aan:",
            "desktopIntro": "Je browser toont de meldingsvraag niet opnieuw nadat deze is weggeklikt. Zo zet je meldingen alsnog aan:"
        },
        "suppressedHint": "We tonen de meldingsvraag niet opnieuw. Tik hier om te zien hoe je meldingen inschakelt.",
        "testErrors": {
            "rate_limit": "Te veel verzoeken. Probeer het later opnieuw.",
            "no_devices": "Geen actieve web push apparaten geregistreerd voor deze gebruiker.",
            "all_failed": "Alle actieve apparaten zijn mislukt. Schakel push opnieuw in op dit apparaat.",
            "not_found": "Dit apparaat is niet meer geregistreerd.",
            "not_configured": "Dit adres wordt door geen enkele notificatie gebruikt.",
            "mail_failed": "Het versturen van de test-e-mail is mislukt. Probeer het opnieuw."
        },
        "testMailSent": "Test-e-mail naar dit adres verzonden",
        "testSendDevice": "Testmelding naar dit apparaat sturen",
        "testSendMail": "Test-e-mail naar dit adres sturen",
        "testSent": "Testmelding is verzonden",
        "testSentDevice": "Testmelding naar dit apparaat verzonden",
        "thisComputer": "Deze computer",
        "thisDevice": "(dit apparaat)",
        "thisPhone": "Deze telefoon",
        "thisTablet": "Deze tablet",
        "title": "Overzicht push-abonnementen",
        "unknownDevice": "Onbekend apparaat",
        "unsupported": "Je browser ondersteunt geen push-meldingen."
    },
    "overview": {
        "accounts": {
            "all": "Alle winkels samen",
            "count_one": "{{count}} winkel",
            "count_other": "{{count}} winkels",
            "emptyBody": "Kies hierboven minimaal één winkel om je cijfers te zien.",
            "emptyTitle": "Geen winkel geselecteerd",
            "none": "Geen winkel geselecteerd"
        },
        "adRevenue": {
            "badgeTooltip_one": "{{count}} verkocht via ads",
            "badgeTooltip_other": "{{count}} verkocht via ads",
            "costs": "Kosten",
            "empty": "Geen advertentieverkopen in deze periode",
            "salesShare": "{{share}} van alle verkopen",
            "stat": "Ad omzet"
        },
        "buyBox": {
            "anonymous": "Anoniem",
            "competitor": "Concurrent",
            "empty": "Geen wisselingen in deze periode",
            "lost": "Koopblok verloren",
            "won": "Koopblok gewonnen",
            "yourPrice": "Jouw prijs"
        },
        "comparison": {
            "dayBefore": "Dag ervoor",
            "monthBefore": "Maand ervoor",
            "periodBefore": "Periode ervoor",
            "weekBefore": "Week ervoor"
        },
        "kpi": {
            "adSpend": "Ad spend",
            "adsRevenue": "Omzet via ads",
            "error": "De statistieken konden niet geladen worden",
            "mailsSent": "Mails verstuurd",
            "margin": "Winstmarge",
            "orders": "Aantal orders",
            "organicRevenue": "Omzet organisch",
            "profit": "Winst",
            "returnRate": "Retour %",
            "returns": "Retouren",
            "revenue": "Omzet",
            "revenueExclVat": "Omzet (excl. btw)",
            "reviewClicks": "Review kliks",
            "reviews": "Nieuwe reviews",
            "shareOfTotal": "% van totale omzet",
            "uploads": "Facturen geüpload"
        },
        "loadMore": "Meer laden",
        "lowStock": {
            "badge_one": "{{count}} stuk op voorraad",
            "badge_other": "{{count}} stuks op voorraad",
            "empty": "Geen producten met lage voorraad"
        },
        "period": {
            "month": "Maand",
            "week": "Week",
            "yesterday": "Gisteren"
        },
        "returns": {
            "badgeTooltip": "Retour",
            "empty": "Geen retouren in deze periode",
            "quantity_one": "{{count}} stuk retour",
            "quantity_other": "{{count}} stuks retour"
        },
        "reviews": {
            "empty": "Geen nieuwe reviews in deze periode"
        },
        "sectionError": "Deze sectie kon niet geladen worden",
        "sections": {
            "adRevenue": "Gekocht via ads",
            "buyBox": "Wisseling koopblok",
            "lowStock": "Lage voorraad",
            "returns": "Retouren",
            "reviews": "Nieuwste reviews",
            "topProducts": "Meest verkochte producten"
        },
        "stat": {
            "profit": "Winst",
            "revenue": "Omzet"
        },
        "topProducts": {
            "empty": "Nog geen verkopen in deze periode",
            "soldTooltip_one": "{{count}} verkocht",
            "soldTooltip_other": "{{count}} verkocht"
        },
        "welcome": "Welkom terug! 👋",
        "welcomeNamed": "Welkom terug, {{name}}! 👋",
        "welcomeSubtitle": "Hieronder het overzicht van je verkopen en prestaties"
    },
    "edit": "Aanpassen",
    "exportError": "Er is iets misgegaan bij het exporteren.",
    "profitInfo": "De winst wordt enkel berekend met producten waarvoor de kosten zijn ingesteld."
}
